// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/avatr/AVATRFont-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/avatr/AVATRFont-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/avatr/AVATRFont-Bold.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --av-font: "AVATRFont", "Inter", -apple-system, "Helvetica Neue", Arial, sans-serif;
  --av-black: #181818;
  --av-white: #FFFFFF;
  --av-gray-1: #464646;
  --av-gray-2: #747474;
  --av-gray-3: #A3A3A3;
  --av-gray-4: #D1D1D1;
  --av-warm-ivory: #FCEDE0;
  --av-cyber-lime: #B4D719;
  --av-light-green-1: #ECF5B9;
  --av-light-green-2: #D9EC74;
  --av-dark-green-1: #3A534E;
  --av-dark-green-2: #1E2F2B;
  --av-select-outline: #E7E7E7;
  --av-bg: var(--av-black);
  --av-glass: rgba(24, 24, 24, 0.72);
  --av-glass-strong: rgba(24, 24, 24, 0.9);
  --av-blur: blur(20px) saturate(140%);
  --av-line: var(--av-gray-1);
  --av-line-strong: var(--av-white);
  --av-hover: rgba(255, 255, 255, 0.08);
  --av-text: var(--av-white);
  --av-text-2: var(--av-gray-4);
  --av-text-3: var(--av-gray-3);
  --av-ink: var(--av-black);
  --av-accent: var(--av-cyber-lime);
  --av-radius: 4px;
  --av-radius-lg: 8px;
  --av-ease: cubic-bezier(.42, 0, 0, 1);
  --av-tracking: 0.14em;
  --av-safe: 5rem;
  --av-sb-left: 1.25rem;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: 0;
}

::-webkit-scrollbar {
  height: 4px;
  width: 4px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 1rem;
}

html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  overflow: hidden;
  overflow: clip;
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
}

#root {
  position: relative;
  width: 100%;
  height: 100%;
}

body {
  font-family: var(--av-font) !important;
  font-weight: 300;
  color: var(--av-text);
  background: var(--av-bg);
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.full-app-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: var(--av-bg);
}

.container-app {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.av-btn-primary {
  position: relative;
  height: 40px !important;
  min-width: 112px;
  padding: 0 20px;
  box-sizing: border-box;
  background: var(--av-white) !important;
  border: none !important;
  border-radius: var(--av-radius) !important;
  cursor: pointer;
  box-shadow: 0 12px 20px -12px rgba(180, 215, 25, 0);
  transition: transform 0.2s linear, box-shadow 0.3s linear;
}
.av-btn-primary > * {
  color: var(--av-ink) !important;
  font-size: 14px !important;
  line-height: 22px !important;
  font-weight: 400;
}
.av-btn-primary:hover {
  transform: translate3d(0, -2px, 0);
  box-shadow: 0 14px 22px -10px rgba(180, 215, 25, 0.85);
}

@font-face {
  font-family: "AVATRFont";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
}
@font-face {
  font-family: "AVATRFont";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
}
@font-face {
  font-family: "AVATRFont";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
}
.bottombar-full-container {
  position: absolute;
  bottom: 0.625rem;
  left: 50%;
  transform: translateX(-50%);
  width: 22.5rem;
  max-width: calc(100% - 1.25rem);
  padding-top: 0.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  opacity: 1;
  background: var(--av-glass);
  backdrop-filter: var(--av-blur);
  -webkit-backdrop-filter: var(--av-blur);
  border: 1px solid var(--av-line);
  border-radius: var(--av-radius-lg);
  transition: opacity 0.8s ease-in-out, bottom 0.8s var(--av-ease);
}

.bottombar-full-container.hidden {
  bottom: -8rem;
}

.bottombar-full-container.hiddenhigh {
  bottom: -13rem;
}

.bottombar-collapse-btn {
  width: 2rem;
  height: 2rem;
  background: var(--av-glass-strong);
  border: 1px solid var(--av-line);
  border-radius: var(--av-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  cursor: pointer;
  position: absolute;
  top: -1rem;
  right: 1rem;
}
.bottombar-collapse-btn img {
  width: 1rem;
  height: 1rem;
  object-fit: contain;
  transform: rotate(-90deg);
  transition: transform 0.8s var(--av-ease);
}

.bottombar-collapse-btn.collapsed img {
  transform: rotate(90deg);
}

.bottombar-menu-title {
  color: var(--av-text);
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 300;
  margin-top: 0.75rem;
}

.bottombar-menu-container {
  width: 100%;
  height: auto;
  margin-top: 0.75rem;
}

.bottombar-menu-view {
  width: 100%;
  height: 2.75rem;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bottombar-view-content {
  height: 100%;
  width: calc(100% - 2rem);
  margin: 0 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.bottombar-view-logo {
  width: auto;
  height: 0.6875rem;
  object-fit: contain;
}

.bottombar-view-options {
  display: flex;
  gap: 4px;
  padding: 4px;
  border: 1px solid var(--av-line);
  border-radius: var(--av-radius);
}

.bottombar-view-button-container {
  width: 5.5rem;
  height: 30px;
  cursor: pointer;
}

.bottombar-view-button {
  width: 100%;
  height: 100%;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s var(--av-ease);
}

.bottombar-view-button.selected {
  background: var(--av-text);
}

.bottombar-view-text {
  color: var(--av-text-2);
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-weight: 400;
}

.bottombar-view-text.selected {
  color: var(--av-ink);
}

.bottombar-menu-color {
  width: 100%;
  min-height: 2.75rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}

.bottombar-color-selection {
  display: flex;
  gap: 12px;
  flex-direction: row;
  justify-content: center;
}

.bottombar-color-element {
  position: relative;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.bottombar-color-element::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background-color: #E5E5E5;
  opacity: 0;
  transform: scale(0.8);
  transition: opacity 0.3s linear, transform 0.3s var(--av-ease);
}

.bottombar-color-element.selected::before {
  opacity: 1;
  transform: scale(1);
}

.bottombar-color-img {
  position: relative;
  z-index: 1;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  object-fit: contain;
}

.bottombar-color-text {
  animation: av-color-name 0.3s linear;
  width: 100%;
  color: var(--av-text-2);
  font-size: 0.75rem;
  line-height: 1.125rem;
  text-align: center;
}

.bottombar-scenario {
  width: 100%;
  min-height: 2.75rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.bottombar-scenario-title {
  display: none;
}

.bottombar-scenario-selection {
  display: flex;
  gap: 4px;
  padding: 4px;
  width: calc(100% - 2rem);
  box-sizing: border-box;
  border: 1px solid var(--av-line);
  border-radius: var(--av-radius);
}

.bottombar-scenario-subcontainer {
  flex: 1 1;
  min-width: 0;
  height: 30px;
  cursor: pointer;
}

.bottombar-scenario-element {
  width: 100%;
  height: 100%;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s var(--av-ease);
}

.bottombar-scenario-element.selected {
  background: var(--av-text);
}

.bottombar-scenario-text {
  color: var(--av-text-2);
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-weight: 400;
}

.bottombar-scenario-text.selected {
  color: var(--av-ink);
}

.bottombar-menu-options {
  width: 100%;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bottombar-options-content {
  display: flex;
  width: 90%;
  gap: 0.5rem;
  justify-content: center;
}

.bottombar-options-button {
  width: 45%;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: var(--av-radius);
  border: 1px solid var(--av-line-strong);
}

.bottombar-options-text {
  color: var(--av-text);
  font-size: 0.875rem;
  line-height: 1.375rem;
}

.bottombar-main-container {
  width: 100%;
  height: auto;
  margin: 0.75rem 0;
  padding: 0 0.5rem;
  box-sizing: border-box;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
}
.bottombar-main-container::-webkit-scrollbar {
  display: none;
}

.bottombar-main-container-scroll {
  min-width: 100%;
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
}

.bottombar-main-button {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 3.25rem;
  padding: 6px 2px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.375rem;
  border-radius: var(--av-radius);
  border: 1px solid transparent;
  cursor: pointer;
  transition: background 0.3s var(--av-ease), border-color 0.3s var(--av-ease);
}

.bottombar-main-button:hover {
  background: var(--av-hover);
}

.bottombar-main-button.selected {
  background: rgba(255, 255, 255, 0.1);
  border-color: var(--av-line-strong);
}

.bottombar-main-button-logo {
  height: 1rem;
  width: 1.25rem;
  object-fit: contain;
}

.bottombar-main-button-text {
  color: var(--av-text-2);
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-weight: 400;
  letter-spacing: 0.02em;
  white-space: normal;
  text-align: center;
}

.bottombar-main-button.selected .bottombar-main-button-text {
  color: var(--av-text);
}

.bottombar-menu-seat {
  width: 100%;
  height: 8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
}

.bottombar-menu-seat.enabled {
  pointer-events: auto;
}

.bottombar-seat-subcontainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bottombar-seat-title {
  color: var(--av-text-3);
  font-size: 0.75rem;
  line-height: 1.125rem;
  letter-spacing: var(--av-tracking);
  text-transform: uppercase;
}

.bottombar-seat-icon-container {
  width: 100%;
  height: calc(90% - 1rem);
  display: flex;
  margin: 0.5rem 0;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.bottombar-seat-icon-row {
  width: 100%;
  height: 45%;
  display: flex;
  justify-content: center;
}

.bottombar-seat-seat-icon {
  height: calc(100% - 0.2rem);
  aspect-ratio: 1;
  border: 1px solid var(--av-line-strong);
  border-radius: var(--av-radius);
  margin: 0.125rem;
  cursor: pointer;
}

.bottombar-seat-seat-icon.selected {
  background: var(--av-text);
}

@keyframes moveToRigth {
  0% {
    left: -17.5%;
  }
  100% {
    left: 2rem;
  }
}
@keyframes move {
  0% {
    left: 7%;
    transform: rotate(-10deg);
  }
  50% {
    left: 70%;
    transform: rotate(25deg);
  }
  100% {
    left: 7%;
    transform: rotate(-10deg);
  }
}
@keyframes moveDown {
  0% {
    top: -5.7rem;
  }
  100% {
    top: 1.7rem;
  }
}
@keyframes moveTop {
  0% {
    bottom: -8rem;
  }
  100% {
    bottom: 1%;
  }
}
@keyframes moveDownMobile {
  0% {
    top: -4rem;
  }
  100% {
    top: 6rem;
  }
}
@keyframes moveDownMobile4k {
  0% {
    top: -4rem;
  }
  100% {
    top: 2rem;
  }
}
@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes breath {
  0% {
    width: 1rem;
    height: 1rem;
  }
  50% {
    width: 1.2rem;
    height: 1.2rem;
  }
  100% {
    width: 1rem;
    height: 1rem;
  }
}
.bullet-full-container {
  display: flex;
  position: absolute;
  width: 100%;
  height: calc(100% - 3.75rem);
  justify-content: center;
  align-items: center;
  flex-direction: row;
  pointer-events: none;
  opacity: 1;
  transition: opacity 0.8s ease-in-out;
}

.bullet-full-container.hide {
  opacity: 0;
}

.bullet-sidebar-container {
  position: absolute;
  display: flex;
  height: 100%;
  width: 38rem;
  max-width: 90%;
  flex-direction: column;
  justify-content: center;
}

.bullet-sidebar-container.portrait {
  width: 21rem;
}

.bullet-container {
  position: absolute;
  display: flex;
  width: 100%;
  height: auto;
  flex-direction: column;
  justify-content: center;
}

.bullet-container.portrait {
  height: 100%;
}

.bullet-container.hide {
  pointer-events: none;
}

.bullet-container-content {
  position: relative;
  width: calc(100% - 2.5rem);
  height: 15.625rem;
  max-height: 60%;
  padding: 1.25rem;
  border-radius: var(--av-radius-lg);
  background: var(--av-glass-strong);
  backdrop-filter: var(--av-blur);
  -webkit-backdrop-filter: var(--av-blur);
  border: 1px solid var(--av-line);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  flex-direction: row;
  pointer-events: auto;
}

.bullet-container-content.hide {
  pointer-events: none;
}

.bullet-container-content.portrait {
  position: absolute;
  height: 8.5rem;
  padding: 0.875rem;
}

.bullet-container-img {
  width: 48%;
  border-radius: var(--av-radius);
  object-fit: cover;
  margin-right: 1.5rem;
}

.bullet-container-img.portrait {
  margin-right: 0.875rem;
}

.bullet-container-data {
  width: -webkit-fill-available;
  display: flex;
  flex-direction: column;
  padding-right: 2.25rem;
  overflow-y: auto;
  overflow-x: hidden;
}

.bullet-container-data.portrait {
  padding-right: 1.75rem;
}

.bullet-container-title {
  color: var(--av-text);
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 400;
  text-align: start;
  margin-top: 0.25rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--av-line);
}

.bullet-container-title.portrait {
  font-size: 0.875rem;
  line-height: 1.375rem;
  margin-top: 0;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
}

.bullet-container-desc {
  color: var(--av-text-2);
  font-size: 0.875rem;
  line-height: 1.375rem;
  font-weight: 300;
  text-align: start;
}

.bullet-container-desc.portrait {
  font-size: 0.75rem;
  line-height: 1.125rem;
}

.bullet-container-banner-button {
  position: absolute;
  top: 0.875rem;
  right: 0.875rem;
  width: 2.25rem;
  height: 2.25rem;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.3s var(--av-ease);
}

.bullet-container-banner-button:hover {
  transform: rotate(90deg);
}

.bullet-container-banner-button.portrait {
  top: 0.5rem;
  right: 0.5rem;
  width: 1.75rem;
  height: 1.75rem;
}

.carselection-full-container {
  position: absolute;
  width: 15rem;
  max-width: 85%;
  height: calc(100% - 3.75rem);
  right: 0px;
  background: #F4F7FE;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  transition: opacity 0.8s ease-in-out, right 0.8s ease-in-out;
  z-index: 1;
}

.carselection-full-container.hide {
  right: -15rem;
  opacity: 0;
  pointer-events: none;
}

.carselection-full-container.portrait {
  width: 11.875rem;
  height: calc(100% - 2.5rem);
}

.carselection-full-container.in3dcontainer {
  width: 11.875rem;
  height: 100%;
}

.carselection-close-bg {
  position: absolute;
  width: 2.5rem;
  height: 2.5rem;
  top: calc(50% - 1.25rem);
  left: calc(0% - 1.25rem);
  display: flex;
  justify-content: center;
  align-items: center;
  background: #F4F7FE;
  border-radius: 100%;
}

.carselection-close-bg.portrait {
  width: 2.5rem;
}

.carselection-close-button {
  width: 80%;
  height: 80%;
  background: #FFF;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.carselection-close-icon {
  width: 50%;
  height: 50%;
  margin: auto;
}

.carselection-title {
  margin: 2.5rem 1.164rem 0rem 1.164rem;
  font-family: var(--av-font);
  font-weight: 500;
  font-size: 1.125rem;
  color: #00095B;
  text-align: center;
}

.carselection-title.portrait {
  font-size: 0.85rem;
  margin: 1.25rem 1.677rem 0rem 1.677rem;
}

.carselection-list {
  width: calc(100% - 0.25rem - 0.25rem);
  margin: 0rem 1.164rem 0rem 1.364rem;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.carselection-category {
  width: calc(100% - 0.914rem - 0.914rem);
  height: auto;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1.2rem;
  margin-bottom: 0.24rem;
}

.carselection-category-text {
  margin-bottom: 0.06125rem;
  font-family: var(--av-font);
  font-weight: 400;
  font-size: 0.75rem;
  color: #84848E;
}

.carselection-car {
  width: 100%;
  height: auto;
  cursor: pointer;
}

.carselection-car.disabled {
  pointer-events: none;
  cursor: unset;
}

.carselection-car-image {
  width: 100%;
  height: 3.98125rem;
  margin-top: 0.66375rem;
  border-radius: 0.625rem 0.625rem 0rem 0rem;
  border: 1px solid #D3D3D3;
  background: #D3D3D3;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.carselection-car-image.portrait {
  height: 3.75rem;
}

.carselection-car-image.disabled {
  filter: grayscale(1);
}

.carselection-car-desc {
  width: 100%;
  height: 3.98125rem;
  border-radius: 0rem 0rem 0.625rem 0.625rem;
  border: 1px solid #D3D3D3;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carselection-car-desc.portrait {
  height: 3.5rem;
}

.carselection-car-desc-text {
  width: 80%;
  font-family: var(--av-font);
  font-weight: 500;
  font-size: 0.9rem;
  color: #00095B;
  text-align: center;
}

.carselection-car-desc-text.portrait {
  width: 80%;
}

.carselection-car-desc-text.disabled {
  color: #84848E;
}

.card-full-container {
  display: flex;
  position: absolute;
  width: 100%;
  height: calc(100% - 3.75rem);
  justify-content: center;
  flex-direction: row;
  pointer-events: none;
  opacity: 1;
  transition: opacity 0.8s ease-in-out;
}

.card-full-container.hide {
  opacity: 0;
}

.card-full-container.portrait {
  width: 100%;
}

.card-container {
  display: flex;
  width: 19.125rem;
  max-width: 90%;
  height: auto;
  flex-direction: column;
  justify-content: center;
  pointer-events: auto;
}

.card-container.portrait {
  height: 100%;
}

.card-container.hide {
  pointer-events: none;
}

.card-container-banner {
  width: 100%;
  height: 10rem;
  max-height: 80%;
  border-radius: 0.625rem 0.625rem 0rem 0rem;
  background: #D3D3D3;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: flex-end;
}

.card-container-banner.portrait {
  height: 10rem;
}

.card-container-banner-button {
  width: 2.5rem;
  height: 2.5rem;
  margin-top: 0.2rem;
  margin-right: 0.2rem;
  object-fit: contain;
  cursor: pointer;
}

.card-container-content {
  width: 100%;
  border-radius: 0rem 0rem 0.625rem 0.625rem;
  background: #F4F7FE;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.card-container-data {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: calc(100% - 1.875rem - 1.875rem);
  margin: 0.625rem 1.875rem 0.625rem 1.875rem;
}

.card-container-title {
  font-family: var(--av-font);
  font-weight: 500;
  font-size: 1.125rem;
  color: #00095B;
}

.card-container-title.portrait {
  font-size: clamp(0.5rem, 5vw, 1rem);
}

.card-container-desc {
  margin-top: 0.625rem;
  font-family: var(--av-font);
  font-weight: 300;
  font-size: 0.75rem;
  color: #84848E;
  text-align: start;
}

.card-container-desc.portrait {
  font-size: clamp(0.5rem, 5vw, 0.75rem);
}

.card-container-block {
  width: calc(100% - 1.28rem - 1.28rem);
  margin: 0rem 1.28rem 0rem 1.28rem;
}

.card-container-block-line {
  width: 100%;
  border-top: 1px solid #EEEEEE;
}

.card-container-info {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin: 0.625rem 0rem 0.625rem 0rem;
}

.card-container-info-icon {
  width: 1.18rem;
  height: 1.18rem;
  object-fit: contain;
}

.card-container-info-desc {
  font-family: var(--av-font);
  font-weight: 300;
  font-size: 0.8rem;
  color: #84848E;
  text-align: start;
  margin-left: 0.82rem;
}

.card-container-button {
  width: calc(100% - 2.875rem - 2.875rem);
  height: 2.375rem;
  background: #066FEF;
  border-radius: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 1.3rem 2.875rem 0.8rem 2.875rem;
  transition: background 0.8s ease-in-out;
}

.card-container-button:hover {
  background: #00095B;
}

.card-container-button-text {
  color: #FFFFFF;
  font-family: var(--av-font);
  font-weight: 300;
  font-size: clamp(0.5rem, 5vw, 0.9rem);
}

.card-container-close-portrait {
  width: 100%;
  height: 4.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-close-button-portrait {
  height: 90%;
  object-fit: contain;
  cursor: pointer;
}

.carousel-container {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 1;
  transition: opacity 0.8s ease-in-out;
  z-index: 1;
  background: var(--av-bg);
}

.carousel-container.hide-container {
  opacity: 0;
  pointer-events: none;
}

.carousel-info-card {
  position: absolute;
  width: 38%;
  height: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background: var(--av-bg);
  z-index: 1;
}

.carousel-info-card.portrait {
  width: 100%;
  height: auto;
  left: unset;
  bottom: 0;
}

.carousel-info-card.mobileland {
  width: 45%;
}

.carousel-info-header {
  height: 0.875rem;
  width: auto;
  max-width: 60%;
  object-fit: contain;
  object-position: left center;
  margin-top: 2.5rem;
  margin-left: var(--av-safe);
  opacity: 0.95;
}

.carousel-info-desc {
  margin-left: var(--av-safe);
  width: calc(100% - var(--av-safe));
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.carousel-info-desc.portrait {
  margin-left: 1.25rem;
  margin-top: 1.5rem;
  width: calc(100% - 1.25rem);
}

.carousel-info-desc.mobileland {
  margin-left: 2rem;
  width: calc(100% - 2rem);
}

.carousel-info-eyebrow {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--av-text-3);
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-weight: 400;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  margin-bottom: 1.25rem;
}
.carousel-info-eyebrow::before {
  content: "";
  width: 1.5rem;
  height: 1px;
  background: var(--av-accent);
}

.carousel-info-eyebrow.portrait {
  font-size: 0.75rem;
  line-height: 1.125rem;
  margin-bottom: 0.625rem;
}

.carousel-info-title {
  width: calc(100% - var(--av-safe));
  color: var(--av-text);
  font-size: clamp(1.75rem, 3.6vw, 3rem);
  line-height: 1.5;
  font-weight: 300;
  letter-spacing: -0.01em;
  margin-bottom: 2.75rem;
  margin-right: var(--av-safe);
}

.carousel-info-title.portrait {
  width: calc(100% - 1.25rem);
  font-size: 1.75rem;
  line-height: 2.625rem;
  margin-bottom: 1.25rem;
  margin-right: 1.25rem;
}

.carousel-info-title.mobileland {
  font-size: clamp(1.25rem, 2.4vw, 1.75rem);
  line-height: 1.5;
  width: calc(100% - 2rem);
  margin-bottom: 1rem;
  margin-right: 2rem;
}

.carousel-info-specs {
  margin-right: var(--av-safe);
  margin-bottom: 3rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--av-line);
  max-width: calc(100% - var(--av-safe));
  height: 3rem;
  object-fit: contain;
  object-position: left center;
}

.carousel-info-specs.portrait {
  margin-right: 1.25rem;
  margin-bottom: 1.25rem;
  padding-top: 1rem;
  width: calc(100% - 1.25rem);
  max-width: unset;
  height: auto;
}

.carousel-info-specs.mobileland {
  margin-right: 2rem;
  margin-bottom: 1rem;
  padding-top: 0.75rem;
  width: calc(100% - 2rem);
}

.carousel-info-options {
  margin-right: var(--av-safe);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

.carousel-info-options.portrait {
  margin-right: 1.25rem;
  display: block;
}

.carousel-info-options-buttonnav.portrait {
  max-width: none;
  width: 100%;
}

.carousel-info-options-buttonnav {
  display: flex;
  max-width: 60%;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

.carousel-info-options-button {
  width: auto;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
}

.carousel-info-options-button.portrait {
  width: 100%;
  margin-bottom: 1.25rem;
}

.carousel-info-options-button.mobileland {
  margin-bottom: 0.75rem;
}

.carousel-info-options-button-text {
  font-size: 0.875rem;
  line-height: 1.375rem;
  letter-spacing: 0.02em;
}

.carousel-info-options-button-text.portrait {
  font-size: 0.875rem;
  line-height: 1.375rem;
}

.carousel-info-options-bullets {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
}

.carousel-info-options-bullets.portrait {
  margin-bottom: 1rem;
}

.carousel-bullet-container {
  height: 1.25rem;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.carousel-bullet {
  width: 1.5rem;
  height: 2px;
  background: var(--av-line-strong);
  transition: width 0.4s var(--av-ease), background 0.4s var(--av-ease);
}

.carousel-bullet.selected {
  width: 2.75rem;
  background: var(--av-text);
}

.carousel-info-options-navegation {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  gap: 0.5rem;
}

.carousel-info-options-navegation-next {
  height: 40px;
  width: 40px;
  box-sizing: border-box;
  border-radius: var(--av-radius);
  background: transparent;
  border: 1px solid var(--av-line-strong);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background 0.3s var(--av-ease), border-color 0.3s var(--av-ease);
}

.carousel-info-options-navegation-next:hover {
  background: var(--av-hover);
}

.carousel-info-options-navegation.portrait {
  display: none;
}

.carousel-info-options-navegation-icon {
  width: 45%;
  object-fit: contain;
}

.carousel-content-footer {
  width: 100%;
  height: 12%;
}

.carousel-content-image {
  position: absolute;
  width: 62%;
  height: 100%;
  right: 0;
  background: var(--av-bg);
  pointer-events: none;
  overflow: hidden;
}
.carousel-content-image::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, var(--av-bg) 0%, rgba(24, 24, 24, 0) 22%), linear-gradient(0deg, rgba(24, 24, 24, 0.7) 0%, rgba(24, 24, 24, 0) 30%);
  pointer-events: none;
}

.carousel-content-image.portrait {
  width: 100%;
  height: calc(100% - 11.875rem);
  right: 0;
}
.carousel-content-image.portrait::after {
  background: linear-gradient(0deg, var(--av-bg) 0%, rgba(24, 24, 24, 0) 35%), linear-gradient(180deg, rgba(24, 24, 24, 0.55) 0%, rgba(24, 24, 24, 0) 18%);
}

.carousel-portrait-logo {
  position: absolute;
  top: 1.5rem;
  left: 1.25rem;
  height: 0.75rem;
  width: auto;
  z-index: 1;
  filter: drop-shadow(0 1px 6px rgba(0, 0, 0, 0.5));
}

.carousel-seal-container {
  position: absolute;
  width: 100%;
  height: 6.5rem;
  display: flex;
  bottom: 0;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.carousel-seal-container.portrait {
  height: 4.125rem;
  top: -4.125rem;
  bottom: unset;
}

.carousel-seal-container-img {
  height: 70%;
  max-width: 90%;
  object-fit: contain;
  opacity: 0.9;
}

.carousel-slide {
  position: absolute;
  width: 100%;
  height: 100%;
}

.carousel-slide-center {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  opacity: 1;
  right: 0%;
  transition: right 0.8s var(--av-ease), opacity 0.8s ease-in-out;
}

.carousel-slide-center.right {
  opacity: 0;
  right: -100%;
}

.carousel-slide-center.left {
  opacity: 0;
  right: 100%;
}

.carousel-slide-right {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  opacity: 0;
  right: -100%;
  transition: right 0.8s var(--av-ease), opacity 0.8s ease-in-out;
}

.carousel-slide-right.center {
  right: 0%;
  opacity: 1;
}

.carousel-slide-left {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  opacity: 0;
  right: 100%;
  transition: right 0.8s var(--av-ease), opacity 0.8s ease-in-out;
}

.carousel-slide-left.center {
  right: 0%;
  opacity: 1;
}

.carousel-slide-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 35% 50%;
}

.carousel-slide-img.portrait {
  object-position: 50% 50%;
}

.carousel-load-only {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.carousel-slides {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.carousel-slides.visible {
  opacity: 1;
}

.concessionaire-full-container {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 1;
  transition: opacity 0.8s ease-in-out;
}

.concessionaire-full-container.hide {
  opacity: 0;
  pointer-events: none;
}

.concessionaire-panoramic {
  position: absolute;
  width: 100%;
  height: 100%;
}

.concessionaire-panoramic-frame {
  width: 100%;
  height: 100%;
  border-style: none;
}

.concessionaire-panoramic-frame.portrait {
  position: relative;
}

.drag-animation-container {
  position: absolute;
  width: auto;
  height: 7.25rem;
  max-height: 50%;
  background: var(--av-glass);
  backdrop-filter: var(--av-blur);
  -webkit-backdrop-filter: var(--av-blur);
  border: 1px solid var(--av-line);
  border-radius: var(--av-radius-lg);
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 1.5rem;
  display: flex;
  align-items: center;
}

.drag-animation-container.portrait {
  height: 7.25rem;
  bottom: 12rem;
}

.drag-animation-mouse {
  position: absolute;
  width: 1.5rem;
  height: 2rem;
  object-fit: contain;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  margin-left: 0.5rem;
}

.drag-animation-mouse.portrait {
  width: 1.5rem;
  height: 1.5rem;
}

.drag-animation-mouse-move {
  animation: move 8s infinite;
}

.drag-animation-container-main {
  position: relative;
  width: 12rem;
  height: 100%;
}

.drag-animation-container-main.portrait {
  width: 10.44rem;
  max-width: 100%;
}

.drag-animation-hr {
  width: 1px;
  background-color: var(--av-line-strong);
  height: 60%;
}

.drag-animation-text {
  position: absolute;
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-weight: 300;
  color: var(--av-text-2);
  width: 85%;
  left: 50%;
  bottom: 12%;
  transform: translate(-50%, 0);
  text-align: center;
}

.drag-animation-text.portrait {
  font-size: 0.75rem;
  line-height: 1.125rem;
}

.drag-animation-scroll-downs {
  position: relative;
  top: 12%;
  left: 50%;
  width: 1.5rem;
  height: 1.5rem;
  transform: translate(-50%, 0);
}

.drag-animation-mousey {
  width: 0.375rem;
  padding: 0.375rem 0.5rem;
  height: 1.25rem;
  border: 1.25px solid var(--av-text);
  border-radius: 2.5rem;
  box-sizing: content-box;
  display: flex;
  justify-content: center;
}

.drag-animation-scroller {
  width: 2px;
  height: 8px;
  border-radius: 2px;
  background-color: var(--av-accent);
  animation-name: scroll;
  animation-duration: 2.2s;
  animation-timing-function: cubic-bezier(0.15, 0.41, 0.69, 0.94);
  animation-iteration-count: infinite;
}

@keyframes scroll {
  0% {
    opacity: 0;
  }
  10% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(15px);
    opacity: 0;
  }
}
.drag-animation-mouse-center-top {
  position: absolute;
  width: 1.5rem;
  height: 1.5rem;
  object-fit: contain;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  left: 52.5%;
  transform: translate(-50%, 0);
  animation: move-up 8s infinite;
}

.drag-animation-mouse-center-bottom {
  position: absolute;
  width: 1.5rem;
  height: 1.5rem;
  object-fit: contain;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  left: 42.5%;
  transform: translate(-50%, 0);
  animation: move-bottom 8s infinite;
}

.drag-animation-touch-center-top {
  animation: move-up 4s infinite;
}

.drag-animation-touch-center-bottom {
  animation: move-bottom 4s infinite;
}

@keyframes move-bottom {
  0% {
    transform: translate(-45%, -20%);
  }
  50% {
    transform: translate(-150%, 0%);
  }
  100% {
    transform: translate(-45%, -20%);
  }
}
@keyframes move-up {
  0% {
    transform: translate(-45%, -20%);
  }
  50% {
    transform: translate(60%, -60%);
  }
  100% {
    transform: translate(-45%, -20%);
  }
}
.car-studio-collapse-container {
  position: absolute;
  top: 1.5rem;
  left: calc(100% + 0.75rem);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  transition: left 0.8s var(--av-ease);
  pointer-events: none;
}

.car-studio-collapse-container.collapsed {
  left: calc(100% + var(--av-sb-left) + 0.75rem);
}

.car-studio-collapse-btn {
  width: 40px;
  height: 40px;
  box-sizing: border-box;
  flex-shrink: 0;
  background: var(--av-glass);
  backdrop-filter: var(--av-blur);
  -webkit-backdrop-filter: var(--av-blur);
  border: 1px solid var(--av-line-strong);
  border-radius: var(--av-radius);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  transition: background 0.3s var(--av-ease), border-color 0.3s var(--av-ease);
}
.car-studio-collapse-btn img {
  width: 1.125rem;
  height: 1.125rem;
  object-fit: contain;
  transform: rotate(0deg);
  transition: transform 0.8s var(--av-ease);
}

.car-studio-collapse-btn:hover {
  background: var(--av-glass-strong);
}

.car-studio-collapse-btn.collapsed img {
  transform: rotate(180deg);
}

.car-studio-collapse-tutorial {
  margin-left: 0.75rem;
  width: 15rem;
  height: 4.5rem;
  background: var(--av-glass);
  backdrop-filter: var(--av-blur);
  -webkit-backdrop-filter: var(--av-blur);
  border: 1px solid var(--av-line);
  border-radius: var(--av-radius-lg);
  display: flex;
  align-items: center;
  pointer-events: none;
  opacity: 1;
  transition: opacity 0.8s ease-in-out;
}

.car-studio-collapse-tutorial.hide {
  opacity: 0;
}

.collapse-animation-icon-container {
  position: relative;
  flex-shrink: 0;
  width: 4.5rem;
  height: 4.5rem;
}

.collapse-icon-animation {
  position: absolute;
  width: 2rem;
  height: 2rem;
  top: 0.875rem;
  left: 0.75rem;
  animation: cross-fade-mouse 2s infinite;
}

.collapse-icon {
  position: absolute;
  width: 1.5rem;
  height: 1.5rem;
  top: 1.875rem;
  left: 1.75rem;
}

.car-studio-collapse-tutorial-text {
  margin-right: 1rem;
  color: var(--av-text-2);
  font-size: 0.75rem;
  line-height: 1.125rem;
}

.collapse-animation-text-reduced {
  font-weight: 300;
}

.fade-out {
  pointer-events: none;
  opacity: 0;
  transition: all 0.4s ease-in-out;
}

.fade-in {
  pointer-events: all;
  opacity: 1;
  transition: all 0.4s ease-in-out;
}

@keyframes cross-fade-mouse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.gallery-full-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(24, 24, 24, 0.9);
  backdrop-filter: var(--av-blur);
  -webkit-backdrop-filter: var(--av-blur);
  opacity: 1;
  transition: opacity 0.8s ease-in-out;
}

.gallery-full-container.hide {
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.8s ease-in-out, visibility 0s linear 0.8s;
}

.gallery-full-container.hide *,
.gallery-partial-container:not(.visible) * {
  pointer-events: none !important;
}

.gallery-partial-container {
  position: absolute;
  width: -webkit-fill-available;
  height: calc(100% - 2.5rem);
  margin-top: 2.5rem;
  left: calc(var(--av-sb-left) + 19.25rem);
  display: flex;
  flex-direction: row;
  justify-content: center;
  overflow-y: auto;
  transition: left 0.8s var(--av-ease), opacity 0.8s ease-in-out;
  opacity: 0;
  pointer-events: none;
}

.gallery-partial-container.visible {
  opacity: 1;
  pointer-events: auto;
}

.gallery-partial-container.extended {
  left: 1rem;
}

.gallery-partial-container.portrait {
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  left: 0;
  height: calc(100% - 1.25rem - 0.375rem);
  margin-top: 1.25rem;
  margin-bottom: 0.375rem;
}

.gallery-partial-container-collage-menu {
  width: calc(100% - 1.5rem);
  padding: 1rem 0;
  background: var(--av-glass);
  border: 1px solid var(--av-line);
  border-radius: var(--av-radius-lg);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 0.875rem;
}

.gallery-partial-container-collage-title {
  color: var(--av-text);
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 300;
}

.gallery-partial-container-collage-buttons {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.gallery-partial-container-collage-logo {
  width: auto;
  height: 0.75rem;
  object-fit: contain;
  margin-left: 1rem;
  margin-right: 1.5rem;
}

.gallery-partial-container-collage-button {
  width: -webkit-fill-available;
  height: 40px;
  box-sizing: border-box;
  border: 1px solid var(--av-line-strong);
  border-radius: var(--av-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 1rem;
  transition: background 0.3s var(--av-ease);
}

.gallery-partial-container-collage-button:hover {
  background: var(--av-hover);
}

.gallery-partial-container-collage-button-text {
  color: var(--av-text);
  font-size: 0.875rem;
  line-height: 1.375rem;
  font-weight: 400;
}

.gallery-partial-container-collage {
  width: 90%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.gallery-partial-container-collage.altportrait {
  height: calc(100% - 7.5rem);
}

.gallery-collage-image {
  object-fit: contain;
  border-radius: var(--av-radius);
  cursor: pointer;
  transition: filter 0.6s ease, transform 0.6s var(--av-ease);
}

.gallery-collage-image:hover {
  filter: brightness(70%);
}

.gallery-partial-container-fullpicture {
  width: 90%;
  height: calc(100% - 2.5rem);
  margin-bottom: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gallery-partial-container-fullpicture.portrait {
  height: calc(50% - 2.5rem);
}

.gallery-partial-container-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--av-radius-lg);
}

.gallery-partial-container-controls {
  width: 90%;
  height: calc(100% - 2.5rem);
  margin-bottom: 2.5rem;
  display: flex;
  position: absolute;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  pointer-events: none;
}

.gallery-container-full-controls {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 14rem;
  margin-bottom: 1.25rem;
  padding: 0.875rem;
  background: var(--av-glass);
  backdrop-filter: var(--av-blur);
  -webkit-backdrop-filter: var(--av-blur);
  border: 1px solid var(--av-line);
  border-radius: var(--av-radius-lg);
  pointer-events: auto;
}

.gallery-container-controls-navigation {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.gallery-container-controls-button {
  width: 40px;
  height: 40px;
  box-sizing: border-box;
  border: 1px solid var(--av-line-strong);
  border-radius: var(--av-radius);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s var(--av-ease);
}
.gallery-container-controls-button img {
  width: 1.125rem;
  height: 1.125rem;
  object-fit: contain;
}

.gallery-container-controls-button:hover {
  background: var(--av-hover);
}

.gallery-container-controls-button.right img {
  transform: rotate(180deg);
}

.gallery-container-controls-subtitle {
  color: var(--av-text-2);
  font-size: 0.875rem;
  line-height: 1.375rem;
  font-weight: 400;
  letter-spacing: 0.08em;
  font-variant-numeric: tabular-nums;
}

.gallery-controls-button {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  border: 1px solid var(--av-line-strong);
  border-radius: var(--av-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s var(--av-ease);
}

.gallery-controls-button:hover {
  background: var(--av-hover);
}

.gallery-controls-button-text {
  color: var(--av-text);
  font-size: 0.875rem;
  line-height: 1.375rem;
  font-weight: 400;
}

.intro-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #222222;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center 50%;
  object-fit: cover;
  opacity: 1;
  transition: opacity 0.8s ease-in-out;
}

.intro-container.hide-container {
  opacity: 0;
  pointer-events: none;
}

.intro-content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}

.intro-top {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.intro-top-title-icon {
  height: clamp(0.75rem, 6vw, 8rem);
  margin-top: 11svh;
  aspect-ratio: 949/230;
}

.intro-top-title-icon.portrait {
  height: unset;
  width: 60%;
}

.intro-top-title {
  color: #FFFFFF;
  font-size: clamp(0.75rem, 5vw, 4.625rem);
  font-family: var(--av-font);
  font-weight: 400;
  text-align: center;
  margin-top: 11svh;
}

.intro-top-title.portrait {
  font-size: clamp(0.75rem, 15vw, 4.625rem);
  margin-top: 4svh;
}

.intro-top-subtitle {
  color: #FFFFFF;
  font-size: clamp(0.75rem, 2vw, 1.875rem);
  font-family: var(--av-font);
  font-weight: 400;
  text-align: center;
}

.intro-top-subtitle.portrait {
  font-size: clamp(0.75rem, 6vw, 1.875rem);
}

.intro-bottom {
  display: flex;
  width: 70%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 2.3125rem;
}

.intro-bottom.portrait {
  width: 95%;
  margin-bottom: 2.5rem;
}

.intro-bottom-line {
  width: 100%;
  height: 2px;
  background: #FFFFFF;
}

.intro-bottom-security {
  width: 100%;
  margin-top: 1.25rem;
  aspect-ratio: 907/96;
  object-fit: contain;
}

.intro-bottom-security.portrait {
  aspect-ratio: 320/46;
}

.intro-bottom-button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
  max-width: calc(100% - 4rem);
  border: 1px solid rgb(238, 103, 103);
  background: #DD4040 0% 0% no-repeat padding-box;
  box-shadow: -2px 2px 6px rgba(50, 58, 79, 0.16);
  border-radius: 10rem;
  transition: background 0.2s ease-in-out;
  color: #FFFFFF;
  font-size: clamp(0.75rem, 2vw, 1.875rem);
  font-family: var(--av-font);
  font-weight: 400;
  text-align: center;
  padding: 0.5rem 2rem 0.5rem 2rem;
}

.intro-bottom-button.portrait {
  max-width: calc(100% - 8rem);
  font-size: clamp(0.5rem, 5vw, 1.2rem);
  padding: 0.5rem 4rem 0.5rem 4rem;
}

.intro-bottom-button:hover {
  background: #B33131 0% 0% no-repeat padding-box;
  cursor: pointer;
}

.full-loading-screen-container {
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
  pointer-events: none;
}

.loading-screen-container {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 48, 87, 0.6);
  backdrop-filter: blur(10px);
  pointer-events: auto;
}

.loading-screen-container.expand {
  width: calc(100% - 2rem);
  left: 2rem;
}

.loading-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background: var(--av-bg);
  opacity: 1;
  transition: opacity 0.9s ease-in-out;
}

.loading-container.hide-container {
  opacity: 0;
  pointer-events: none;
}

.loading-progress {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.loading-post-logo {
  height: 1.5rem;
  width: auto;
  max-width: 60%;
  object-fit: contain;
  margin-bottom: 3.5rem;
  animation: loading-breath 2.4s ease-in-out infinite;
}

.loading-post-logo.portrait {
  height: 1.125rem;
  margin-bottom: 2.5rem;
}

.loading-progress-bar {
  max-width: 32rem;
  width: 70%;
  height: 2px;
}

.loading-progress-info {
  max-width: 32rem;
  width: 70%;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  margin-top: 1rem;
}

.loading-progress-message {
  color: var(--av-text-3);
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-weight: 400;
  letter-spacing: 0.08em;
}

.loading-progress-message.portrait {
  font-size: 0.75rem;
  line-height: 1.125rem;
}

.loading-progress-value {
  color: var(--av-text);
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-weight: 400;
  letter-spacing: 0.08em;
  font-variant-numeric: tabular-nums;
}

@keyframes loading-breath {
  0%, 100% {
    opacity: 0.55;
  }
  50% {
    opacity: 1;
  }
}
.pdfviewer-global {
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8) 0% 0% no-repeat padding-box;
  backdrop-filter: blur(5px);
  justify-content: center;
  align-items: center;
  z-index: 2;
  opacity: 0;
  transition: opacity 0.8s ease-in-out;
  pointer-events: none;
}

.pdfviewer-global.visible {
  opacity: 1;
  pointer-events: auto;
}

.pdfviewer-menu {
  display: flex;
  width: 97.87rem;
  height: 51.56rem;
  max-width: 85%;
  max-height: 85%;
  background: #fff;
  border-radius: 10px;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
}

.pdfviewer-menu.portrait {
  width: calc(100% - 1.25rem);
  height: calc(100% - 1.25rem);
  max-width: unset;
  max-height: unset;
}

.pdfviewer-container {
  width: 99%;
  height: 90%;
  --rpv-core__page-layer-box-shadow: 0px 0px 0px 0 rgba(0, 0, 0, 0.0) //para eliminar sombras de las páginas;
}

.pdfviewer-close-btn {
  width: 14.1875rem;
  height: 2.25rem;
  background: #DD4040;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  cursor: pointer;
  border: 1px solid rgb(238, 103, 103);
  font-family: var(--av-font);
  font-weight: 400;
  font-size: clamp(0.1rem, 4vw, 0.8rem);
  color: #fff;
}

.pdfviewer-close-btn:hover {
  box-shadow: 0px 0px 6px #000000;
}

.rpv-default-layout__toolbar {
  background-color: #fff;
  border-bottom: 0px;
}

.rpv-core__icon {
  stroke-width: 2;
}

.rpv-default-layout__container {
  border: 0px;
}

.rpv-default-layout__sidebar--ltr {
  border-right: 0px;
}

.rpv-default-layout__sidebar-headers {
  background-color: #fff;
}

.pc-full-container {
  position: absolute;
  width: 100%;
  height: 100%;
}

.pc-container {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  border-style: none;
  transition: opacity 1s ease;
}

.pc-container.portrait {
  position: relative;
  height: calc(100% + 0.625rem);
}

.pc-container.visible {
  opacity: 1;
}

.screenshot-full-container {
  position: absolute;
  width: 100%;
  height: calc(100% - 3.75rem);
  background: transparent;
  pointer-events: none;
  opacity: 1;
  transition: opacity 0.8s ease-in-out, background 0.8s ease-in-out;
}

.screenshot-full-container.portrait {
  height: 100%;
  z-index: 1;
}

.screenshot-full-container.background {
  height: 100%;
  background: rgba(24, 24, 24, 0.9);
  backdrop-filter: var(--av-blur);
  -webkit-backdrop-filter: var(--av-blur);
}

.screenshot-full-container.hide {
  opacity: 0;
}

.screenshot-reticle-container {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.screenshot-reticle-rows {
  width: 55%;
  height: 68%;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
}

.screenshot-reticle-rows.portrait {
  width: 90%;
  height: 50%;
}

.screenshot-reticle-columns {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.screenshot-reticle-br, .screenshot-reticle-bl, .screenshot-reticle-tr, .screenshot-reticle-tl {
  width: 2.5rem;
  height: 2.5rem;
  border: 1.5px solid var(--av-text);
}

.screenshot-reticle-tl {
  border-bottom-width: 0;
  border-right-width: 0;
}

.screenshot-reticle-tr {
  border-bottom-width: 0;
  border-left-width: 0;
}

.screenshot-reticle-bl {
  border-top-width: 0;
  border-right-width: 0;
}

.screenshot-reticle-br {
  border-top-width: 0;
  border-left-width: 0;
}

.screenshot-reticle-tl.portrait,
.screenshot-reticle-tr.portrait,
.screenshot-reticle-bl.portrait,
.screenshot-reticle-br.portrait {
  width: 1.25rem;
  height: 1.25rem;
}

.screenshot-capture-container {
  position: absolute;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-content: center;
  flex-wrap: wrap;
  pointer-events: auto;
}

.screenshot-capture-container.portrait {
  width: 100%;
  justify-content: center;
  align-content: flex-end;
}

.screenshot-capture-container.hide {
  pointer-events: none;
}

.screenshot-capture-center {
  height: 4rem;
  margin-left: 1.75rem;
  display: flex;
  align-items: center;
}

.screenshot-capture-center.portrait {
  height: 3.5rem;
  margin-left: 0;
  margin-bottom: 1.5rem;
}

.screenshot-capture-icon {
  height: 100%;
  cursor: pointer;
  transition: transform 0.2s linear, filter 0.3s linear;
}

.screenshot-capture-icon:hover {
  transform: scale(1.05);
  filter: drop-shadow(0 6px 12px rgba(180, 215, 25, 0.6));
}

.screenshot-capture-msg {
  margin-left: 1rem;
  padding: 0.75rem 1rem;
  background: var(--av-glass);
  backdrop-filter: var(--av-blur);
  -webkit-backdrop-filter: var(--av-blur);
  border: 1px solid var(--av-line);
  border-radius: var(--av-radius-lg);
  display: flex;
  align-items: center;
}

.screenshot-capture-text {
  color: var(--av-text-2);
  font-size: 0.875rem;
  line-height: 1.375rem;
}

.screenshot-preview-container {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
  pointer-events: auto;
}

.screenshot-preview-container.hide {
  pointer-events: none;
}

.screenshot-preview-center {
  width: 80%;
  height: 80%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.screenshot-preview-center.portrait {
  width: 90%;
  height: auto;
  flex-direction: column;
}

.screenshot-preview-image {
  width: 60%;
  max-height: 100%;
  aspect-ratio: 905/509;
  border-radius: var(--av-radius-lg);
  border: 1px solid var(--av-line);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.screenshot-preview-image.portrait {
  width: 100%;
  max-height: 60%;
  aspect-ratio: 1;
}

.screenshot-preview-confirmation {
  width: calc(40% - 4rem);
  margin-left: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.screenshot-preview-confirmation.portrait {
  width: 100%;
  margin-left: 0;
}

.screenshot-preview-confirmation-title {
  color: var(--av-text);
  font-size: 2.25rem;
  line-height: 3.375rem;
  font-weight: 300;
}

.screenshot-preview-confirmation-title.portrait {
  font-size: 1.25rem;
  line-height: 1.75rem;
  text-align: center;
  margin: 1.25rem 0;
}

.screenshot-preview-confirmation-buttons {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  margin-top: 2.5rem;
}

.screenshot-preview-confirmation-buttons.portrait {
  margin-top: 0;
}

.screenshot-preview-button-retake, .screenshot-preview-button-download {
  width: 100%;
  min-width: 112px;
  max-width: 18rem;
  height: 40px;
  box-sizing: border-box;
  padding: 0 20px;
  border-radius: var(--av-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.screenshot-preview-button-download {
  background: var(--av-text);
  box-shadow: 0 12px 20px -12px rgba(180, 215, 25, 0);
  transition: transform 0.2s linear, box-shadow 0.3s linear;
}

.screenshot-preview-button-download:hover {
  transform: translate3d(0, -2px, 0);
  box-shadow: 0 14px 22px -10px rgba(180, 215, 25, 0.85);
}

.screenshot-preview-button-retake {
  border: 1px solid var(--av-line-strong);
  transition: background 0.3s var(--av-ease);
}

.screenshot-preview-button-retake:hover {
  background: var(--av-hover);
}

.screenshot-preview-button-download.portrait,
.screenshot-preview-button-retake.portrait {
  max-width: 100%;
}

.screenshot-preview-button-download-text,
.screenshot-preview-button-retake-text {
  font-size: 0.875rem;
  line-height: 1.375rem;
  font-weight: 400;
  letter-spacing: 0.02em;
}

.screenshot-preview-button-download-text {
  color: var(--av-ink);
}

.screenshot-preview-button-retake-text {
  color: var(--av-text);
}

.screenshot-return-button {
  position: absolute;
  margin-left: 1.25rem;
  margin-top: 1.25rem;
  height: 40px;
  box-sizing: border-box;
  padding: 0 12px;
  background: var(--av-glass);
  backdrop-filter: var(--av-blur);
  -webkit-backdrop-filter: var(--av-blur);
  border: 1px solid var(--av-line-strong);
  border-radius: var(--av-radius);
  display: flex;
  align-items: center;
  pointer-events: auto;
  cursor: pointer;
}

.screenshot-return-button.hide {
  pointer-events: none;
}

.screenshot-return-text {
  color: var(--av-text);
  font-size: 0.875rem;
  line-height: 1.375rem;
  font-weight: 400;
}

.studio-full-container {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 1;
  transition: opacity 0.8s ease-in-out;
}

.studio-full-container.portrait {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.studio-full-container.hide {
  opacity: 0;
  pointer-events: none;
}

.studio-full-container.hide *,
.studio-full-siderbar.hide * {
  pointer-events: none !important;
}

.studio-3d-container {
  position: absolute;
  width: 100%;
  height: 100%;
}

.studio-full-siderbar {
  display: flex;
  position: absolute;
  height: 100%;
  left: var(--av-sb-left);
  align-items: flex-start;
  flex-direction: column;
  pointer-events: none;
  opacity: 1;
  transition: opacity 0.8s ease-in-out;
}

.studio-full-siderbar.hide {
  opacity: 0;
}

.studio-sidebar-topbar {
  display: flex;
  gap: 0.5rem;
  height: 40px;
  margin-top: 1.25rem;
  margin-bottom: 0.75rem;
  position: relative;
}

.studio-sidebar-topbar.portrait {
  position: absolute;
  height: 40px;
  margin-left: 1.25rem;
  margin-top: 1.25rem;
  margin-bottom: unset;
  z-index: 2;
}

.studio-sidebar-topbar-button,
.studio-sidebar-topbar-music {
  height: 100%;
  box-sizing: border-box;
  background: var(--av-glass);
  backdrop-filter: var(--av-blur);
  -webkit-backdrop-filter: var(--av-blur);
  border: 1px solid var(--av-line-strong);
  border-radius: var(--av-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  pointer-events: auto;
  transition: background 0.3s var(--av-ease), border-color 0.3s var(--av-ease);
}

.studio-sidebar-topbar-button:hover,
.studio-sidebar-topbar-music:hover {
  background: var(--av-glass-strong);
}

.studio-sidebar-topbar-button {
  gap: 0.25rem;
  padding: 0 12px 0 8px;
}

.studio-sidebar-topbar-icon {
  width: 1.125rem;
  height: 1.125rem;
}

.studio-sidebar-topbar-text {
  color: var(--av-text);
  font-size: 0.875rem;
  line-height: 1.375rem;
  font-weight: 400;
}

.studio-sidebar-topbar-music {
  aspect-ratio: 1;
}
.studio-sidebar-topbar-music img {
  width: 1rem;
  height: 1rem;
  object-fit: contain;
  opacity: 0.9;
}

.studio-sidebar-container {
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  position: relative;
  width: 18rem;
  height: calc(100% - 40px - 1.25rem - 0.75rem - 1.25rem);
  margin-bottom: 1.25rem;
  left: 0;
  background: var(--av-glass);
  backdrop-filter: var(--av-blur);
  -webkit-backdrop-filter: var(--av-blur);
  border: 1px solid var(--av-line);
  border-radius: var(--av-radius-lg);
  transition: left 0.8s var(--av-ease);
}

.studio-sidebar-container.collapsed {
  left: calc(-18rem - var(--av-sb-left) - 0.75rem);
}

.studio-sidebar-subcontainer {
  position: relative;
  height: 100%;
  padding: 1.75rem 1.75rem 1.5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
}

.studio-sidebar-header {
  display: flex;
  flex-direction: column;
}

.studio-sidebar-header-logo {
  order: 0;
  height: 0.75rem;
  width: auto;
  align-self: flex-start;
  object-fit: contain;
}

.studio-sidebar-header-subtitle {
  order: 1;
  display: flex;
  align-items: center;
  gap: 0.625rem;
  margin-top: 2.5rem;
  color: var(--av-text-3);
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-weight: 400;
  letter-spacing: var(--av-tracking);
  text-transform: uppercase;
}
.studio-sidebar-header-subtitle::before {
  content: "";
  width: 1rem;
  height: 1px;
  background: var(--av-accent);
}

.studio-sidebar-header-title {
  order: 2;
  margin-top: 0.625rem;
  color: var(--av-text);
  font-size: 1.75rem;
  line-height: 2.625rem;
  font-weight: 300;
}

.studio-sidebar-section {
  margin-top: 2.25rem;
}

.studio-sidebar-section-title,
.studio-sidebar-color-title {
  color: var(--av-text-3);
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-weight: 400;
  letter-spacing: var(--av-tracking);
  text-transform: uppercase;
  margin-bottom: 0.875rem;
}

.studio-sidebar-view {
  display: flex;
  gap: 4px;
  padding: 4px;
  border: 1px solid var(--av-line);
  border-radius: var(--av-radius);
}

.studio-sidebar-view-button-container {
  flex: 1 1;
  height: 30px;
  cursor: pointer;
}

.studio-sidebar-view-button {
  width: 100%;
  height: 100%;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  transition: background 0.3s var(--av-ease);
}

.studio-sidebar-view-button:hover {
  background: var(--av-hover);
}

.studio-sidebar-view-button.selected {
  background: var(--av-text);
}

.studio-sidebar-view-text {
  color: var(--av-text-2);
  font-size: 0.875rem;
  line-height: 1.375rem;
  font-weight: 400;
  letter-spacing: 0.02em;
  transition: color 0.3s var(--av-ease);
}

.studio-sidebar-view-text.selected {
  color: var(--av-ink);
}

.studio-sidebar-color {
  margin-top: 2.25rem;
}

.studio-sidebar-color-subcontainer {
  display: flex;
  flex-direction: column;
}

.studio-sidebar-color-selection {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px;
}

.studio-sidebar-color-element {
  position: relative;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.studio-sidebar-color-element::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background-color: rgba(229, 229, 229, 0.9333333333);
  opacity: 0;
  transform: scale(0.8);
  transition: opacity 0.3s linear, transform 0.3s var(--av-ease);
}

.studio-sidebar-color-element.selected::before,
.studio-sidebar-color-element:hover::before {
  opacity: 1;
  transform: scale(1);
}

.studio-sidebar-color-selection:hover .studio-sidebar-color-element.selected:not(:hover)::before {
  opacity: 0;
  transform: scale(0.8);
}

.studio-sidebar-color-img {
  position: relative;
  z-index: 1;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: contain;
}

.studio-sidebar-color-text {
  margin-top: 0.5rem;
  animation: av-color-name 0.3s linear;
  color: var(--av-text);
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 300;
}

.studio-sidebar-options {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: auto;
  padding-top: 2rem;
}

.studio-sidebar-options-button {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  flex-shrink: 0;
  background: transparent;
  border: 1px solid var(--av-line-strong);
  border-radius: var(--av-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s var(--av-ease), border-color 0.3s var(--av-ease);
}

.studio-sidebar-options-button:hover {
  background: var(--av-hover);
}

.studio-sidebar-options-button.av-btn-primary {
  margin-top: 0.25rem;
}

.studio-sidebar-options-text {
  width: 100%;
  color: var(--av-text);
  font-size: 0.875rem;
  line-height: 1.375rem;
  font-weight: 400;
  text-align: center;
}

.studio-sidebar-lights {
  display: flex;
  align-items: center;
  margin-top: 1.5rem;
}

.studio-sidebar-lights-title {
  color: var(--av-text);
  font-size: 0.875rem;
  line-height: 1.375rem;
  margin-left: 0.625rem;
}

.studio-sidebar-scenario-subcontainer {
  display: flex;
  flex-direction: column;
  margin-top: 2.25rem;
}

.studio-sidebar-scenario-title {
  color: var(--av-text-3);
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-weight: 400;
  letter-spacing: var(--av-tracking);
  text-transform: uppercase;
  margin-bottom: 0.875rem;
}

.studio-sidebar-scenario-selection {
  display: flex;
  gap: 4px;
  padding: 4px;
  border: 1px solid var(--av-line);
  border-radius: var(--av-radius);
}

.studio-sidebar-scenario-button-container {
  flex: 1 1;
  min-width: 0;
  height: 30px;
  cursor: pointer;
}

.studio-sidebar-scenario-button {
  width: 100%;
  height: 100%;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  transition: background 0.3s var(--av-ease);
}

.studio-sidebar-scenario-button:hover {
  background: var(--av-hover);
}

.studio-sidebar-scenario-button.selected {
  background: var(--av-text);
}

.studio-sidebar-scenario-text {
  color: var(--av-text-2);
  font-size: 0.875rem;
  line-height: 1.375rem;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.3s var(--av-ease);
}

.studio-sidebar-scenario-text.selected {
  color: var(--av-ink);
}

.studio-sidebar-seats {
  pointer-events: none;
  margin-top: 2.25rem;
}

.studio-sidebar-seats.enabled {
  pointer-events: auto;
}

.studio-sidebar-seats-subcontainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.studio-sidebar-seats-title {
  color: var(--av-text-3);
  font-size: 0.75rem;
  line-height: 1.125rem;
  letter-spacing: var(--av-tracking);
  text-transform: uppercase;
  margin-bottom: 1rem;
}

.studio-sidebar-icon-container {
  width: 50%;
  display: flex;
  flex-direction: column;
}

.studio-sidebar-icon-row {
  display: flex;
}

.studio-sidebar-seat-icon {
  width: 45%;
  aspect-ratio: 1;
  border: 1px solid var(--av-line-strong);
  border-radius: var(--av-radius);
  margin: 0.25rem;
  cursor: pointer;
  transition: background 0.3s var(--av-ease);
}

.studio-sidebar-seat-icon.selected {
  background: var(--av-text);
}

@keyframes av-color-name {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.interior-viewer {
  position: fixed;
  inset: 0;
  background: var(--av-bg);
  opacity: 1;
  transition: opacity 0.6s ease-in-out;
}

.interior-viewer.hide {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  transition: opacity 0.6s ease-in-out, visibility 0s linear 0.6s;
}
.interior-viewer.hide * {
  pointer-events: none !important;
}

.interior-viewer.portrait {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 72px 0 216px;
  box-sizing: border-box;
}

.interior-viewer-stage {
  position: absolute;
  inset: 0;
}

.interior-viewer-stage.portrait {
  position: relative;
  inset: auto;
  width: 100%;
  aspect-ratio: 4320/2400;
}

.interior-viewer-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.6s ease-in-out;
  -webkit-user-drag: none;
}

.interior-viewer-image.visible {
  opacity: 1;
}

.interior-viewer-image.portrait {
  object-fit: contain;
}

.interior-viewer-controls {
  position: absolute;
  bottom: 1.5rem;
  left: calc(50% + (18rem + var(--av-sb-left)) / 2);
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  background: var(--av-glass);
  backdrop-filter: var(--av-blur);
  -webkit-backdrop-filter: var(--av-blur);
  border: 1px solid var(--av-line);
  border-radius: var(--av-radius-lg);
  transition: left 0.8s var(--av-ease);
}

.interior-viewer.extended .interior-viewer-controls {
  left: 50%;
}

.interior-viewer-controls.portrait {
  position: relative;
  bottom: auto;
  left: auto;
  transform: none;
  margin-top: 1rem;
}

.interior-viewer.portrait .interior-viewer-controls {
  left: auto;
}

.interior-viewer-button {
  width: 40px;
  height: 40px;
  box-sizing: border-box;
  border: 1px solid var(--av-line-strong);
  border-radius: var(--av-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s var(--av-ease);
}
.interior-viewer-button img {
  width: 1.125rem;
  height: 1.125rem;
  object-fit: contain;
}

.interior-viewer-button:hover {
  background: var(--av-hover);
}

.interior-viewer-indicators {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 4px;
}

.interior-viewer-indicator {
  height: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.interior-viewer-indicator-line {
  width: 1.5rem;
  height: 2px;
  background: var(--av-gray-2);
  transition: width 0.4s var(--av-ease), background 0.4s var(--av-ease);
}

.interior-viewer-indicator.selected .interior-viewer-indicator-line {
  width: 2.75rem;
  background: var(--av-text);
}

.interior-viewer-counter {
  min-width: 2.5rem;
  color: var(--av-text-2);
  font-size: 0.75rem;
  line-height: 1.125rem;
  text-align: center;
  font-variant-numeric: tabular-nums;
}

@media screen and (orientation: portrait) and (min-width: 1000px) and (min-height: 1000px) {
  .carousel-info-title.portrait {
    width: calc(100% - 4.53125rem);
    font-size: 3rem;
    line-height: 4.5rem;
    margin-bottom: 1.125rem;
    margin-right: 4.53125rem;
  }
  .carousel-info-desc.portrait {
    margin-left: 4.53125rem;
    margin-top: 2.875rem;
    width: calc(100% - 4.53125rem);
  }
  .carousel-info-specs.portrait {
    margin-right: 4.53125rem;
    margin-bottom: 2.73875rem;
    width: calc(100% - 4.53125rem);
  }
  .carousel-info-options.portrait {
    justify-content: center;
    margin-right: 4.53125rem;
  }
  .carousel-info-options-buttonnav {
    max-width: unset;
  }
  .carousel-info-options-button.portrait {
    width: 31.25rem;
    margin-bottom: 3rem;
  }
  .carousel-info-options-button-text.portrait {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .carousel-info-options-navegation-next.portrait {
    height: 3.5rem;
    width: 3.5rem;
  }
  .carousel-bullet-container.portrait {
    height: 2.5rem;
  }
  .carousel-seal-container.portrait {
    height: 7.375rem;
    top: -7.375rem;
    bottom: unset;
  }
  .studio-sidebar-topbar.portrait {
    height: 2.75rem;
    margin-left: 1.25rem;
    margin-top: 1.25rem;
  }
  .studio-sidebar-topbar-text.portrait {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .studio-sidebar-topbar-music.portrait img {
    width: 1.25rem;
    height: 1.25rem;
  }
  .drag-animation-container.portrait {
    bottom: 20rem;
  }
  .drag-animation-text.portrait {
    font-size: 0.75rem;
    line-height: 1.125rem;
  }
  .bullet-sidebar-container.portrait {
    width: 35rem;
  }
  .bullet-container-content.portrait {
    padding-bottom: 2rem;
    height: 15.625rem;
  }
  .bullet-container-title.portrait {
    font-size: 1.25rem;
    line-height: 1.75rem;
    margin-bottom: 1.25rem;
  }
  .bullet-container-desc.portrait {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .bullet-container-banner-button.portrait {
    width: 2.5rem;
    height: 2.5rem;
    top: 1rem;
    right: 1rem;
  }
  .bottombar-full-container {
    width: 39.375rem;
    margin-bottom: 1.25rem;
  }
  .bottombar-full-container.hidden {
    bottom: -13.625rem;
  }
  .bottombar-menu-title {
    font-size: 1.5rem;
    line-height: 2rem;
    margin-top: 0.75rem;
  }
  .bottombar-menu-container {
    margin-top: 1.875rem;
  }
  .bottombar-menu-view {
    height: 5rem;
  }
  .bottombar-menu-color {
    height: 5rem;
  }
  .bottombar-view-logo {
    height: 1rem;
  }
  .bottombar-view-button-container {
    width: 10rem;
    height: 2.5rem;
  }
  .bottombar-view-text {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .bottombar-main-container {
    max-width: calc(100% - 1.25rem);
    height: auto;
    margin: 0.5rem 0rem 0.875rem 0rem;
  }
  .bottombar-main-button {
    width: 6.25rem;
    height: 4.5625rem;
  }
  .bottombar-main-button-text {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .bottombar-color-element {
    width: 48px;
    height: 48px;
  }
  .bottombar-color-img {
    width: 32px;
    height: 32px;
  }
  .bottombar-color-text {
    font-size: 1rem;
    line-height: 1.5rem;
    margin-bottom: 1rem;
  }
  .gallery-partial-container-collage.altportrait {
    height: calc(100% - 11.875rem - 1.25rem);
  }
  .gallery-partial-container-collage-menu {
    max-width: 98%;
    width: 61.5rem;
    height: 11.875rem;
  }
  .gallery-partial-container-collage-title {
    font-size: 1.5rem;
    line-height: 2rem;
    margin-top: 2.53125rem;
  }
  .gallery-partial-container-collage-buttons {
    justify-content: center;
    margin-bottom: 1.25rem;
  }
  .gallery-partial-container-collage-logo {
    height: 1rem;
    object-fit: contain;
    margin-left: unset;
    margin-right: 5rem;
  }
  .gallery-partial-container-collage-button {
    width: 18.75rem;
    height: 2.5rem;
  }
  .gallery-partial-container-collage-button-text {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .gallery-container-controls-subtitle {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .gallery-container-full-controls {
    width: 17.375rem;
  }
  .gallery-controls-button {
    height: 2.5rem;
  }
  .gallery-controls-button-text {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .gallery-container-controls-button {
    width: 3rem;
    height: 3rem;
  }
  .gallery-container-controls-button img {
    width: 1.5rem;
    height: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/style.sass","webpack://./src/styles/main.sass","webpack://./src/styles/fonts.sass","webpack://./src/styles/portrait/bottombar.sass","webpack://./src/styles/landscape/animations.sass","webpack://./src/styles/landscape/bullet.sass","webpack://./src/styles/landscape/car_selection.sass","webpack://./src/styles/landscape/card.sass","webpack://./src/styles/landscape/carousel.sass","webpack://./src/styles/landscape/concessionaire.sass","webpack://./src/styles/landscape/control_tutorial.sass","webpack://./src/styles/landscape/gallery.sass","webpack://./src/styles/landscape/intro.sass","webpack://./src/styles/landscape/loading_screen.sass","webpack://./src/styles/landscape/loading.sass","webpack://./src/styles/landscape/pdfviewer.sass","webpack://./src/styles/landscape/pc.sass","webpack://./src/styles/landscape/screenshot.sass","webpack://./src/styles/landscape/studio.sass","webpack://./src/styles/landscape/interior_viewer.sass","webpack://./src/styles/breakpoints/main.sass","webpack://./src/styles/breakpoints/ipad_portrait.sass"],"names":[],"mappings":"AAAA,gBAAgB;ACEhB;EACE,mFAAA;EAGA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,wBAAA;EACA,wBAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,4BAAA;EAGA,wBAAA;EACA,kCAAA;EACA,wCAAA;EACA,oCAAA;EAEA,2BAAA;EACA,iCAAA;EACA,qCAAA;EAEA,0BAAA;EACA,6BAAA;EACA,6BAAA;EACA,yBAAA;EAGA,iCAAA;EAEA,gBAAA;EACA,mBAAA;EACA,qCAAA;EAEA,qBAAA;EAGA,eAAA;EAGA,qBAAA;ADdF;;ACgBA;EACE,SAAA;EACA,UAAA;EACA,aAAA;ADbF;;ACeA;EACE,WAAA;EACA,UAAA;ADZF;;ACcA;EACE,uBAAA;ADXF;;ACaA;EACE,qCAAA;EACA,mBAAA;ADVF;;ACYA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EAEA,cAAA;EACA,yBAAA;EAGA,oBAAA;EACA,iBAAA;ADVF;;ACYA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;ADTF;;ACWA;EACE,sCAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,SAAA;EACA,mCAAA;EACA,kCAAA;ADRF;;ACUA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;ADPF;;ACSA;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;ADPF;;ACYA;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,sCAAA;EACA,uBAAA;EACA,0CAAA;EACA,eAAA;EACA,mDAAA;EACA,yDAAA;ADTF;ACUE;EACE,+BAAA;EACA,0BAAA;EACA,4BAAA;EACA,gBAAA;ADRJ;ACSE;EACE,kCAAA;EACA,sDAAA;ADPJ;;AEvHA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4DAAA;AF0HF;AExHA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4DAAA;AF0HF;AExHA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4DAAA;AF0HF;AGhJA;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,2BAAA;EACA,cAAA;EACA,+BAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,UAAA;EACA,2BAAA;EACA,+BAAA;EACA,uCAAA;EACA,gCAAA;EACA,kCAAA;EACA,gEAAA;AHkJF;;AGhJA;EACE,aAAA;AHmJF;;AGjJA;EACE,cAAA;AHoJF;;AGlJA;EACE,WAAA;EACA,YAAA;EACA,kCAAA;EACA,gCAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AHqJF;AGpJE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;AHsJJ;;AGnJE;EACE,wBAAA;AHsJJ;;AGpJA;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AHuJF;;AGrJA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AHwJF;;AGrJA;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AHwJF;;AGtJA;EACE,YAAA;EACA,wBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AHyJF;;AGvJA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;AH0JF;;AGxJA;EACE,aAAA;EACA,QAAA;EACA,YAAA;EACA,gCAAA;EACA,+BAAA;AH2JF;;AGzJA;EACE,aAAA;EACA,YAAA;EACA,eAAA;AH4JF;;AG1JA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;AH6JF;;AG3JA;EACE,0BAAA;AH8JF;;AG5JA;EACE,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AH+JF;;AG7JA;EACE,oBAAA;AHgKF;;AG7JA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AHgKF;;AG7JA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AHgKF;;AG9JA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AHiKF;AGhKE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,qBAAA;EACA,8DAAA;AHkKJ;;AGhKA;EACE,UAAA;EACA,mBAAA;AHmKF;;AGjKA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AHoKF;;AGlKA;EACE,oCAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AHqKF;;AGlKA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AHqKF;;AGnKA;EACE,aAAA;AHsKF;;AGpKA;EACE,aAAA;EACA,QAAA;EACA,YAAA;EACA,wBAAA;EACA,sBAAA;EACA,gCAAA;EACA,+BAAA;AHuKF;;AGrKA;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AHwKF;;AGtKA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;AHyKF;;AGvKA;EACE,0BAAA;AH0KF;;AGxKA;EACE,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AH2KF;;AGzKA;EACE,oBAAA;AH4KF;;AGzKA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AH4KF;;AG1KA;EACE,aAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;AH6KF;;AG3KA;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,+BAAA;EACA,uCAAA;AH8KF;;AG5KA;EACE,qBAAA;EACA,mBAAA;EACA,qBAAA;AH+KF;;AG5KA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AH+KF;AG9KE;EACE,aAAA;AHgLJ;;AG9KA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AHiLF;;AG/KA;EAEE,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,+BAAA;EACA,6BAAA;EACA,eAAA;EACA,4EAAA;AHiLF;;AG/KA;EACE,2BAAA;AHkLF;;AGhLA;EACE,oCAAA;EACA,mCAAA;AHmLF;;AGjLA;EACE,YAAA;EACA,cAAA;EACA,mBAAA;AHoLF;;AGlLA;EACE,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AHqLF;;AGnLA;EACE,qBAAA;AHsLF;;AGnLA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AHsLF;;AGpLA;EACE,oBAAA;AHuLF;;AGrLA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AHwLF;;AGtLA;EACE,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kCAAA;EACA,yBAAA;AHyLF;;AGvLA;EACE,WAAA;EACA,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AH0LF;;AGxLA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AH2LF;;AGzLA;EACE,2BAAA;EACA,eAAA;EACA,uCAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;AH4LF;;AG1LA;EACE,0BAAA;AH6LF;;AIriBA;EACE;IACE,YAAA;EJwiBF;EIviBA;IACE,UAAA;EJyiBF;AACF;AIxiBA;EACE;IACE,QAAA;IACA,yBAAA;EJ0iBF;EIziBA;IACE,SAAA;IACA,wBAAA;EJ2iBF;EI1iBA;IACE,QAAA;IACA,yBAAA;EJ4iBF;AACF;AI3iBA;EACE;IACE,YAAA;EJ6iBF;EI5iBA;IACE,WAAA;EJ8iBF;AACF;AI7iBA;EACE;IACE,aAAA;EJ+iBF;EI9iBA;IACE,UAAA;EJgjBF;AACF;AI/iBA;EACE;IACE,UAAA;EJijBF;EIhjBA;IACE,SAAA;EJkjBF;AACF;AIjjBA;EACE;IACE,UAAA;EJmjBF;EIljBA;IACE,SAAA;EJojBF;AACF;AInjBA;EACE;IACE,UAAA;EJqjBF;EIpjBA;IACE,UAAA;EJsjBF;AACF;AIrjBA;EACE;IACE,WAAA;IACA,YAAA;EJujBF;EItjBA;IACE,aAAA;IACA,cAAA;EJwjBF;EIvjBA;IACE,WAAA;IACA,YAAA;EJyjBF;AACF;AKlnBA;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,oCAAA;ALonBF;;AKlnBA;EACE,UAAA;ALqnBF;;AKnnBA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;ALsnBF;;AKpnBA;EACE,YAAA;ALunBF;;AKrnBA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;ALwnBF;;AKtnBA;EACE,YAAA;ALynBF;;AKvnBA;EACE,oBAAA;AL0nBF;;AKxnBA;EACE,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,kCAAA;EACA,+BAAA;EACA,uCAAA;EACA,gCAAA;EACA,2CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AL2nBF;;AKznBA;EACE,oBAAA;AL4nBF;;AK1nBA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;AL6nBF;;AK3nBA;EACE,UAAA;EACA,+BAAA;EACA,iBAAA;EACA,oBAAA;AL8nBF;;AK5nBA;EACE,sBAAA;AL+nBF;;AK7nBA;EACE,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;ALgoBF;;AK9nBA;EACE,sBAAA;ALioBF;;AK/nBA;EACE,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,uCAAA;ALkoBF;;AKhoBA;EACE,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;ALmoBF;;AKjoBA;EACE,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;ALooBF;;AKloBA;EACE,kBAAA;EACA,qBAAA;ALqoBF;;AKnoBA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,yCAAA;ALsoBF;;AKpoBA;EACE,wBAAA;ALuoBF;;AKroBA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;ALwoBF;;AM5wBA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,4BAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,4DAAA;EACA,UAAA;AN+wBF;;AM7wBA;EACE,aAAA;EACA,UAAA;EACA,oBAAA;ANgxBF;;AM9wBA;EACE,gBAAA;EACA,2BAAA;ANixBF;;AM/wBA;EACE,gBAAA;EACA,YAAA;ANkxBF;;AMhxBA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,wBAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;ANmxBF;;AMjxBA;EACE,aAAA;ANoxBF;;AMjxBA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;ANoxBF;;AMlxBA;EACE,UAAA;EACA,WAAA;EACA,YAAA;ANqxBF;;AMnxBA;EACE,qCAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;ANsxBF;;AMpxBA;EACE,kBAAA;EACA,sCAAA;ANuxBF;;AMrxBA;EACE,qCAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;ANwxBF;;AMtxBA;EACE,uCAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;ANyxBF;;AMvxBA;EAEE,yBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;ANyxBF;;AMvxBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AN0xBF;;AMxxBA;EACE,oBAAA;EACA,aAAA;AN2xBF;;AMzxBA;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,0CAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AN4xBF;;AM1xBA;EACE,eAAA;AN6xBF;;AM3xBA;EAEE,oBAAA;AN8xBF;;AM5xBA;EACE,WAAA;EACA,kBAAA;EACA,0CAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AN+xBF;;AM7xBA;EACE,cAAA;ANgyBF;;AM9xBA;EACE,UAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;ANiyBF;;AM/xBA;EACE,UAAA;ANkyBF;;AMhyBA;EACE,cAAA;ANmyBF;;AOp7BA;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,oCAAA;APu7BF;;AOr7BA;EACE,UAAA;APw7BF;;AOt7BA;EACE,WAAA;APy7BF;;AOv6BA;EACE,aAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;AP06BF;;AOx6BA;EACE,YAAA;AP26BF;;AOz6BA;EACE,oBAAA;AP46BF;;AO16BA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,0CAAA;EACA,mBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,yBAAA;AP66BF;;AO36BA;EACE,aAAA;AP86BF;;AO56BA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;AP+6BF;;AO76BA;EACE,WAAA;EACA,0CAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;APg7BF;;AO36BA;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,uCAAA;EACA,2CAAA;AP86BF;;AO56BA;EACE,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AP+6BF;;AO76BA;EACE,mCAAA;APg7BF;;AO96BA;EACE,oBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;APi7BF;;AOh7BA;EACE,sCAAA;APm7BF;;AOj7BA;EACE,qCAAA;EACA,iCAAA;APo7BF;;AOl7BA;EACE,WAAA;EACA,6BAAA;APq7BF;;AOn7BA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,mCAAA;APs7BF;;AOp7BA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;APu7BF;;AOr7BA;EACE,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;APw7BF;;AOt7BA;EACE,uCAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,uCAAA;EACA,uCAAA;APy7BF;;AOv7BA;EACE,mBAAA;AP07BF;;AOx7BA;EACE,cAAA;EACA,2BAAA;EACA,gBAAA;EACA,qCAAA;AP27BF;;AOz7BA;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AP47BF;;AO17BA;EAEE,WAAA;EACA,mBAAA;EACA,eAAA;AP47BF;;AQtmCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oCAAA;EACA,UAAA;EACA,wBAAA;ARymCF;;AQvmCA;EACE,UAAA;EACA,oBAAA;AR0mCF;;AQvmCA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;EACA,wBAAA;EACA,UAAA;AR0mCF;;AQxmCA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AR2mCF;;AQzmCA;EACE,UAAA;AR4mCF;;AQ1mCA;EACE,gBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;AR6mCF;;AQ3mCA;EACE,2BAAA;EACA,kCAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AR8mCF;;AQ5mCA;EACE,oBAAA;EACA,kBAAA;EACA,2BAAA;AR+mCF;;AQ7mCA;EACE,iBAAA;EACA,wBAAA;ARgnCF;;AQ9mCA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;ARinCF;AQhnCE;EACE,WAAA;EACA,aAAA;EACA,WAAA;EACA,4BAAA;ARknCJ;;AQhnCA;EACE,kBAAA;EACA,qBAAA;EACA,uBAAA;ARmnCF;;AQjnCA;EACE,kCAAA;EACA,qBAAA;EACA,sCAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;ARonCF;;AQlnCA;EACE,2BAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;ARqnCF;;AQnnCA;EACE,yCAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;ARsnCF;;AQpnCA;EACE,4BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,sCAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;ARunCF;;AQrnCA;EACE,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;ARwnCF;;AQtnCA;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;ARynCF;;AQvnCA;EACE,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;AR0nCF;;AQxnCA;EACE,qBAAA;EACA,cAAA;AR2nCF;;AQznCA;EACE,eAAA;EACA,WAAA;AR4nCF;;AQ1nCA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;AR6nCF;;AQ3nCA;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AR8nCF;;AQ5nCA;EAEE,WAAA;EACA,sBAAA;AR8nCF;;AQ5nCA;EACE,sBAAA;AR+nCF;;AQ7nCA;EACE,mBAAA;EACA,qBAAA;EACA,sBAAA;ARgoCF;;AQ9nCA;EACE,mBAAA;EACA,qBAAA;ARioCF;;AQ9nCA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;ARioCF;;AQ/nCA;EACE,mBAAA;ARkoCF;;AQhoCA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;ARmoCF;;AQjoCA;EACE,aAAA;EACA,WAAA;EACA,iCAAA;EACA,qEAAA;ARooCF;;AQloCA;EACE,cAAA;EACA,0BAAA;ARqoCF;;AQnoCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,WAAA;ARsoCF;;AQpoCA;EAEE,YAAA;EACA,WAAA;EACA,sBAAA;EACA,+BAAA;EACA,uBAAA;EACA,uCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,4EAAA;ARsoCF;;AQpoCA;EACE,2BAAA;ARuoCF;;AQpoCA;EACE,aAAA;ARuoCF;;AQroCA;EACE,UAAA;EACA,mBAAA;ARwoCF;;AQtoCA;EACE,WAAA;EACA,WAAA;ARyoCF;;AQtoCA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,wBAAA;EACA,oBAAA;EACA,gBAAA;ARyoCF;AQvoCE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,sJAAA;EACA,oBAAA;ARyoCJ;;AQvoCA;EACE,WAAA;EACA,8BAAA;EACA,QAAA;AR0oCF;AQzoCE;EACE,wJAAA;AR2oCJ;;AQxoCA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,iDAAA;AR2oCF;;AQzoCA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AR4oCF;;AQ1oCA;EACE,gBAAA;EACA,cAAA;EACA,aAAA;AR6oCF;;AQ3oCA;EACE,WAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AR8oCF;;AQ5oCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AR+oCF;;AQ7oCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,+DAAA;ARgpCF;;AQ/oCA;EACE,UAAA;EACA,YAAA;ARkpCF;;AQjpCA;EACE,UAAA;EACA,WAAA;ARopCF;;AQlpCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;EACA,+DAAA;ARqpCF;;AQppCA;EACE,SAAA;EACA,UAAA;ARupCF;;AQrpCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,+DAAA;ARwpCF;;AQvpCA;EACE,SAAA;EACA,UAAA;AR0pCF;;AQxpCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EAEA,wBAAA;AR0pCF;;AQxpCA;EACE,wBAAA;AR2pCF;;AQzpCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AR4pCF;;AQ1pCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AR6pCF;;AQ5pCA;EACE,UAAA;AR+pCF;;ASjhDA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oCAAA;ATohDJ;;ASlhDA;EACI,UAAA;EACA,oBAAA;ATqhDJ;;ASnhDA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;ATshDJ;;ASphDA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;ATuhDJ;;ASrhDA;EACI,kBAAA;ATwhDJ;;AU7iDA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;EACA,+BAAA;EACA,uCAAA;EACA,gCAAA;EACA,kCAAA;EACA,SAAA;EACA,6BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AVgjDF;;AU9iDA;EACE,eAAA;EACA,aAAA;AVijDF;;AU/iDA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AVkjDF;;AUhjDA;EACE,aAAA;EACA,cAAA;AVmjDF;;AUjjDA;EACE,2BAAA;AVojDF;;AUljDA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;AVqjDF;;AUnjDA;EACE,eAAA;EACA,eAAA;AVsjDF;;AUpjDA;EACE,UAAA;EACA,uCAAA;EACA,WAAA;AVujDF;;AUrjDA;EACE,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,kBAAA;AVwjDF;;AUtjDA;EACE,kBAAA;EACA,qBAAA;AVyjDF;;AUvjDA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;EACA,6BAAA;AV0jDF;;AUxjDA;EACE,eAAA;EACA,wBAAA;EACA,eAAA;EACA,mCAAA;EACA,qBAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;AV2jDF;;AUzjDA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,sBAAA;EACA,wBAAA;EACA,+DAAA;EACA,mCAAA;AV4jDF;;AU1jDA;EACE;IACE,UAAA;EV6jDF;EU5jDA;IACE,wBAAA;IACA,UAAA;EV8jDF;EU7jDA;IACE,2BAAA;IACA,UAAA;EV+jDF;AACF;AU9jDA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,6BAAA;EACA,8BAAA;AVgkDF;;AU9jDA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,6BAAA;EACA,kCAAA;AVikDF;;AU/jDA;EACE,8BAAA;AVkkDF;;AUhkDA;EACE,kCAAA;AVmkDF;;AUjkDA;EACE;IACE,gCAAA;EVokDF;EUnkDA;IACE,+BAAA;EVqkDF;EUpkDA;IACE,gCAAA;EVskDF;AACF;AUrkDA;EACE;IACE,gCAAA;EVukDF;EUtkDA;IACE,+BAAA;EVwkDF;EUvkDA;IACE,gCAAA;EVykDF;AACF;AUvkDA;EACE,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,oCAAA;EACA,oBAAA;AVykDF;;AUvkDA;EACE,8CAAA;AV0kDF;;AUxkDA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,2BAAA;EACA,+BAAA;EACA,uCAAA;EACA,uCAAA;EACA,+BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,4EAAA;AV2kDF;AU1kDE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yCAAA;AV4kDJ;;AU1kDA;EACE,kCAAA;AV6kDF;;AU1kDE;EACE,yBAAA;AV6kDJ;;AU3kDA;EACE,oBAAA;EACA,YAAA;EACA,cAAA;EACA,2BAAA;EACA,+BAAA;EACA,uCAAA;EACA,gCAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,oCAAA;AV8kDF;;AU5kDA;EACE,UAAA;AV+kDF;;AU7kDA;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;AVglDF;;AU9kDA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uCAAA;AVilDF;;AU/kDA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;AVklDF;;AUhlDA;EACE,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;AVmlDF;;AUjlDA;EACE,gBAAA;AVolDF;;AUllDA;EACE,oBAAA;EACA,UAAA;EACA,gCAAA;AVqlDF;;AUnlDA;EACE,mBAAA;EACA,UAAA;EACA,gCAAA;AVslDF;;AUplDA;EACE;IACE,UAAA;EVulDF;EUtlDA;IACE,UAAA;EVwlDF;EUvlDA;IACE,UAAA;EVylDF;AACF;AW51DA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,+BAAA;EACA,uCAAA;EACA,UAAA;EACA,oCAAA;AX81DF;;AW51DA;EACE,oBAAA;EACA,UAAA;EAEA,kBAAA;EACA,+DAAA;AX81DF;;AW31DA;;EAEE,+BAAA;AX81DF;;AW51DA;EACE,kBAAA;EACA,6BAAA;EACA,2BAAA;EACA,kBAAA;EAEA,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,8DAAA;EACA,UAAA;EACA,oBAAA;AX81DF;;AW51DA;EACE,UAAA;EACA,oBAAA;AX+1DF;;AW71DA;EACE,UAAA;AXg2DF;;AW91DA;EACE,sBAAA;EACA,6BAAA;EACA,mBAAA;EACA,OAAA;EACA,uCAAA;EACA,mBAAA;EACA,uBAAA;AXi2DF;;AW91DA;EACE,0BAAA;EACA,eAAA;EACA,2BAAA;EACA,gCAAA;EACA,kCAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AXi2DF;;AW/1DA;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AXk2DF;;AWh2DA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AXm2DF;;AWj2DA;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AXo2DF;;AWl2DA;EACE,6BAAA;EACA,YAAA;EACA,sBAAA;EACA,uCAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,0CAAA;AXq2DF;;AWn2DA;EACE,2BAAA;AXs2DF;;AWp2DA;EACE,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AXu2DF;;AWp2DA;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AXu2DF;;AWr2DA;EACE,2BAAA;AXw2DF;;AWt2DA;EACE,mBAAA;EACA,+BAAA;EACA,eAAA;EACA,2DAAA;AXy2DF;;AWv2DA;EACE,uBAAA;AX02DF;;AWv2DA;EACE,UAAA;EACA,2BAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AX02DF;;AWx2DA;EACE,0BAAA;AX22DF;;AWz2DA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kCAAA;AX42DF;;AW12DA;EACE,UAAA;EACA,2BAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;AX62DF;;AW32DA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,+BAAA;EACA,uCAAA;EACA,gCAAA;EACA,kCAAA;EACA,oBAAA;AX82DF;;AW52DA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AX+2DF;;AW72DA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uCAAA;EACA,+BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;AXg3DF;AW/2DE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AXi3DJ;;AW/2DA;EACE,2BAAA;AXk3DF;;AW/2DE;EACE,yBAAA;AXk3DJ;;AWh3DA;EACE,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kCAAA;AXm3DF;;AWj3DA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uCAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,0CAAA;AXo3DF;;AWl3DA;EACE,2BAAA;AXq3DF;;AWn3DA;EACE,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AXs3DF;;AY3lEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,4BAAA;EACA,sBAAA;EACA,+BAAA;EACA,iBAAA;EACA,UAAA;EACA,oCAAA;AZ8lEF;;AY5lEA;EACE,UAAA;EACA,oBAAA;AZ+lEF;;AY7lEA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AZgmEF;;AY9lEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AZimEF;;AY/lEA;EACE,iCAAA;EACA,iBAAA;EACA,qBAAA;AZkmEF;;AYhmEA;EACE,aAAA;EACA,UAAA;AZmmEF;;AYjmEA;EACE,cAAA;EACA,wCAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AZomEF;;AYlmEA;EACE,yCAAA;EACA,gBAAA;AZqmEF;;AYnmEA;EACE,cAAA;EACA,wCAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AZsmEF;;AYpmEA;EACE,wCAAA;AZumEF;;AYrmEA;EACE,aAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,wBAAA;AZwmEF;;AYvmEA;EACE,UAAA;EACA,qBAAA;AZ0mEF;;AYxmEA;EACE,WAAA;EACA,WAAA;EACA,mBAAA;AZ2mEF;;AYzmEA;EACE,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AZ4mEF;;AY1mEA;EACE,oBAAA;AZ6mEF;;AY3mEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,4BAAA;EACA,oCAAA;EACA,+CAAA;EACA,+CAAA;EACA,oBAAA;EAEA,uCAAA;EACA,cAAA;EACA,wCAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;AZ6mEF;;AY3mEA;EACE,4BAAA;EACA,qCAAA;EACA,gCAAA;AZ8mEF;;AY5mEA;EACE,+CAAA;EACA,eAAA;AZ+mEF;;Aa/tEA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;AbkuEF;;AahuEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sCAAA;EACA,2BAAA;EACA,oBAAA;AbmuEF;;AajuEA;EACE,wBAAA;EACA,UAAA;AbouEF;;AcxvEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,UAAA;EACA,oCAAA;Ad2vEF;;AczvEA;EACE,UAAA;EACA,oBAAA;Ad4vEF;;Ac1vEA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;Ad6vEF;;Ac3vEA;EACE,cAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,mDAAA;Ad8vEF;;Ac5vEA;EACE,gBAAA;EACA,qBAAA;Ad+vEF;;Ac7vEA;EACE,gBAAA;EACA,UAAA;EACA,WAAA;AdgwEF;;Ac9vEA;EACE,gBAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;AdiwEF;;Ac/vEA;EACE,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;AdkwEF;;AchwEA;EACE,kBAAA;EACA,qBAAA;AdmwEF;;AcjwEA;EACE,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kCAAA;AdowEF;;AclwEA;EACE;IACE,aAAA;EdqwEF;EcpwEA;IACE,UAAA;EdswEF;AACF;Ae50EA;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0DAAA;EACA,0BAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,UAAA;EACA,oCAAA;EACA,oBAAA;Af80EF;;Ae50EA;EACE,UAAA;EACA,oBAAA;Af+0EF;;Ae70EA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,sBAAA;Afg1EF;;Ae90EA;EACE,2BAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;Afi1EF;;Aeh1EA;EACE,UAAA;EACA,WAAA;EACA,0GAAA;Afm1EF;;Aej1EA;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,oCAAA;EACA,2BAAA;EACA,gBAAA;EACA,qCAAA;EACA,WAAA;Afo1EF;;Aej1EA;EACE,+BAAA;Afo1EF;;Aeh1EA;EACE,sBAAA;EACA,kBAAA;Afm1EF;;Aej1EA;EACE,eAAA;Afo1EF;;Ael1EA;EACE,WAAA;Afq1EF;;Ael1EA;EACE,iBAAA;Afq1EF;;Aen1EA;EACE,sBAAA;Afs1EF;;AgBl6EA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AhBq6EF;;AgBh6EA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;AhBm6EF;;AgBj6EA;EACE,kBAAA;EACA,6BAAA;AhBo6EF;;AgBl6EA;EACE,UAAA;AhBq6EF;;AiB17EA;EACE,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,uBAAA;EACA,oBAAA;EACA,UAAA;EACA,iEAAA;AjB67EF;;AiB37EA;EACE,YAAA;EACA,UAAA;AjB87EF;;AiB57EA;EACE,YAAA;EACA,iCAAA;EACA,+BAAA;EACA,uCAAA;AjB+7EF;;AiB77EA;EACE,UAAA;AjBg8EF;;AiB77EA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AjBg8EF;;AiB97EA;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,4BAAA;AjBi8EF;;AiB/7EA;EACE,UAAA;EACA,WAAA;AjBk8EF;;AiBh8EA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AjBm8EF;;AiBj8EA;EACE,aAAA;EACA,cAAA;EACA,kCAAA;AjBo8EF;;AiBl8EA;EAEE,sBAAA;EACA,qBAAA;AjBo8EF;;AiBn8EA;EAEE,sBAAA;EACA,oBAAA;AjBq8EF;;AiBp8EA;EAEE,mBAAA;EACA,qBAAA;AjBs8EF;;AiBr8EA;EAEE,mBAAA;EACA,oBAAA;AjBu8EF;;AiBr8EA;;;;EAIE,cAAA;EACA,eAAA;AjBw8EF;;AiBr8EA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,qBAAA;EACA,eAAA;EACA,oBAAA;AjBw8EF;;AiBt8EA;EACE,WAAA;EACA,uBAAA;EACA,uBAAA;AjBy8EF;;AiBv8EA;EACE,oBAAA;AjB08EF;;AiBx8EA;EACE,YAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AjB28EF;;AiBz8EA;EACE,cAAA;EACA,cAAA;EACA,qBAAA;AjB48EF;;AiB18EA;EACE,YAAA;EACA,eAAA;EACA,qDAAA;AjB68EF;;AiB38EA;EACE,sBAAA;EACA,uDAAA;AjB88EF;;AiB58EA;EACE,iBAAA;EACA,qBAAA;EACA,2BAAA;EACA,+BAAA;EACA,uCAAA;EACA,gCAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;AjB+8EF;;AiB78EA;EACE,uBAAA;EACA,mBAAA;EACA,qBAAA;AjBg9EF;;AiB78EA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,oBAAA;AjBg9EF;;AiB98EA;EACE,oBAAA;AjBi9EF;;AiB/8EA;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AjBk9EF;;AiBh9EA;EACE,UAAA;EACA,YAAA;EACA,sBAAA;AjBm9EF;;AiBj9EA;EACE,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,kCAAA;EACA,gCAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AjBo9EF;;AiBl9EA;EACE,WAAA;EACA,eAAA;EACA,eAAA;AjBq9EF;;AiBn9EA;EACE,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AjBs9EF;;AiBp9EA;EACE,WAAA;EACA,cAAA;AjBu9EF;;AiBr9EA;EACE,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AjBw9EF;;AiBt9EA;EACE,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;AjBy9EF;;AiBv9EA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;AjB09EF;;AiBx9EA;EACE,aAAA;AjB29EF;;AiBz9EA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AjB49EF;;AiB19EA;EAEE,0BAAA;EACA,mDAAA;EACA,yDAAA;AjB49EF;;AiB19EA;EACE,kCAAA;EACA,sDAAA;AjB69EF;;AiB39EA;EAEE,uCAAA;EACA,0CAAA;AjB69EF;;AiB39EA;EACE,2BAAA;AjB89EF;;AiB59EA;;EAEE,eAAA;AjB+9EF;;AiB79EA;;EAEE,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;AjBg+EF;;AiB99EA;EACE,oBAAA;AjBi+EF;;AiB/9EA;EACE,qBAAA;AjBk+EF;;AiBh+EA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,+BAAA;EACA,uCAAA;EACA,uCAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;AjBm+EF;;AiBj+EA;EACE,oBAAA;AjBo+EF;;AiBl+EA;EACE,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AjBq+EF;;AkB1vFA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oCAAA;AlB6vFF;;AkB3vFA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AlB8vFF;;AkB5vFA;EACE,UAAA;EACA,oBAAA;AlB+vFF;;AkB5vFA;;EAEE,+BAAA;AlB+vFF;;AkB7vFA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AlBgwFF;;AkB7vFA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,UAAA;EACA,oCAAA;AlBgwFF;;AkB9vFA;EACE,UAAA;AlBiwFF;;AkB/vFA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AlBkwFF;;AkBhwFA;EACE,kBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;AlBmwFF;;AkBjwFA;;EAEE,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,+BAAA;EACA,uCAAA;EACA,uCAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;EACA,4EAAA;AlBowFF;;AkBlwFA;;EAEE,kCAAA;AlBqwFF;;AkBnwFA;EACE,YAAA;EACA,qBAAA;AlBswFF;;AkBpwFA;EACE,eAAA;EACA,gBAAA;AlBuwFF;;AkBrwFA;EACE,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AlBwwFF;;AkBtwFA;EACE,eAAA;AlBywFF;AkBxwFE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AlB0wFJ;;AkBvwFA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,uDAAA;EACA,sBAAA;EACA,OAAA;EACA,2BAAA;EACA,+BAAA;EACA,uCAAA;EACA,gCAAA;EACA,kCAAA;EACA,oCAAA;AlB0wFF;;AkBvwFA;EACE,gDAAA;AlB0wFF;;AkBxwFA;EACE,kBAAA;EACA,YAAA;EACA,+BAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AlB2wFF;;AkBzwFA;EACE,aAAA;EACA,sBAAA;AlB4wFF;;AkB1wFA;EACE,QAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;AlB6wFF;;AkB3wFA;EACE,QAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kCAAA;EACA,yBAAA;AlB8wFF;AkB7wFE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,4BAAA;AlB+wFJ;;AkB7wFA;EACE,QAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AlBgxFF;;AkB7wFA;EACE,mBAAA;AlBgxFF;;AkB9wFA;;EAEE,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kCAAA;EACA,yBAAA;EACA,uBAAA;AlBixFF;;AkB9wFA;EACE,aAAA;EACA,QAAA;EACA,YAAA;EACA,gCAAA;EACA,+BAAA;AlBixFF;;AkB/wFA;EACE,SAAA;EACA,YAAA;EACA,eAAA;AlBkxFF;;AkBhxFA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,0CAAA;AlBmxFF;;AkBjxFA;EACE,2BAAA;AlBoxFF;;AkBlxFA;EACE,0BAAA;AlBqxFF;;AkBnxFA;EACE,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,qCAAA;AlBsxFF;;AkBpxFA;EACE,oBAAA;AlBuxFF;;AkBpxFA;EACE,mBAAA;AlBuxFF;;AkBrxFA;EACE,aAAA;EACA,sBAAA;AlBwxFF;;AkBpxFA;EACE,aAAA;EACA,eAAA;EAEA,cAAA;AlBsxFF;;AkBpxFA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AlBuxFF;AkBtxFE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,mDAAA;EACA,UAAA;EACA,qBAAA;EACA,8DAAA;AlBwxFJ;;AkBtxFA;;EAEE,UAAA;EACA,mBAAA;AlByxFF;;AkBtxFA;EACE,UAAA;EACA,qBAAA;AlByxFF;;AkBvxFA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AlB0xFF;;AkBxxFA;EACE,kBAAA;EACA,oCAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AlB2xFF;;AkBxxFA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AlB2xFF;;AkBzxFA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,uBAAA;EACA,uCAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,4EAAA;AlB4xFF;;AkB1xFA;EACE,2BAAA;AlB6xFF;;AkB3xFA;EACE,mBAAA;AlB8xFF;;AkB5xFA;EACE,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AlB+xFF;;AkB5xFA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AlB+xFF;;AkB7xFA;EACE,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;AlBgyFF;;AkB7xFA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AlBgyFF;;AkB9xFA;EACE,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kCAAA;EACA,yBAAA;EACA,uBAAA;AlBiyFF;;AkB/xFA;EACE,aAAA;EACA,QAAA;EACA,YAAA;EACA,gCAAA;EACA,+BAAA;AlBkyFF;;AkBhyFA;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AlBmyFF;;AkBjyFA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,0CAAA;AlBoyFF;;AkBlyFA;EACE,2BAAA;AlBqyFF;;AkBnyFA;EACE,0BAAA;AlBsyFF;;AkBpyFA;EACE,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qCAAA;AlBuyFF;;AkBryFA;EACE,oBAAA;AlBwyFF;;AkBtyFA;EACE,oBAAA;EACA,mBAAA;AlByyFF;;AkBvyFA;EACE,oBAAA;AlB0yFF;;AkBxyFA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AlB2yFF;;AkBzyFA;EACE,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kCAAA;EACA,yBAAA;EACA,mBAAA;AlB4yFF;;AkB1yFA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;AlB6yFF;;AkB3yFA;EACE,aAAA;AlB8yFF;;AkB5yFA;EACE,UAAA;EACA,eAAA;EACA,uCAAA;EACA,+BAAA;EACA,eAAA;EACA,eAAA;EACA,0CAAA;AlB+yFF;;AkB7yFA;EACE,0BAAA;AlBgzFF;;AkB7yFA;EACE;IACE,UAAA;ElBgzFF;EkB/yFA;IACE,UAAA;ElBizFF;AACF;AmBhuGA;EAGE,eAAA;EACA,QAAA;EACA,wBAAA;EACA,UAAA;EACA,oCAAA;AnBguGF;;AmB9tGA;EACE,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,+DAAA;AnBiuGF;AmBhuGE;EACE,+BAAA;AnBkuGJ;;AmB/tGA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;AnBkuGF;;AmBhuGA;EACE,kBAAA;EACA,QAAA;AnBmuGF;;AmBjuGA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;AnBouGF;;AmBluGA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,oCAAA;EACA,uBAAA;AnBquGF;;AmBnuGA;EACE,UAAA;AnBsuGF;;AmBpuGA;EACE,mBAAA;AnBuuGF;;AmBpuGA;EACE,kBAAA;EACA,cAAA;EAEA,iDAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,+BAAA;EACA,uCAAA;EACA,gCAAA;EACA,kCAAA;EACA,oCAAA;AnBsuGF;;AmBpuGA;EACE,SAAA;AnBuuGF;;AmBruGA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AnBwuGF;;AmBtuGA;EACE,UAAA;AnByuGF;;AmBvuGA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uCAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,0CAAA;AnB0uGF;AmBzuGE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AnB2uGJ;;AmBzuGA;EACE,2BAAA;AnB4uGF;;AmB1uGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AnB6uGF;;AmB3uGA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AnB8uGF;;AmB5uGA;EACE,aAAA;EACA,WAAA;EACA,4BAAA;EACA,qEAAA;AnB+uGF;;AmB7uGA;EACE,cAAA;EACA,0BAAA;AnBgvGF;;AmB9uGA;EACE,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kCAAA;AnBivGF;;AoBl3GA;ECAE;IACE,8BAAA;IACA,eAAA;IACA,mBAAA;IACA,uBAAA;IACA,wBAAA;ErBs3GF;EqBp3GA;IACE,uBAAA;IACA,oBAAA;IACA,8BAAA;ErBs3GF;EqBp3GA;IACE,wBAAA;IACA,yBAAA;IACA,8BAAA;ErBs3GF;EqBp3GA;IACE,uBAAA;IACA,wBAAA;ErBs3GF;EqBr3GA;IACE,gBAAA;ErBu3GF;EqBr3GA;IACE,eAAA;IACA,mBAAA;ErBu3GF;EqBr3GA;IACE,kBAAA;IACA,oBAAA;ErBu3GF;EqBr3GA;IACE,cAAA;IACA,aAAA;ErBu3GF;EqBr3GA;IACE,cAAA;ErBu3GF;EqBr3GA;IACE,gBAAA;IACA,cAAA;IACA,aAAA;ErBu3GF;EqBr3GA;IACE,eAAA;IACA,oBAAA;IACA,mBAAA;ErBu3GF;EqBr3GA;IACE,eAAA;IACA,mBAAA;ErBu3GF;EqBp3GE;IACE,cAAA;IACA,eAAA;ErBs3GJ;EqBp3GA;IACE,aAAA;ErBs3GF;EqBp3GA;IACE,kBAAA;IACA,qBAAA;ErBs3GF;EqBp3GA;IACE,YAAA;ErBs3GF;EqBp3GA;IACE,oBAAA;IACA,iBAAA;ErBs3GF;EqBp3GA;IACE,kBAAA;IACA,oBAAA;IACA,sBAAA;ErBs3GF;EqBp3GA;IACE,eAAA;IACA,mBAAA;ErBs3GF;EqBp3GA;IACE,aAAA;IACA,cAAA;IACA,SAAA;IACA,WAAA;ErBs3GF;EqBp3GA;IACE,gBAAA;IACA,sBAAA;ErBs3GF;EqBp3GA;IACE,kBAAA;ErBs3GF;EqBp3GA;IACE,iBAAA;IACA,iBAAA;IACA,mBAAA;ErBs3GF;EqBp3GA;IACE,oBAAA;ErBs3GF;EqBp3GA;IACE,YAAA;ErBs3GF;EqBp3GA;IACE,YAAA;ErBs3GF;EqBp3GA;IACE,YAAA;ErBs3GF;EqBp3GA;IACE,YAAA;IACA,cAAA;ErBs3GF;EqBp3GA;IACE,kBAAA;IACA,oBAAA;ErBs3GF;EqBp3GA;IACE,+BAAA;IACA,YAAA;IACA,iCAAA;ErBs3GF;EqBp3GA;IACE,cAAA;IACA,iBAAA;ErBs3GF;EqBp3GA;IACE,eAAA;IACA,mBAAA;ErBs3GF;EqBn3GA;IACE,WAAA;IACA,YAAA;ErBq3GF;EqBn3GA;IACE,WAAA;IACA,YAAA;ErBq3GF;EqBn3GA;IACE,eAAA;IACA,mBAAA;IACA,mBAAA;ErBq3GF;EqBn3GA;IACE,wCAAA;ErBq3GF;EqBn3GA;IACE,cAAA;IACA,cAAA;IACA,iBAAA;ErBq3GF;EqBn3GA;IACE,iBAAA;IACA,iBAAA;IACA,sBAAA;ErBq3GF;EqBn3GA;IACE,uBAAA;IACA,sBAAA;ErBq3GF;EqBn3GA;IACE,YAAA;IACA,mBAAA;IACA,kBAAA;IACA,kBAAA;ErBq3GF;EqBn3GA;IACE,eAAA;IACA,cAAA;ErBq3GF;EqBn3GA;IACE,kBAAA;IACA,oBAAA;ErBq3GF;EqBn3GA;IACE,kBAAA;IACA,oBAAA;ErBq3GF;EqBn3GA;IACE,gBAAA;ErBq3GF;EqBn3GA;IACE,cAAA;ErBq3GF;EqBn3GA;IACE,kBAAA;IACA,oBAAA;ErBq3GF;EqBn3GA;IACE,WAAA;IACA,YAAA;ErBq3GF;EqBp3GE;IACE,aAAA;IACA,cAAA;ErBs3GJ;AACF","sourcesContent":["@charset \"UTF-8\";\n:root {\n  --av-font: \"AVATRFont\", \"Inter\", -apple-system, \"Helvetica Neue\", Arial, sans-serif;\n  --av-black: #181818;\n  --av-white: #FFFFFF;\n  --av-gray-1: #464646;\n  --av-gray-2: #747474;\n  --av-gray-3: #A3A3A3;\n  --av-gray-4: #D1D1D1;\n  --av-warm-ivory: #FCEDE0;\n  --av-cyber-lime: #B4D719;\n  --av-light-green-1: #ECF5B9;\n  --av-light-green-2: #D9EC74;\n  --av-dark-green-1: #3A534E;\n  --av-dark-green-2: #1E2F2B;\n  --av-select-outline: #E7E7E7;\n  --av-bg: var(--av-black);\n  --av-glass: rgba(24, 24, 24, 0.72);\n  --av-glass-strong: rgba(24, 24, 24, 0.9);\n  --av-blur: blur(20px) saturate(140%);\n  --av-line: var(--av-gray-1);\n  --av-line-strong: var(--av-white);\n  --av-hover: rgba(255, 255, 255, 0.08);\n  --av-text: var(--av-white);\n  --av-text-2: var(--av-gray-4);\n  --av-text-3: var(--av-gray-3);\n  --av-ink: var(--av-black);\n  --av-accent: var(--av-cyber-lime);\n  --av-radius: 4px;\n  --av-radius-lg: 8px;\n  --av-ease: cubic-bezier(.42, 0, 0, 1);\n  --av-tracking: 0.14em;\n  --av-safe: 5rem;\n  --av-sb-left: 1.25rem;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: 0;\n}\n\n::-webkit-scrollbar {\n  height: 4px;\n  width: 4px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.18);\n  border-radius: 1rem;\n}\n\nhtml, body {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  overflow: hidden;\n  overflow: clip;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n}\n\n#root {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\nbody {\n  font-family: var(--av-font) !important;\n  font-weight: 300;\n  color: var(--av-text);\n  background: var(--av-bg);\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.full-app-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background-color: var(--av-bg);\n}\n\n.container-app {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.av-btn-primary {\n  position: relative;\n  height: 40px !important;\n  min-width: 112px;\n  padding: 0 20px;\n  box-sizing: border-box;\n  background: var(--av-white) !important;\n  border: none !important;\n  border-radius: var(--av-radius) !important;\n  cursor: pointer;\n  box-shadow: 0 12px 20px -12px rgba(180, 215, 25, 0);\n  transition: transform 0.2s linear, box-shadow 0.3s linear;\n}\n.av-btn-primary > * {\n  color: var(--av-ink) !important;\n  font-size: 14px !important;\n  line-height: 22px !important;\n  font-weight: 400;\n}\n.av-btn-primary:hover {\n  transform: translate3d(0, -2px, 0);\n  box-shadow: 0 14px 22px -10px rgba(180, 215, 25, 0.85);\n}\n\n@font-face {\n  font-family: \"AVATRFont\";\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src: url(\"../assets/fonts/avatr/AVATRFont-Light.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"AVATRFont\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(\"../assets/fonts/avatr/AVATRFont-Regular.woff2\") format(\"woff2\");\n}\n@font-face {\n  font-family: \"AVATRFont\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(\"../assets/fonts/avatr/AVATRFont-Bold.woff2\") format(\"woff2\");\n}\n.bottombar-full-container {\n  position: absolute;\n  bottom: 0.625rem;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 22.5rem;\n  max-width: calc(100% - 1.25rem);\n  padding-top: 0.25rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-evenly;\n  opacity: 1;\n  background: var(--av-glass);\n  backdrop-filter: var(--av-blur);\n  -webkit-backdrop-filter: var(--av-blur);\n  border: 1px solid var(--av-line);\n  border-radius: var(--av-radius-lg);\n  transition: opacity 0.8s ease-in-out, bottom 0.8s var(--av-ease);\n}\n\n.bottombar-full-container.hidden {\n  bottom: -8rem;\n}\n\n.bottombar-full-container.hiddenhigh {\n  bottom: -13rem;\n}\n\n.bottombar-collapse-btn {\n  width: 2rem;\n  height: 2rem;\n  background: var(--av-glass-strong);\n  border: 1px solid var(--av-line);\n  border-radius: var(--av-radius);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto;\n  cursor: pointer;\n  position: absolute;\n  top: -1rem;\n  right: 1rem;\n}\n.bottombar-collapse-btn img {\n  width: 1rem;\n  height: 1rem;\n  object-fit: contain;\n  transform: rotate(-90deg);\n  transition: transform 0.8s var(--av-ease);\n}\n\n.bottombar-collapse-btn.collapsed img {\n  transform: rotate(90deg);\n}\n\n.bottombar-menu-title {\n  color: var(--av-text);\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 300;\n  margin-top: 0.75rem;\n}\n\n.bottombar-menu-container {\n  width: 100%;\n  height: auto;\n  margin-top: 0.75rem;\n}\n\n.bottombar-menu-view {\n  width: 100%;\n  height: 2.75rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.bottombar-view-content {\n  height: 100%;\n  width: calc(100% - 2rem);\n  margin: 0 1rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.bottombar-view-logo {\n  width: auto;\n  height: 0.6875rem;\n  object-fit: contain;\n}\n\n.bottombar-view-options {\n  display: flex;\n  gap: 4px;\n  padding: 4px;\n  border: 1px solid var(--av-line);\n  border-radius: var(--av-radius);\n}\n\n.bottombar-view-button-container {\n  width: 5.5rem;\n  height: 30px;\n  cursor: pointer;\n}\n\n.bottombar-view-button {\n  width: 100%;\n  height: 100%;\n  border-radius: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.3s var(--av-ease);\n}\n\n.bottombar-view-button.selected {\n  background: var(--av-text);\n}\n\n.bottombar-view-text {\n  color: var(--av-text-2);\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  font-weight: 400;\n}\n\n.bottombar-view-text.selected {\n  color: var(--av-ink);\n}\n\n.bottombar-menu-color {\n  width: 100%;\n  min-height: 2.75rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4px;\n}\n\n.bottombar-color-selection {\n  display: flex;\n  gap: 12px;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.bottombar-color-element {\n  position: relative;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.bottombar-color-element::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  background-color: #E5E5E5;\n  opacity: 0;\n  transform: scale(0.8);\n  transition: opacity 0.3s linear, transform 0.3s var(--av-ease);\n}\n\n.bottombar-color-element.selected::before {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.bottombar-color-img {\n  position: relative;\n  z-index: 1;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  object-fit: contain;\n}\n\n.bottombar-color-text {\n  animation: av-color-name 0.3s linear;\n  width: 100%;\n  color: var(--av-text-2);\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  text-align: center;\n}\n\n.bottombar-scenario {\n  width: 100%;\n  min-height: 2.75rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.bottombar-scenario-title {\n  display: none;\n}\n\n.bottombar-scenario-selection {\n  display: flex;\n  gap: 4px;\n  padding: 4px;\n  width: calc(100% - 2rem);\n  box-sizing: border-box;\n  border: 1px solid var(--av-line);\n  border-radius: var(--av-radius);\n}\n\n.bottombar-scenario-subcontainer {\n  flex: 1;\n  min-width: 0;\n  height: 30px;\n  cursor: pointer;\n}\n\n.bottombar-scenario-element {\n  width: 100%;\n  height: 100%;\n  border-radius: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.3s var(--av-ease);\n}\n\n.bottombar-scenario-element.selected {\n  background: var(--av-text);\n}\n\n.bottombar-scenario-text {\n  color: var(--av-text-2);\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  font-weight: 400;\n}\n\n.bottombar-scenario-text.selected {\n  color: var(--av-ink);\n}\n\n.bottombar-menu-options {\n  width: 100%;\n  height: 3rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.bottombar-options-content {\n  display: flex;\n  width: 90%;\n  gap: 0.5rem;\n  justify-content: center;\n}\n\n.bottombar-options-button {\n  width: 45%;\n  height: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border-radius: var(--av-radius);\n  border: 1px solid var(--av-line-strong);\n}\n\n.bottombar-options-text {\n  color: var(--av-text);\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n}\n\n.bottombar-main-container {\n  width: 100%;\n  height: auto;\n  margin: 0.75rem 0;\n  padding: 0 0.5rem;\n  box-sizing: border-box;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n}\n.bottombar-main-container::-webkit-scrollbar {\n  display: none;\n}\n\n.bottombar-main-container-scroll {\n  min-width: 100%;\n  display: flex;\n  flex-direction: row;\n  gap: 0.25rem;\n}\n\n.bottombar-main-button {\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 3.25rem;\n  padding: 6px 2px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.375rem;\n  border-radius: var(--av-radius);\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: background 0.3s var(--av-ease), border-color 0.3s var(--av-ease);\n}\n\n.bottombar-main-button:hover {\n  background: var(--av-hover);\n}\n\n.bottombar-main-button.selected {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: var(--av-line-strong);\n}\n\n.bottombar-main-button-logo {\n  height: 1rem;\n  width: 1.25rem;\n  object-fit: contain;\n}\n\n.bottombar-main-button-text {\n  color: var(--av-text-2);\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  font-weight: 400;\n  letter-spacing: 0.02em;\n  white-space: normal;\n  text-align: center;\n}\n\n.bottombar-main-button.selected .bottombar-main-button-text {\n  color: var(--av-text);\n}\n\n.bottombar-menu-seat {\n  width: 100%;\n  height: 8rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  pointer-events: none;\n}\n\n.bottombar-menu-seat.enabled {\n  pointer-events: auto;\n}\n\n.bottombar-seat-subcontainer {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.bottombar-seat-title {\n  color: var(--av-text-3);\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  letter-spacing: var(--av-tracking);\n  text-transform: uppercase;\n}\n\n.bottombar-seat-icon-container {\n  width: 100%;\n  height: calc(90% - 1rem);\n  display: flex;\n  margin: 0.5rem 0;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.bottombar-seat-icon-row {\n  width: 100%;\n  height: 45%;\n  display: flex;\n  justify-content: center;\n}\n\n.bottombar-seat-seat-icon {\n  height: calc(100% - 0.2rem);\n  aspect-ratio: 1;\n  border: 1px solid var(--av-line-strong);\n  border-radius: var(--av-radius);\n  margin: 0.125rem;\n  cursor: pointer;\n}\n\n.bottombar-seat-seat-icon.selected {\n  background: var(--av-text);\n}\n\n@keyframes moveToRigth {\n  0% {\n    left: -17.5%;\n  }\n  100% {\n    left: 2rem;\n  }\n}\n@keyframes move {\n  0% {\n    left: 7%;\n    transform: rotate(-10deg);\n  }\n  50% {\n    left: 70%;\n    transform: rotate(25deg);\n  }\n  100% {\n    left: 7%;\n    transform: rotate(-10deg);\n  }\n}\n@keyframes moveDown {\n  0% {\n    top: -5.7rem;\n  }\n  100% {\n    top: 1.7rem;\n  }\n}\n@keyframes moveTop {\n  0% {\n    bottom: -8rem;\n  }\n  100% {\n    bottom: 1%;\n  }\n}\n@keyframes moveDownMobile {\n  0% {\n    top: -4rem;\n  }\n  100% {\n    top: 6rem;\n  }\n}\n@keyframes moveDownMobile4k {\n  0% {\n    top: -4rem;\n  }\n  100% {\n    top: 2rem;\n  }\n}\n@keyframes fade {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes breath {\n  0% {\n    width: 1rem;\n    height: 1rem;\n  }\n  50% {\n    width: 1.2rem;\n    height: 1.2rem;\n  }\n  100% {\n    width: 1rem;\n    height: 1rem;\n  }\n}\n.bullet-full-container {\n  display: flex;\n  position: absolute;\n  width: 100%;\n  height: calc(100% - 3.75rem);\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  pointer-events: none;\n  opacity: 1;\n  transition: opacity 0.8s ease-in-out;\n}\n\n.bullet-full-container.hide {\n  opacity: 0;\n}\n\n.bullet-sidebar-container {\n  position: absolute;\n  display: flex;\n  height: 100%;\n  width: 38rem;\n  max-width: 90%;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.bullet-sidebar-container.portrait {\n  width: 21rem;\n}\n\n.bullet-container {\n  position: absolute;\n  display: flex;\n  width: 100%;\n  height: auto;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.bullet-container.portrait {\n  height: 100%;\n}\n\n.bullet-container.hide {\n  pointer-events: none;\n}\n\n.bullet-container-content {\n  position: relative;\n  width: calc(100% - 2.5rem);\n  height: 15.625rem;\n  max-height: 60%;\n  padding: 1.25rem;\n  border-radius: var(--av-radius-lg);\n  background: var(--av-glass-strong);\n  backdrop-filter: var(--av-blur);\n  -webkit-backdrop-filter: var(--av-blur);\n  border: 1px solid var(--av-line);\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  pointer-events: auto;\n}\n\n.bullet-container-content.hide {\n  pointer-events: none;\n}\n\n.bullet-container-content.portrait {\n  position: absolute;\n  height: 8.5rem;\n  padding: 0.875rem;\n}\n\n.bullet-container-img {\n  width: 48%;\n  border-radius: var(--av-radius);\n  object-fit: cover;\n  margin-right: 1.5rem;\n}\n\n.bullet-container-img.portrait {\n  margin-right: 0.875rem;\n}\n\n.bullet-container-data {\n  width: -webkit-fill-available;\n  display: flex;\n  flex-direction: column;\n  padding-right: 2.25rem;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.bullet-container-data.portrait {\n  padding-right: 1.75rem;\n}\n\n.bullet-container-title {\n  color: var(--av-text);\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n  font-weight: 400;\n  text-align: start;\n  margin-top: 0.25rem;\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--av-line);\n}\n\n.bullet-container-title.portrait {\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.bullet-container-desc {\n  color: var(--av-text-2);\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n  font-weight: 300;\n  text-align: start;\n}\n\n.bullet-container-desc.portrait {\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n}\n\n.bullet-container-banner-button {\n  position: absolute;\n  top: 0.875rem;\n  right: 0.875rem;\n  width: 2.25rem;\n  height: 2.25rem;\n  object-fit: contain;\n  cursor: pointer;\n  transition: transform 0.3s var(--av-ease);\n}\n\n.bullet-container-banner-button:hover {\n  transform: rotate(90deg);\n}\n\n.bullet-container-banner-button.portrait {\n  top: 0.5rem;\n  right: 0.5rem;\n  width: 1.75rem;\n  height: 1.75rem;\n}\n\n.carselection-full-container {\n  position: absolute;\n  width: 15rem;\n  max-width: 85%;\n  height: calc(100% - 3.75rem);\n  right: 0px;\n  background: #F4F7FE;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  transition: opacity 0.8s ease-in-out, right 0.8s ease-in-out;\n  z-index: 1;\n}\n\n.carselection-full-container.hide {\n  right: -15rem;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.carselection-full-container.portrait {\n  width: 11.875rem;\n  height: calc(100% - 2.5rem);\n}\n\n.carselection-full-container.in3dcontainer {\n  width: 11.875rem;\n  height: 100%;\n}\n\n.carselection-close-bg {\n  position: absolute;\n  width: 2.5rem;\n  height: 2.5rem;\n  top: calc(50% - 1.25rem);\n  left: calc(0% - 1.25rem);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #F4F7FE;\n  border-radius: 100%;\n}\n\n.carselection-close-bg.portrait {\n  width: 2.5rem;\n}\n\n.carselection-close-button {\n  width: 80%;\n  height: 80%;\n  background: #FFF;\n  border-radius: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.carselection-close-icon {\n  width: 50%;\n  height: 50%;\n  margin: auto;\n}\n\n.carselection-title {\n  margin: 2.5rem 1.164rem 0rem 1.164rem;\n  font-family: var(--av-font);\n  font-weight: 500;\n  font-size: 1.125rem;\n  color: #00095B;\n  text-align: center;\n}\n\n.carselection-title.portrait {\n  font-size: 0.85rem;\n  margin: 1.25rem 1.677rem 0rem 1.677rem;\n}\n\n.carselection-list {\n  width: calc(100% - 0.25rem - 0.25rem);\n  margin: 0rem 1.164rem 0rem 1.364rem;\n  max-height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.carselection-category {\n  width: calc(100% - 0.914rem - 0.914rem);\n  height: auto;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 1.2rem;\n  margin-bottom: 0.24rem;\n}\n\n.carselection-category-text {\n  margin-bottom: 0.06125rem;\n  font-family: var(--av-font);\n  font-weight: 400;\n  font-size: 0.75rem;\n  color: #84848E;\n}\n\n.carselection-car {\n  width: 100%;\n  height: auto;\n  cursor: pointer;\n}\n\n.carselection-car.disabled {\n  pointer-events: none;\n  cursor: unset;\n}\n\n.carselection-car-image {\n  width: 100%;\n  height: 3.98125rem;\n  margin-top: 0.66375rem;\n  border-radius: 0.625rem 0.625rem 0rem 0rem;\n  border: 1px solid #D3D3D3;\n  background: #D3D3D3;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.carselection-car-image.portrait {\n  height: 3.75rem;\n}\n\n.carselection-car-image.disabled {\n  -webkit-filter: grayscale(1);\n  filter: grayscale(1);\n}\n\n.carselection-car-desc {\n  width: 100%;\n  height: 3.98125rem;\n  border-radius: 0rem 0rem 0.625rem 0.625rem;\n  border: 1px solid #D3D3D3;\n  background: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.carselection-car-desc.portrait {\n  height: 3.5rem;\n}\n\n.carselection-car-desc-text {\n  width: 80%;\n  font-family: var(--av-font);\n  font-weight: 500;\n  font-size: 0.9rem;\n  color: #00095B;\n  text-align: center;\n}\n\n.carselection-car-desc-text.portrait {\n  width: 80%;\n}\n\n.carselection-car-desc-text.disabled {\n  color: #84848E;\n}\n\n.card-full-container {\n  display: flex;\n  position: absolute;\n  width: 100%;\n  height: calc(100% - 3.75rem);\n  justify-content: center;\n  flex-direction: row;\n  pointer-events: none;\n  opacity: 1;\n  transition: opacity 0.8s ease-in-out;\n}\n\n.card-full-container.hide {\n  opacity: 0;\n}\n\n.card-full-container.portrait {\n  width: 100%;\n}\n\n.card-container {\n  display: flex;\n  width: 19.125rem;\n  max-width: 90%;\n  height: auto;\n  flex-direction: column;\n  justify-content: center;\n  pointer-events: auto;\n}\n\n.card-container.portrait {\n  height: 100%;\n}\n\n.card-container.hide {\n  pointer-events: none;\n}\n\n.card-container-banner {\n  width: 100%;\n  height: 10rem;\n  max-height: 80%;\n  border-radius: 0.625rem 0.625rem 0rem 0rem;\n  background: #D3D3D3;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.card-container-banner.portrait {\n  height: 10rem;\n}\n\n.card-container-banner-button {\n  width: 2.5rem;\n  height: 2.5rem;\n  margin-top: 0.2rem;\n  margin-right: 0.2rem;\n  object-fit: contain;\n  cursor: pointer;\n}\n\n.card-container-content {\n  width: 100%;\n  border-radius: 0rem 0rem 0.625rem 0.625rem;\n  background: #F4F7FE;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.card-container-data {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  width: calc(100% - 1.875rem - 1.875rem);\n  margin: 0.625rem 1.875rem 0.625rem 1.875rem;\n}\n\n.card-container-title {\n  font-family: var(--av-font);\n  font-weight: 500;\n  font-size: 1.125rem;\n  color: #00095B;\n}\n\n.card-container-title.portrait {\n  font-size: clamp(0.5rem, 5vw, 1rem);\n}\n\n.card-container-desc {\n  margin-top: 0.625rem;\n  font-family: var(--av-font);\n  font-weight: 300;\n  font-size: 0.75rem;\n  color: #84848E;\n  text-align: start;\n}\n\n.card-container-desc.portrait {\n  font-size: clamp(0.5rem, 5vw, 0.75rem);\n}\n\n.card-container-block {\n  width: calc(100% - 1.28rem - 1.28rem);\n  margin: 0rem 1.28rem 0rem 1.28rem;\n}\n\n.card-container-block-line {\n  width: 100%;\n  border-top: 1px solid #EEEEEE;\n}\n\n.card-container-info {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  margin: 0.625rem 0rem 0.625rem 0rem;\n}\n\n.card-container-info-icon {\n  width: 1.18rem;\n  height: 1.18rem;\n  object-fit: contain;\n}\n\n.card-container-info-desc {\n  font-family: var(--av-font);\n  font-weight: 300;\n  font-size: 0.8rem;\n  color: #84848E;\n  text-align: start;\n  margin-left: 0.82rem;\n}\n\n.card-container-button {\n  width: calc(100% - 2.875rem - 2.875rem);\n  height: 2.375rem;\n  background: #066FEF;\n  border-radius: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin: 1.3rem 2.875rem 0.8rem 2.875rem;\n  transition: background 0.8s ease-in-out;\n}\n\n.card-container-button:hover {\n  background: #00095B;\n}\n\n.card-container-button-text {\n  color: #FFFFFF;\n  font-family: var(--av-font);\n  font-weight: 300;\n  font-size: clamp(0.5rem, 5vw, 0.9rem);\n}\n\n.card-container-close-portrait {\n  width: 100%;\n  height: 4.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.card-close-button-portrait {\n  height: 90%;\n  object-fit: contain;\n  cursor: pointer;\n}\n\n.carousel-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 1;\n  transition: opacity 0.8s ease-in-out;\n  z-index: 1;\n  background: var(--av-bg);\n}\n\n.carousel-container.hide-container {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.carousel-info-card {\n  position: absolute;\n  width: 38%;\n  height: 100%;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  background: var(--av-bg);\n  z-index: 1;\n}\n\n.carousel-info-card.portrait {\n  width: 100%;\n  height: auto;\n  left: unset;\n  bottom: 0;\n}\n\n.carousel-info-card.mobileland {\n  width: 45%;\n}\n\n.carousel-info-header {\n  height: 0.875rem;\n  width: auto;\n  max-width: 60%;\n  object-fit: contain;\n  object-position: left center;\n  margin-top: 2.5rem;\n  margin-left: var(--av-safe);\n  opacity: 0.95;\n}\n\n.carousel-info-desc {\n  margin-left: var(--av-safe);\n  width: calc(100% - var(--av-safe));\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.carousel-info-desc.portrait {\n  margin-left: 1.25rem;\n  margin-top: 1.5rem;\n  width: calc(100% - 1.25rem);\n}\n\n.carousel-info-desc.mobileland {\n  margin-left: 2rem;\n  width: calc(100% - 2rem);\n}\n\n.carousel-info-eyebrow {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: var(--av-text-3);\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  font-weight: 400;\n  letter-spacing: 0.24em;\n  text-transform: uppercase;\n  margin-bottom: 1.25rem;\n}\n.carousel-info-eyebrow::before {\n  content: \"\";\n  width: 1.5rem;\n  height: 1px;\n  background: var(--av-accent);\n}\n\n.carousel-info-eyebrow.portrait {\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  margin-bottom: 0.625rem;\n}\n\n.carousel-info-title {\n  width: calc(100% - var(--av-safe));\n  color: var(--av-text);\n  font-size: clamp(1.75rem, 3.6vw, 3rem);\n  line-height: 1.5;\n  font-weight: 300;\n  letter-spacing: -0.01em;\n  margin-bottom: 2.75rem;\n  margin-right: var(--av-safe);\n}\n\n.carousel-info-title.portrait {\n  width: calc(100% - 1.25rem);\n  font-size: 1.75rem;\n  line-height: 2.625rem;\n  margin-bottom: 1.25rem;\n  margin-right: 1.25rem;\n}\n\n.carousel-info-title.mobileland {\n  font-size: clamp(1.25rem, 2.4vw, 1.75rem);\n  line-height: 1.5;\n  width: calc(100% - 2rem);\n  margin-bottom: 1rem;\n  margin-right: 2rem;\n}\n\n.carousel-info-specs {\n  margin-right: var(--av-safe);\n  margin-bottom: 3rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--av-line);\n  max-width: calc(100% - var(--av-safe));\n  height: 3rem;\n  object-fit: contain;\n  object-position: left center;\n}\n\n.carousel-info-specs.portrait {\n  margin-right: 1.25rem;\n  margin-bottom: 1.25rem;\n  padding-top: 1rem;\n  width: calc(100% - 1.25rem);\n  max-width: unset;\n  height: auto;\n}\n\n.carousel-info-specs.mobileland {\n  margin-right: 2rem;\n  margin-bottom: 1rem;\n  padding-top: 0.75rem;\n  width: calc(100% - 2rem);\n}\n\n.carousel-info-options {\n  margin-right: var(--av-safe);\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.carousel-info-options.portrait {\n  margin-right: 1.25rem;\n  display: block;\n}\n\n.carousel-info-options-buttonnav.portrait {\n  max-width: none;\n  width: 100%;\n}\n\n.carousel-info-options-buttonnav {\n  display: flex;\n  max-width: 60%;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.carousel-info-options-button {\n  width: auto;\n  max-width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 2rem;\n}\n\n.carousel-info-options-button.portrait {\n  width: 100%;\n  margin-bottom: 1.25rem;\n}\n\n.carousel-info-options-button.mobileland {\n  margin-bottom: 0.75rem;\n}\n\n.carousel-info-options-button-text {\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n  letter-spacing: 0.02em;\n}\n\n.carousel-info-options-button-text.portrait {\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n}\n\n.carousel-info-options-bullets {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5rem;\n}\n\n.carousel-info-options-bullets.portrait {\n  margin-bottom: 1rem;\n}\n\n.carousel-bullet-container {\n  height: 1.25rem;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.carousel-bullet {\n  width: 1.5rem;\n  height: 2px;\n  background: var(--av-line-strong);\n  transition: width 0.4s var(--av-ease), background 0.4s var(--av-ease);\n}\n\n.carousel-bullet.selected {\n  width: 2.75rem;\n  background: var(--av-text);\n}\n\n.carousel-info-options-navegation {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-content: center;\n  gap: 0.5rem;\n}\n\n.carousel-info-options-navegation-next {\n  height: 40px;\n  width: 40px;\n  box-sizing: border-box;\n  border-radius: var(--av-radius);\n  background: transparent;\n  border: 1px solid var(--av-line-strong);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: background 0.3s var(--av-ease), border-color 0.3s var(--av-ease);\n}\n\n.carousel-info-options-navegation-next:hover {\n  background: var(--av-hover);\n}\n\n.carousel-info-options-navegation.portrait {\n  display: none;\n}\n\n.carousel-info-options-navegation-icon {\n  width: 45%;\n  object-fit: contain;\n}\n\n.carousel-content-footer {\n  width: 100%;\n  height: 12%;\n}\n\n.carousel-content-image {\n  position: absolute;\n  width: 62%;\n  height: 100%;\n  right: 0;\n  background: var(--av-bg);\n  pointer-events: none;\n  overflow: hidden;\n}\n.carousel-content-image::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(90deg, var(--av-bg) 0%, rgba(24, 24, 24, 0) 22%), linear-gradient(0deg, rgba(24, 24, 24, 0.7) 0%, rgba(24, 24, 24, 0) 30%);\n  pointer-events: none;\n}\n\n.carousel-content-image.portrait {\n  width: 100%;\n  height: calc(100% - 11.875rem);\n  right: 0;\n}\n.carousel-content-image.portrait::after {\n  background: linear-gradient(0deg, var(--av-bg) 0%, rgba(24, 24, 24, 0) 35%), linear-gradient(180deg, rgba(24, 24, 24, 0.55) 0%, rgba(24, 24, 24, 0) 18%);\n}\n\n.carousel-portrait-logo {\n  position: absolute;\n  top: 1.5rem;\n  left: 1.25rem;\n  height: 0.75rem;\n  width: auto;\n  z-index: 1;\n  filter: drop-shadow(0 1px 6px rgba(0, 0, 0, 0.5));\n}\n\n.carousel-seal-container {\n  position: absolute;\n  width: 100%;\n  height: 6.5rem;\n  display: flex;\n  bottom: 0;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n}\n\n.carousel-seal-container.portrait {\n  height: 4.125rem;\n  top: -4.125rem;\n  bottom: unset;\n}\n\n.carousel-seal-container-img {\n  height: 70%;\n  max-width: 90%;\n  object-fit: contain;\n  opacity: 0.9;\n}\n\n.carousel-slide {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.carousel-slide-center {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  opacity: 1;\n  right: 0%;\n  transition: right 0.8s var(--av-ease), opacity 0.8s ease-in-out;\n}\n\n.carousel-slide-center.right {\n  opacity: 0;\n  right: -100%;\n}\n\n.carousel-slide-center.left {\n  opacity: 0;\n  right: 100%;\n}\n\n.carousel-slide-right {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  opacity: 0;\n  right: -100%;\n  transition: right 0.8s var(--av-ease), opacity 0.8s ease-in-out;\n}\n\n.carousel-slide-right.center {\n  right: 0%;\n  opacity: 1;\n}\n\n.carousel-slide-left {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  opacity: 0;\n  right: 100%;\n  transition: right 0.8s var(--av-ease), opacity 0.8s ease-in-out;\n}\n\n.carousel-slide-left.center {\n  right: 0%;\n  opacity: 1;\n}\n\n.carousel-slide-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: 35% 50%;\n}\n\n.carousel-slide-img.portrait {\n  object-position: 50% 50%;\n}\n\n.carousel-load-only {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n}\n\n.carousel-slides {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n}\n\n.carousel-slides.visible {\n  opacity: 1;\n}\n\n.concessionaire-full-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 1;\n  transition: opacity 0.8s ease-in-out;\n}\n\n.concessionaire-full-container.hide {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.concessionaire-panoramic {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.concessionaire-panoramic-frame {\n  width: 100%;\n  height: 100%;\n  border-style: none;\n}\n\n.concessionaire-panoramic-frame.portrait {\n  position: relative;\n}\n\n.drag-animation-container {\n  position: absolute;\n  width: auto;\n  height: 7.25rem;\n  max-height: 50%;\n  background: var(--av-glass);\n  backdrop-filter: var(--av-blur);\n  -webkit-backdrop-filter: var(--av-blur);\n  border: 1px solid var(--av-line);\n  border-radius: var(--av-radius-lg);\n  left: 50%;\n  transform: translate(-50%, 0);\n  bottom: 1.5rem;\n  display: flex;\n  align-items: center;\n}\n\n.drag-animation-container.portrait {\n  height: 7.25rem;\n  bottom: 12rem;\n}\n\n.drag-animation-mouse {\n  position: absolute;\n  width: 1.5rem;\n  height: 2rem;\n  object-fit: contain;\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n  margin-left: 0.5rem;\n}\n\n.drag-animation-mouse.portrait {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.drag-animation-mouse-move {\n  animation: move 8s infinite;\n}\n\n.drag-animation-container-main {\n  position: relative;\n  width: 12rem;\n  height: 100%;\n}\n\n.drag-animation-container-main.portrait {\n  width: 10.44rem;\n  max-width: 100%;\n}\n\n.drag-animation-hr {\n  width: 1px;\n  background-color: var(--av-line-strong);\n  height: 60%;\n}\n\n.drag-animation-text {\n  position: absolute;\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  font-weight: 300;\n  color: var(--av-text-2);\n  width: 85%;\n  left: 50%;\n  bottom: 12%;\n  transform: translate(-50%, 0);\n  text-align: center;\n}\n\n.drag-animation-text.portrait {\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n}\n\n.drag-animation-scroll-downs {\n  position: relative;\n  top: 12%;\n  left: 50%;\n  width: 1.5rem;\n  height: 1.5rem;\n  transform: translate(-50%, 0);\n}\n\n.drag-animation-mousey {\n  width: 0.375rem;\n  padding: 0.375rem 0.5rem;\n  height: 1.25rem;\n  border: 1.25px solid var(--av-text);\n  border-radius: 2.5rem;\n  box-sizing: content-box;\n  display: flex;\n  justify-content: center;\n}\n\n.drag-animation-scroller {\n  width: 2px;\n  height: 8px;\n  border-radius: 2px;\n  background-color: var(--av-accent);\n  animation-name: scroll;\n  animation-duration: 2.2s;\n  animation-timing-function: cubic-bezier(0.15, 0.41, 0.69, 0.94);\n  animation-iteration-count: infinite;\n}\n\n@keyframes scroll {\n  0% {\n    opacity: 0;\n  }\n  10% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(15px);\n    opacity: 0;\n  }\n}\n.drag-animation-mouse-center-top {\n  position: absolute;\n  width: 1.5rem;\n  height: 1.5rem;\n  object-fit: contain;\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n  left: 52.5%;\n  transform: translate(-50%, 0);\n  animation: move-up 8s infinite;\n}\n\n.drag-animation-mouse-center-bottom {\n  position: absolute;\n  width: 1.5rem;\n  height: 1.5rem;\n  object-fit: contain;\n  margin-top: 2rem;\n  margin-bottom: 0.5rem;\n  left: 42.5%;\n  transform: translate(-50%, 0);\n  animation: move-bottom 8s infinite;\n}\n\n.drag-animation-touch-center-top {\n  animation: move-up 4s infinite;\n}\n\n.drag-animation-touch-center-bottom {\n  animation: move-bottom 4s infinite;\n}\n\n@keyframes move-bottom {\n  0% {\n    transform: translate(-45%, -20%);\n  }\n  50% {\n    transform: translate(-150%, 0%);\n  }\n  100% {\n    transform: translate(-45%, -20%);\n  }\n}\n@keyframes move-up {\n  0% {\n    transform: translate(-45%, -20%);\n  }\n  50% {\n    transform: translate(60%, -60%);\n  }\n  100% {\n    transform: translate(-45%, -20%);\n  }\n}\n.car-studio-collapse-container {\n  position: absolute;\n  top: 1.5rem;\n  left: calc(100% + 0.75rem);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  transition: left 0.8s var(--av-ease);\n  pointer-events: none;\n}\n\n.car-studio-collapse-container.collapsed {\n  left: calc(100% + var(--av-sb-left) + 0.75rem);\n}\n\n.car-studio-collapse-btn {\n  width: 40px;\n  height: 40px;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  background: var(--av-glass);\n  backdrop-filter: var(--av-blur);\n  -webkit-backdrop-filter: var(--av-blur);\n  border: 1px solid var(--av-line-strong);\n  border-radius: var(--av-radius);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto;\n  transition: background 0.3s var(--av-ease), border-color 0.3s var(--av-ease);\n}\n.car-studio-collapse-btn img {\n  width: 1.125rem;\n  height: 1.125rem;\n  object-fit: contain;\n  transform: rotate(0deg);\n  transition: transform 0.8s var(--av-ease);\n}\n\n.car-studio-collapse-btn:hover {\n  background: var(--av-glass-strong);\n}\n\n.car-studio-collapse-btn.collapsed img {\n  transform: rotate(180deg);\n}\n\n.car-studio-collapse-tutorial {\n  margin-left: 0.75rem;\n  width: 15rem;\n  height: 4.5rem;\n  background: var(--av-glass);\n  backdrop-filter: var(--av-blur);\n  -webkit-backdrop-filter: var(--av-blur);\n  border: 1px solid var(--av-line);\n  border-radius: var(--av-radius-lg);\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n  opacity: 1;\n  transition: opacity 0.8s ease-in-out;\n}\n\n.car-studio-collapse-tutorial.hide {\n  opacity: 0;\n}\n\n.collapse-animation-icon-container {\n  position: relative;\n  flex-shrink: 0;\n  width: 4.5rem;\n  height: 4.5rem;\n}\n\n.collapse-icon-animation {\n  position: absolute;\n  width: 2rem;\n  height: 2rem;\n  top: 0.875rem;\n  left: 0.75rem;\n  animation: cross-fade-mouse 2s infinite;\n}\n\n.collapse-icon {\n  position: absolute;\n  width: 1.5rem;\n  height: 1.5rem;\n  top: 1.875rem;\n  left: 1.75rem;\n}\n\n.car-studio-collapse-tutorial-text {\n  margin-right: 1rem;\n  color: var(--av-text-2);\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n}\n\n.collapse-animation-text-reduced {\n  font-weight: 300;\n}\n\n.fade-out {\n  pointer-events: none;\n  opacity: 0;\n  transition: all 0.4s ease-in-out;\n}\n\n.fade-in {\n  pointer-events: all;\n  opacity: 1;\n  transition: all 0.4s ease-in-out;\n}\n\n@keyframes cross-fade-mouse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.gallery-full-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: rgba(24, 24, 24, 0.9);\n  backdrop-filter: var(--av-blur);\n  -webkit-backdrop-filter: var(--av-blur);\n  opacity: 1;\n  transition: opacity 0.8s ease-in-out;\n}\n\n.gallery-full-container.hide {\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.8s ease-in-out, visibility 0s linear 0.8s;\n}\n\n.gallery-full-container.hide *,\n.gallery-partial-container:not(.visible) * {\n  pointer-events: none !important;\n}\n\n.gallery-partial-container {\n  position: absolute;\n  width: -webkit-fill-available;\n  height: calc(100% - 2.5rem);\n  margin-top: 2.5rem;\n  left: calc(var(--av-sb-left) + 19.25rem);\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  overflow-y: auto;\n  transition: left 0.8s var(--av-ease), opacity 0.8s ease-in-out;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.gallery-partial-container.visible {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.gallery-partial-container.extended {\n  left: 1rem;\n}\n\n.gallery-partial-container.portrait {\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  left: 0;\n  height: calc(100% - 1.25rem - 0.375rem);\n  margin-top: 1.25rem;\n  margin-bottom: 0.375rem;\n}\n\n.gallery-partial-container-collage-menu {\n  width: calc(100% - 1.5rem);\n  padding: 1rem 0;\n  background: var(--av-glass);\n  border: 1px solid var(--av-line);\n  border-radius: var(--av-radius-lg);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.875rem;\n}\n\n.gallery-partial-container-collage-title {\n  color: var(--av-text);\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 300;\n}\n\n.gallery-partial-container-collage-buttons {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.gallery-partial-container-collage-logo {\n  width: auto;\n  height: 0.75rem;\n  object-fit: contain;\n  margin-left: 1rem;\n  margin-right: 1.5rem;\n}\n\n.gallery-partial-container-collage-button {\n  width: -webkit-fill-available;\n  height: 40px;\n  box-sizing: border-box;\n  border: 1px solid var(--av-line-strong);\n  border-radius: var(--av-radius);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-right: 1rem;\n  transition: background 0.3s var(--av-ease);\n}\n\n.gallery-partial-container-collage-button:hover {\n  background: var(--av-hover);\n}\n\n.gallery-partial-container-collage-button-text {\n  color: var(--av-text);\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n  font-weight: 400;\n}\n\n.gallery-partial-container-collage {\n  width: 90%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.gallery-partial-container-collage.altportrait {\n  height: calc(100% - 7.5rem);\n}\n\n.gallery-collage-image {\n  object-fit: contain;\n  border-radius: var(--av-radius);\n  cursor: pointer;\n  transition: filter 0.6s ease, transform 0.6s var(--av-ease);\n}\n\n.gallery-collage-image:hover {\n  filter: brightness(70%);\n}\n\n.gallery-partial-container-fullpicture {\n  width: 90%;\n  height: calc(100% - 2.5rem);\n  margin-bottom: 2.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.gallery-partial-container-fullpicture.portrait {\n  height: calc(50% - 2.5rem);\n}\n\n.gallery-partial-container-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: var(--av-radius-lg);\n}\n\n.gallery-partial-container-controls {\n  width: 90%;\n  height: calc(100% - 2.5rem);\n  margin-bottom: 2.5rem;\n  display: flex;\n  position: absolute;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  pointer-events: none;\n}\n\n.gallery-container-full-controls {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  width: 14rem;\n  margin-bottom: 1.25rem;\n  padding: 0.875rem;\n  background: var(--av-glass);\n  backdrop-filter: var(--av-blur);\n  -webkit-backdrop-filter: var(--av-blur);\n  border: 1px solid var(--av-line);\n  border-radius: var(--av-radius-lg);\n  pointer-events: auto;\n}\n\n.gallery-container-controls-navigation {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.gallery-container-controls-button {\n  width: 40px;\n  height: 40px;\n  box-sizing: border-box;\n  border: 1px solid var(--av-line-strong);\n  border-radius: var(--av-radius);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.3s var(--av-ease);\n}\n.gallery-container-controls-button img {\n  width: 1.125rem;\n  height: 1.125rem;\n  object-fit: contain;\n}\n\n.gallery-container-controls-button:hover {\n  background: var(--av-hover);\n}\n\n.gallery-container-controls-button.right img {\n  transform: rotate(180deg);\n}\n\n.gallery-container-controls-subtitle {\n  color: var(--av-text-2);\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n  font-weight: 400;\n  letter-spacing: 0.08em;\n  font-variant-numeric: tabular-nums;\n}\n\n.gallery-controls-button {\n  width: 100%;\n  height: 40px;\n  box-sizing: border-box;\n  border: 1px solid var(--av-line-strong);\n  border-radius: var(--av-radius);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.3s var(--av-ease);\n}\n\n.gallery-controls-button:hover {\n  background: var(--av-hover);\n}\n\n.gallery-controls-button-text {\n  color: var(--av-text);\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n  font-weight: 400;\n}\n\n.intro-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: #222222;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center 50%;\n  object-fit: cover;\n  opacity: 1;\n  transition: opacity 0.8s ease-in-out;\n}\n\n.intro-container.hide-container {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.intro-content {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: column;\n}\n\n.intro-top {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.intro-top-title-icon {\n  height: clamp(0.75rem, 6vw, 8rem);\n  margin-top: 11svh;\n  aspect-ratio: 949/230;\n}\n\n.intro-top-title-icon.portrait {\n  height: unset;\n  width: 60%;\n}\n\n.intro-top-title {\n  color: #FFFFFF;\n  font-size: clamp(0.75rem, 5vw, 4.625rem);\n  font-family: var(--av-font);\n  font-weight: 400;\n  text-align: center;\n  margin-top: 11svh;\n}\n\n.intro-top-title.portrait {\n  font-size: clamp(0.75rem, 15vw, 4.625rem);\n  margin-top: 4svh;\n}\n\n.intro-top-subtitle {\n  color: #FFFFFF;\n  font-size: clamp(0.75rem, 2vw, 1.875rem);\n  font-family: var(--av-font);\n  font-weight: 400;\n  text-align: center;\n}\n\n.intro-top-subtitle.portrait {\n  font-size: clamp(0.75rem, 6vw, 1.875rem);\n}\n\n.intro-bottom {\n  display: flex;\n  width: 70%;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin-bottom: 2.3125rem;\n}\n\n.intro-bottom.portrait {\n  width: 95%;\n  margin-bottom: 2.5rem;\n}\n\n.intro-bottom-line {\n  width: 100%;\n  height: 2px;\n  background: #FFFFFF;\n}\n\n.intro-bottom-security {\n  width: 100%;\n  margin-top: 1.25rem;\n  aspect-ratio: 907/96;\n  object-fit: contain;\n}\n\n.intro-bottom-security.portrait {\n  aspect-ratio: 320/46;\n}\n\n.intro-bottom-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2rem;\n  max-width: calc(100% - 4rem);\n  border: 1px solid rgb(238, 103, 103);\n  background: #DD4040 0% 0% no-repeat padding-box;\n  box-shadow: -2px 2px 6px rgba(50, 58, 79, 0.16);\n  border-radius: 10rem;\n  transition: background 0.2s ease-in-out;\n  color: #FFFFFF;\n  font-size: clamp(0.75rem, 2vw, 1.875rem);\n  font-family: var(--av-font);\n  font-weight: 400;\n  text-align: center;\n  padding: 0.5rem 2rem 0.5rem 2rem;\n}\n\n.intro-bottom-button.portrait {\n  max-width: calc(100% - 8rem);\n  font-size: clamp(0.5rem, 5vw, 1.2rem);\n  padding: 0.5rem 4rem 0.5rem 4rem;\n}\n\n.intro-bottom-button:hover {\n  background: #B33131 0% 0% no-repeat padding-box;\n  cursor: pointer;\n}\n\n.full-loading-screen-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  position: absolute;\n  pointer-events: none;\n}\n\n.loading-screen-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 48, 87, 0.6);\n  backdrop-filter: blur(10px);\n  pointer-events: auto;\n}\n\n.loading-screen-container.expand {\n  width: calc(100% - 2rem);\n  left: 2rem;\n}\n\n.loading-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: var(--av-bg);\n  opacity: 1;\n  transition: opacity 0.9s ease-in-out;\n}\n\n.loading-container.hide-container {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.loading-progress {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.loading-post-logo {\n  height: 1.5rem;\n  width: auto;\n  max-width: 60%;\n  object-fit: contain;\n  margin-bottom: 3.5rem;\n  animation: loading-breath 2.4s ease-in-out infinite;\n}\n\n.loading-post-logo.portrait {\n  height: 1.125rem;\n  margin-bottom: 2.5rem;\n}\n\n.loading-progress-bar {\n  max-width: 32rem;\n  width: 70%;\n  height: 2px;\n}\n\n.loading-progress-info {\n  max-width: 32rem;\n  width: 70%;\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.loading-progress-message {\n  color: var(--av-text-3);\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  font-weight: 400;\n  letter-spacing: 0.08em;\n}\n\n.loading-progress-message.portrait {\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n}\n\n.loading-progress-value {\n  color: var(--av-text);\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  font-weight: 400;\n  letter-spacing: 0.08em;\n  font-variant-numeric: tabular-nums;\n}\n\n@keyframes loading-breath {\n  0%, 100% {\n    opacity: 0.55;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n.pdfviewer-global {\n  display: flex;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.8) 0% 0% no-repeat padding-box;\n  backdrop-filter: blur(5px);\n  justify-content: center;\n  align-items: center;\n  z-index: 2;\n  opacity: 0;\n  transition: opacity 0.8s ease-in-out;\n  pointer-events: none;\n}\n\n.pdfviewer-global.visible {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.pdfviewer-menu {\n  display: flex;\n  width: 97.87rem;\n  height: 51.56rem;\n  max-width: 85%;\n  max-height: 85%;\n  background: #fff;\n  border-radius: 10px;\n  justify-content: space-evenly;\n  align-items: center;\n  flex-direction: column;\n}\n\n.pdfviewer-menu.portrait {\n  width: calc(100% - 1.25rem);\n  height: calc(100% - 1.25rem);\n  max-width: unset;\n  max-height: unset;\n}\n\n.pdfviewer-container {\n  width: 99%;\n  height: 90%;\n  --rpv-core__page-layer-box-shadow: 0px 0px 0px 0 rgba(0, 0, 0, 0.0) //para eliminar sombras de las páginas;\n}\n\n.pdfviewer-close-btn {\n  width: 14.1875rem;\n  height: 2.25rem;\n  background: #DD4040;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  cursor: pointer;\n  border: 1px solid rgb(238, 103, 103);\n  font-family: var(--av-font);\n  font-weight: 400;\n  font-size: clamp(0.1rem, 4vw, 0.8rem);\n  color: #fff;\n}\n\n.pdfviewer-close-btn:hover {\n  box-shadow: 0px 0px 6px #000000;\n}\n\n.rpv-default-layout__toolbar {\n  background-color: #fff;\n  border-bottom: 0px;\n}\n\n.rpv-core__icon {\n  stroke-width: 2;\n}\n\n.rpv-default-layout__container {\n  border: 0px;\n}\n\n.rpv-default-layout__sidebar--ltr {\n  border-right: 0px;\n}\n\n.rpv-default-layout__sidebar-headers {\n  background-color: #fff;\n}\n\n.pc-full-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.pc-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  border-style: none;\n  transition: opacity 1s ease;\n}\n\n.pc-container.portrait {\n  position: relative;\n  height: calc(100% + 0.625rem);\n}\n\n.pc-container.visible {\n  opacity: 1;\n}\n\n.screenshot-full-container {\n  position: absolute;\n  width: 100%;\n  height: calc(100% - 3.75rem);\n  background: transparent;\n  pointer-events: none;\n  opacity: 1;\n  transition: opacity 0.8s ease-in-out, background 0.8s ease-in-out;\n}\n\n.screenshot-full-container.portrait {\n  height: 100%;\n  z-index: 1;\n}\n\n.screenshot-full-container.background {\n  height: 100%;\n  background: rgba(24, 24, 24, 0.9);\n  backdrop-filter: var(--av-blur);\n  -webkit-backdrop-filter: var(--av-blur);\n}\n\n.screenshot-full-container.hide {\n  opacity: 0;\n}\n\n.screenshot-reticle-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.screenshot-reticle-rows {\n  width: 55%;\n  height: 68%;\n  display: flex;\n  flex-wrap: wrap;\n  align-content: space-between;\n}\n\n.screenshot-reticle-rows.portrait {\n  width: 90%;\n  height: 50%;\n}\n\n.screenshot-reticle-columns {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.screenshot-reticle-br, .screenshot-reticle-bl, .screenshot-reticle-tr, .screenshot-reticle-tl {\n  width: 2.5rem;\n  height: 2.5rem;\n  border: 1.5px solid var(--av-text);\n}\n\n.screenshot-reticle-tl {\n  border-bottom-width: 0;\n  border-right-width: 0;\n}\n\n.screenshot-reticle-tr {\n  border-bottom-width: 0;\n  border-left-width: 0;\n}\n\n.screenshot-reticle-bl {\n  border-top-width: 0;\n  border-right-width: 0;\n}\n\n.screenshot-reticle-br {\n  border-top-width: 0;\n  border-left-width: 0;\n}\n\n.screenshot-reticle-tl.portrait,\n.screenshot-reticle-tr.portrait,\n.screenshot-reticle-bl.portrait,\n.screenshot-reticle-br.portrait {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n.screenshot-capture-container {\n  position: absolute;\n  height: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-content: center;\n  flex-wrap: wrap;\n  pointer-events: auto;\n}\n\n.screenshot-capture-container.portrait {\n  width: 100%;\n  justify-content: center;\n  align-content: flex-end;\n}\n\n.screenshot-capture-container.hide {\n  pointer-events: none;\n}\n\n.screenshot-capture-center {\n  height: 4rem;\n  margin-left: 1.75rem;\n  display: flex;\n  align-items: center;\n}\n\n.screenshot-capture-center.portrait {\n  height: 3.5rem;\n  margin-left: 0;\n  margin-bottom: 1.5rem;\n}\n\n.screenshot-capture-icon {\n  height: 100%;\n  cursor: pointer;\n  transition: transform 0.2s linear, filter 0.3s linear;\n}\n\n.screenshot-capture-icon:hover {\n  transform: scale(1.05);\n  filter: drop-shadow(0 6px 12px rgba(180, 215, 25, 0.6));\n}\n\n.screenshot-capture-msg {\n  margin-left: 1rem;\n  padding: 0.75rem 1rem;\n  background: var(--av-glass);\n  backdrop-filter: var(--av-blur);\n  -webkit-backdrop-filter: var(--av-blur);\n  border: 1px solid var(--av-line);\n  border-radius: var(--av-radius-lg);\n  display: flex;\n  align-items: center;\n}\n\n.screenshot-capture-text {\n  color: var(--av-text-2);\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n}\n\n.screenshot-preview-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  flex-wrap: wrap;\n  pointer-events: auto;\n}\n\n.screenshot-preview-container.hide {\n  pointer-events: none;\n}\n\n.screenshot-preview-center {\n  width: 80%;\n  height: 80%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.screenshot-preview-center.portrait {\n  width: 90%;\n  height: auto;\n  flex-direction: column;\n}\n\n.screenshot-preview-image {\n  width: 60%;\n  max-height: 100%;\n  aspect-ratio: 905/509;\n  border-radius: var(--av-radius-lg);\n  border: 1px solid var(--av-line);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.screenshot-preview-image.portrait {\n  width: 100%;\n  max-height: 60%;\n  aspect-ratio: 1;\n}\n\n.screenshot-preview-confirmation {\n  width: calc(40% - 4rem);\n  margin-left: 4rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.screenshot-preview-confirmation.portrait {\n  width: 100%;\n  margin-left: 0;\n}\n\n.screenshot-preview-confirmation-title {\n  color: var(--av-text);\n  font-size: 2.25rem;\n  line-height: 3.375rem;\n  font-weight: 300;\n}\n\n.screenshot-preview-confirmation-title.portrait {\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n  text-align: center;\n  margin: 1.25rem 0;\n}\n\n.screenshot-preview-confirmation-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 0.625rem;\n  margin-top: 2.5rem;\n}\n\n.screenshot-preview-confirmation-buttons.portrait {\n  margin-top: 0;\n}\n\n.screenshot-preview-button-retake, .screenshot-preview-button-download {\n  width: 100%;\n  min-width: 112px;\n  max-width: 18rem;\n  height: 40px;\n  box-sizing: border-box;\n  padding: 0 20px;\n  border-radius: var(--av-radius);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.screenshot-preview-button-download {\n  background: var(--av-text);\n  box-shadow: 0 12px 20px -12px rgba(180, 215, 25, 0);\n  transition: transform 0.2s linear, box-shadow 0.3s linear;\n}\n\n.screenshot-preview-button-download:hover {\n  transform: translate3d(0, -2px, 0);\n  box-shadow: 0 14px 22px -10px rgba(180, 215, 25, 0.85);\n}\n\n.screenshot-preview-button-retake {\n  border: 1px solid var(--av-line-strong);\n  transition: background 0.3s var(--av-ease);\n}\n\n.screenshot-preview-button-retake:hover {\n  background: var(--av-hover);\n}\n\n.screenshot-preview-button-download.portrait,\n.screenshot-preview-button-retake.portrait {\n  max-width: 100%;\n}\n\n.screenshot-preview-button-download-text,\n.screenshot-preview-button-retake-text {\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n  font-weight: 400;\n  letter-spacing: 0.02em;\n}\n\n.screenshot-preview-button-download-text {\n  color: var(--av-ink);\n}\n\n.screenshot-preview-button-retake-text {\n  color: var(--av-text);\n}\n\n.screenshot-return-button {\n  position: absolute;\n  margin-left: 1.25rem;\n  margin-top: 1.25rem;\n  height: 40px;\n  box-sizing: border-box;\n  padding: 0 12px;\n  background: var(--av-glass);\n  backdrop-filter: var(--av-blur);\n  -webkit-backdrop-filter: var(--av-blur);\n  border: 1px solid var(--av-line-strong);\n  border-radius: var(--av-radius);\n  display: flex;\n  align-items: center;\n  pointer-events: auto;\n  cursor: pointer;\n}\n\n.screenshot-return-button.hide {\n  pointer-events: none;\n}\n\n.screenshot-return-text {\n  color: var(--av-text);\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n  font-weight: 400;\n}\n\n.studio-full-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 1;\n  transition: opacity 0.8s ease-in-out;\n}\n\n.studio-full-container.portrait {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.studio-full-container.hide {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.studio-full-container.hide *,\n.studio-full-siderbar.hide * {\n  pointer-events: none !important;\n}\n\n.studio-3d-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.studio-full-siderbar {\n  display: flex;\n  position: absolute;\n  height: 100%;\n  left: var(--av-sb-left);\n  align-items: flex-start;\n  flex-direction: column;\n  pointer-events: none;\n  opacity: 1;\n  transition: opacity 0.8s ease-in-out;\n}\n\n.studio-full-siderbar.hide {\n  opacity: 0;\n}\n\n.studio-sidebar-topbar {\n  display: flex;\n  gap: 0.5rem;\n  height: 40px;\n  margin-top: 1.25rem;\n  margin-bottom: 0.75rem;\n  position: relative;\n}\n\n.studio-sidebar-topbar.portrait {\n  position: absolute;\n  height: 40px;\n  margin-left: 1.25rem;\n  margin-top: 1.25rem;\n  margin-bottom: unset;\n  z-index: 2;\n}\n\n.studio-sidebar-topbar-button,\n.studio-sidebar-topbar-music {\n  height: 100%;\n  box-sizing: border-box;\n  background: var(--av-glass);\n  backdrop-filter: var(--av-blur);\n  -webkit-backdrop-filter: var(--av-blur);\n  border: 1px solid var(--av-line-strong);\n  border-radius: var(--av-radius);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  pointer-events: auto;\n  transition: background 0.3s var(--av-ease), border-color 0.3s var(--av-ease);\n}\n\n.studio-sidebar-topbar-button:hover,\n.studio-sidebar-topbar-music:hover {\n  background: var(--av-glass-strong);\n}\n\n.studio-sidebar-topbar-button {\n  gap: 0.25rem;\n  padding: 0 12px 0 8px;\n}\n\n.studio-sidebar-topbar-icon {\n  width: 1.125rem;\n  height: 1.125rem;\n}\n\n.studio-sidebar-topbar-text {\n  color: var(--av-text);\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n  font-weight: 400;\n}\n\n.studio-sidebar-topbar-music {\n  aspect-ratio: 1;\n}\n.studio-sidebar-topbar-music img {\n  width: 1rem;\n  height: 1rem;\n  object-fit: contain;\n  opacity: 0.9;\n}\n\n.studio-sidebar-container {\n  display: flex;\n  flex-direction: column;\n  pointer-events: auto;\n  position: relative;\n  width: 18rem;\n  height: calc(100% - 40px - 1.25rem - 0.75rem - 1.25rem);\n  margin-bottom: 1.25rem;\n  left: 0;\n  background: var(--av-glass);\n  backdrop-filter: var(--av-blur);\n  -webkit-backdrop-filter: var(--av-blur);\n  border: 1px solid var(--av-line);\n  border-radius: var(--av-radius-lg);\n  transition: left 0.8s var(--av-ease);\n}\n\n.studio-sidebar-container.collapsed {\n  left: calc(-18rem - var(--av-sb-left) - 0.75rem);\n}\n\n.studio-sidebar-subcontainer {\n  position: relative;\n  height: 100%;\n  padding: 1.75rem 1.75rem 1.5rem;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.studio-sidebar-header {\n  display: flex;\n  flex-direction: column;\n}\n\n.studio-sidebar-header-logo {\n  order: 0;\n  height: 0.75rem;\n  width: auto;\n  align-self: flex-start;\n  object-fit: contain;\n}\n\n.studio-sidebar-header-subtitle {\n  order: 1;\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  margin-top: 2.5rem;\n  color: var(--av-text-3);\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  font-weight: 400;\n  letter-spacing: var(--av-tracking);\n  text-transform: uppercase;\n}\n.studio-sidebar-header-subtitle::before {\n  content: \"\";\n  width: 1rem;\n  height: 1px;\n  background: var(--av-accent);\n}\n\n.studio-sidebar-header-title {\n  order: 2;\n  margin-top: 0.625rem;\n  color: var(--av-text);\n  font-size: 1.75rem;\n  line-height: 2.625rem;\n  font-weight: 300;\n}\n\n.studio-sidebar-section {\n  margin-top: 2.25rem;\n}\n\n.studio-sidebar-section-title,\n.studio-sidebar-color-title {\n  color: var(--av-text-3);\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  font-weight: 400;\n  letter-spacing: var(--av-tracking);\n  text-transform: uppercase;\n  margin-bottom: 0.875rem;\n}\n\n.studio-sidebar-view {\n  display: flex;\n  gap: 4px;\n  padding: 4px;\n  border: 1px solid var(--av-line);\n  border-radius: var(--av-radius);\n}\n\n.studio-sidebar-view-button-container {\n  flex: 1;\n  height: 30px;\n  cursor: pointer;\n}\n\n.studio-sidebar-view-button {\n  width: 100%;\n  height: 100%;\n  border-radius: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  transition: background 0.3s var(--av-ease);\n}\n\n.studio-sidebar-view-button:hover {\n  background: var(--av-hover);\n}\n\n.studio-sidebar-view-button.selected {\n  background: var(--av-text);\n}\n\n.studio-sidebar-view-text {\n  color: var(--av-text-2);\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n  font-weight: 400;\n  letter-spacing: 0.02em;\n  transition: color 0.3s var(--av-ease);\n}\n\n.studio-sidebar-view-text.selected {\n  color: var(--av-ink);\n}\n\n.studio-sidebar-color {\n  margin-top: 2.25rem;\n}\n\n.studio-sidebar-color-subcontainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.studio-sidebar-color-selection {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -8px;\n}\n\n.studio-sidebar-color-element {\n  position: relative;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.studio-sidebar-color-element::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  background-color: rgba(229, 229, 229, 0.9333333333);\n  opacity: 0;\n  transform: scale(0.8);\n  transition: opacity 0.3s linear, transform 0.3s var(--av-ease);\n}\n\n.studio-sidebar-color-element.selected::before,\n.studio-sidebar-color-element:hover::before {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.studio-sidebar-color-selection:hover .studio-sidebar-color-element.selected:not(:hover)::before {\n  opacity: 0;\n  transform: scale(0.8);\n}\n\n.studio-sidebar-color-img {\n  position: relative;\n  z-index: 1;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: contain;\n}\n\n.studio-sidebar-color-text {\n  margin-top: 0.5rem;\n  animation: av-color-name 0.3s linear;\n  color: var(--av-text);\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 300;\n}\n\n.studio-sidebar-options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: auto;\n  padding-top: 2rem;\n}\n\n.studio-sidebar-options-button {\n  width: 100%;\n  height: 40px;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  background: transparent;\n  border: 1px solid var(--av-line-strong);\n  border-radius: var(--av-radius);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.3s var(--av-ease), border-color 0.3s var(--av-ease);\n}\n\n.studio-sidebar-options-button:hover {\n  background: var(--av-hover);\n}\n\n.studio-sidebar-options-button.av-btn-primary {\n  margin-top: 0.25rem;\n}\n\n.studio-sidebar-options-text {\n  width: 100%;\n  color: var(--av-text);\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n  font-weight: 400;\n  text-align: center;\n}\n\n.studio-sidebar-lights {\n  display: flex;\n  align-items: center;\n  margin-top: 1.5rem;\n}\n\n.studio-sidebar-lights-title {\n  color: var(--av-text);\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n  margin-left: 0.625rem;\n}\n\n.studio-sidebar-scenario-subcontainer {\n  display: flex;\n  flex-direction: column;\n  margin-top: 2.25rem;\n}\n\n.studio-sidebar-scenario-title {\n  color: var(--av-text-3);\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  font-weight: 400;\n  letter-spacing: var(--av-tracking);\n  text-transform: uppercase;\n  margin-bottom: 0.875rem;\n}\n\n.studio-sidebar-scenario-selection {\n  display: flex;\n  gap: 4px;\n  padding: 4px;\n  border: 1px solid var(--av-line);\n  border-radius: var(--av-radius);\n}\n\n.studio-sidebar-scenario-button-container {\n  flex: 1;\n  min-width: 0;\n  height: 30px;\n  cursor: pointer;\n}\n\n.studio-sidebar-scenario-button {\n  width: 100%;\n  height: 100%;\n  border-radius: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  transition: background 0.3s var(--av-ease);\n}\n\n.studio-sidebar-scenario-button:hover {\n  background: var(--av-hover);\n}\n\n.studio-sidebar-scenario-button.selected {\n  background: var(--av-text);\n}\n\n.studio-sidebar-scenario-text {\n  color: var(--av-text-2);\n  font-size: 0.875rem;\n  line-height: 1.375rem;\n  font-weight: 400;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: color 0.3s var(--av-ease);\n}\n\n.studio-sidebar-scenario-text.selected {\n  color: var(--av-ink);\n}\n\n.studio-sidebar-seats {\n  pointer-events: none;\n  margin-top: 2.25rem;\n}\n\n.studio-sidebar-seats.enabled {\n  pointer-events: auto;\n}\n\n.studio-sidebar-seats-subcontainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.studio-sidebar-seats-title {\n  color: var(--av-text-3);\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  letter-spacing: var(--av-tracking);\n  text-transform: uppercase;\n  margin-bottom: 1rem;\n}\n\n.studio-sidebar-icon-container {\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n}\n\n.studio-sidebar-icon-row {\n  display: flex;\n}\n\n.studio-sidebar-seat-icon {\n  width: 45%;\n  aspect-ratio: 1;\n  border: 1px solid var(--av-line-strong);\n  border-radius: var(--av-radius);\n  margin: 0.25rem;\n  cursor: pointer;\n  transition: background 0.3s var(--av-ease);\n}\n\n.studio-sidebar-seat-icon.selected {\n  background: var(--av-text);\n}\n\n@keyframes av-color-name {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.interior-viewer {\n  position: fixed;\n  inset: 0;\n  background: var(--av-bg);\n  opacity: 1;\n  transition: opacity 0.6s ease-in-out;\n}\n\n.interior-viewer.hide {\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n  transition: opacity 0.6s ease-in-out, visibility 0s linear 0.6s;\n}\n.interior-viewer.hide * {\n  pointer-events: none !important;\n}\n\n.interior-viewer.portrait {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 72px 0 216px;\n  box-sizing: border-box;\n}\n\n.interior-viewer-stage {\n  position: absolute;\n  inset: 0;\n}\n\n.interior-viewer-stage.portrait {\n  position: relative;\n  inset: auto;\n  width: 100%;\n  aspect-ratio: 4320/2400;\n}\n\n.interior-viewer-image {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0;\n  transition: opacity 0.6s ease-in-out;\n  -webkit-user-drag: none;\n}\n\n.interior-viewer-image.visible {\n  opacity: 1;\n}\n\n.interior-viewer-image.portrait {\n  object-fit: contain;\n}\n\n.interior-viewer-controls {\n  position: absolute;\n  bottom: 1.5rem;\n  left: calc(50% + (18rem + var(--av-sb-left)) / 2);\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px;\n  background: var(--av-glass);\n  backdrop-filter: var(--av-blur);\n  -webkit-backdrop-filter: var(--av-blur);\n  border: 1px solid var(--av-line);\n  border-radius: var(--av-radius-lg);\n  transition: left 0.8s var(--av-ease);\n}\n\n.interior-viewer.extended .interior-viewer-controls {\n  left: 50%;\n}\n\n.interior-viewer-controls.portrait {\n  position: relative;\n  bottom: auto;\n  left: auto;\n  transform: none;\n  margin-top: 1rem;\n}\n\n.interior-viewer.portrait .interior-viewer-controls {\n  left: auto;\n}\n\n.interior-viewer-button {\n  width: 40px;\n  height: 40px;\n  box-sizing: border-box;\n  border: 1px solid var(--av-line-strong);\n  border-radius: var(--av-radius);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.3s var(--av-ease);\n}\n.interior-viewer-button img {\n  width: 1.125rem;\n  height: 1.125rem;\n  object-fit: contain;\n}\n\n.interior-viewer-button:hover {\n  background: var(--av-hover);\n}\n\n.interior-viewer-indicators {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 4px;\n}\n\n.interior-viewer-indicator {\n  height: 40px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.interior-viewer-indicator-line {\n  width: 1.5rem;\n  height: 2px;\n  background: var(--av-gray-2);\n  transition: width 0.4s var(--av-ease), background 0.4s var(--av-ease);\n}\n\n.interior-viewer-indicator.selected .interior-viewer-indicator-line {\n  width: 2.75rem;\n  background: var(--av-text);\n}\n\n.interior-viewer-counter {\n  min-width: 2.5rem;\n  color: var(--av-text-2);\n  font-size: 0.75rem;\n  line-height: 1.125rem;\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n}\n\n@media screen and (orientation: portrait) and (min-width: 1000px) and (min-height: 1000px) {\n  .carousel-info-title.portrait {\n    width: calc(100% - 4.53125rem);\n    font-size: 3rem;\n    line-height: 4.5rem;\n    margin-bottom: 1.125rem;\n    margin-right: 4.53125rem;\n  }\n  .carousel-info-desc.portrait {\n    margin-left: 4.53125rem;\n    margin-top: 2.875rem;\n    width: calc(100% - 4.53125rem);\n  }\n  .carousel-info-specs.portrait {\n    margin-right: 4.53125rem;\n    margin-bottom: 2.73875rem;\n    width: calc(100% - 4.53125rem);\n  }\n  .carousel-info-options.portrait {\n    justify-content: center;\n    margin-right: 4.53125rem;\n  }\n  .carousel-info-options-buttonnav {\n    max-width: unset;\n  }\n  .carousel-info-options-button.portrait {\n    width: 31.25rem;\n    margin-bottom: 3rem;\n  }\n  .carousel-info-options-button-text.portrait {\n    font-size: 1.25rem;\n    line-height: 1.75rem;\n  }\n  .carousel-info-options-navegation-next.portrait {\n    height: 3.5rem;\n    width: 3.5rem;\n  }\n  .carousel-bullet-container.portrait {\n    height: 2.5rem;\n  }\n  .carousel-seal-container.portrait {\n    height: 7.375rem;\n    top: -7.375rem;\n    bottom: unset;\n  }\n  .studio-sidebar-topbar.portrait {\n    height: 2.75rem;\n    margin-left: 1.25rem;\n    margin-top: 1.25rem;\n  }\n  .studio-sidebar-topbar-text.portrait {\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n  .studio-sidebar-topbar-music.portrait img {\n    width: 1.25rem;\n    height: 1.25rem;\n  }\n  .drag-animation-container.portrait {\n    bottom: 20rem;\n  }\n  .drag-animation-text.portrait {\n    font-size: 0.75rem;\n    line-height: 1.125rem;\n  }\n  .bullet-sidebar-container.portrait {\n    width: 35rem;\n  }\n  .bullet-container-content.portrait {\n    padding-bottom: 2rem;\n    height: 15.625rem;\n  }\n  .bullet-container-title.portrait {\n    font-size: 1.25rem;\n    line-height: 1.75rem;\n    margin-bottom: 1.25rem;\n  }\n  .bullet-container-desc.portrait {\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n  .bullet-container-banner-button.portrait {\n    width: 2.5rem;\n    height: 2.5rem;\n    top: 1rem;\n    right: 1rem;\n  }\n  .bottombar-full-container {\n    width: 39.375rem;\n    margin-bottom: 1.25rem;\n  }\n  .bottombar-full-container.hidden {\n    bottom: -13.625rem;\n  }\n  .bottombar-menu-title {\n    font-size: 1.5rem;\n    line-height: 2rem;\n    margin-top: 0.75rem;\n  }\n  .bottombar-menu-container {\n    margin-top: 1.875rem;\n  }\n  .bottombar-menu-view {\n    height: 5rem;\n  }\n  .bottombar-menu-color {\n    height: 5rem;\n  }\n  .bottombar-view-logo {\n    height: 1rem;\n  }\n  .bottombar-view-button-container {\n    width: 10rem;\n    height: 2.5rem;\n  }\n  .bottombar-view-text {\n    font-size: 1.25rem;\n    line-height: 1.75rem;\n  }\n  .bottombar-main-container {\n    max-width: calc(100% - 1.25rem);\n    height: auto;\n    margin: 0.5rem 0rem 0.875rem 0rem;\n  }\n  .bottombar-main-button {\n    width: 6.25rem;\n    height: 4.5625rem;\n  }\n  .bottombar-main-button-text {\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n  .bottombar-color-element {\n    width: 48px;\n    height: 48px;\n  }\n  .bottombar-color-img {\n    width: 32px;\n    height: 32px;\n  }\n  .bottombar-color-text {\n    font-size: 1rem;\n    line-height: 1.5rem;\n    margin-bottom: 1rem;\n  }\n  .gallery-partial-container-collage.altportrait {\n    height: calc(100% - 11.875rem - 1.25rem);\n  }\n  .gallery-partial-container-collage-menu {\n    max-width: 98%;\n    width: 61.5rem;\n    height: 11.875rem;\n  }\n  .gallery-partial-container-collage-title {\n    font-size: 1.5rem;\n    line-height: 2rem;\n    margin-top: 2.53125rem;\n  }\n  .gallery-partial-container-collage-buttons {\n    justify-content: center;\n    margin-bottom: 1.25rem;\n  }\n  .gallery-partial-container-collage-logo {\n    height: 1rem;\n    object-fit: contain;\n    margin-left: unset;\n    margin-right: 5rem;\n  }\n  .gallery-partial-container-collage-button {\n    width: 18.75rem;\n    height: 2.5rem;\n  }\n  .gallery-partial-container-collage-button-text {\n    font-size: 1.25rem;\n    line-height: 1.75rem;\n  }\n  .gallery-container-controls-subtitle {\n    font-size: 1.25rem;\n    line-height: 1.75rem;\n  }\n  .gallery-container-full-controls {\n    width: 17.375rem;\n  }\n  .gallery-controls-button {\n    height: 2.5rem;\n  }\n  .gallery-controls-button-text {\n    font-size: 1.25rem;\n    line-height: 1.75rem;\n  }\n  .gallery-container-controls-button {\n    width: 3rem;\n    height: 3rem;\n  }\n  .gallery-container-controls-button img {\n    width: 1.5rem;\n    height: 1.5rem;\n  }\n}","// Tokens de diseño según \"Official website specifications\" de AVATR.\n// Paleta, grises de texto, escala tipográfica y botones salen de ese documento.\n:root\n  --av-font: 'AVATRFont', 'Inter', -apple-system, 'Helvetica Neue', Arial, sans-serif\n\n  // Paleta oficial\n  --av-black: #181818\n  --av-white: #FFFFFF\n  --av-gray-1: #464646\n  --av-gray-2: #747474\n  --av-gray-3: #A3A3A3\n  --av-gray-4: #D1D1D1\n  --av-warm-ivory: #FCEDE0\n  --av-cyber-lime: #B4D719\n  --av-light-green-1: #ECF5B9\n  --av-light-green-2: #D9EC74\n  --av-dark-green-1: #3A534E\n  --av-dark-green-2: #1E2F2B\n  --av-select-outline: #E7E7E7\n\n  // Roles (interfaz oscura: la especificación permite el tono oscuro como base)\n  --av-bg: var(--av-black)\n  --av-glass: rgba(24, 24, 24, 0.72)\n  --av-glass-strong: rgba(24, 24, 24, 0.9)\n  --av-blur: blur(20px) saturate(140%)\n\n  --av-line: var(--av-gray-1)\n  --av-line-strong: var(--av-white)\n  --av-hover: rgba(255, 255, 255, 0.08)\n\n  --av-text: var(--av-white)\n  --av-text-2: var(--av-gray-4)\n  --av-text-3: var(--av-gray-3)\n  --av-ink: var(--av-black)\n\n  // Cyber Lime: solo como acento (máx. ~5% de la superficie)\n  --av-accent: var(--av-cyber-lime)\n\n  --av-radius: 4px\n  --av-radius-lg: 8px\n  --av-ease: cubic-bezier(.42, 0, 0, 1)\n\n  --av-tracking: 0.14em\n\n  // Margen de seguridad del contenido (PC ≥ 80px, H5 20px)\n  --av-safe: 5rem\n  // Distancia del panel lateral del estudio al borde (panel flotante sobre el 3D,\n  // no es contenido de página, por eso no usa el margen de 80px)\n  --av-sb-left: 1.25rem\n\n*\n  margin: 0\n  padding: 0\n  box-sizing: 0\n\n::-webkit-scrollbar\n  height: 4px\n  width: 4px\n\n::-webkit-scrollbar-track\n  background: transparent\n\n::-webkit-scrollbar-thumb\n  background: rgba(255, 255, 255, 0.18)\n  border-radius: 1rem\n\nhtml, body\n  width: 100%\n  height: 100%\n  margin: 0\n  overflow: hidden\n  // clip además impide desplazamientos programáticos (focus / scrollIntoView)\n  overflow: clip\n  -webkit-user-select: none\n  -khtml-user-select: none\n  -moz-user-select: none\n  -o-user-select: none\n  user-select: none\n\n#root\n  position: relative\n  width: 100%\n  height: 100%\n\nbody\n  font-family: var(--av-font) !important\n  font-weight: 300\n  color: var(--av-text)\n  background: var(--av-bg)\n  margin: 0\n  -webkit-font-smoothing: antialiased\n  -moz-osx-font-smoothing: grayscale\n\n.full-app-container\n  position: relative\n  width: 100%\n  height: 100%\n  overflow: hidden\n  background-color: var(--av-bg)\n\n.container-app\n  // posicionado para que su overflow recorte las capas absolutas (slides fuera de pantalla)\n  position: relative\n  width: 100%\n  height: 100%\n  overflow: hidden\n\n// ---- Botones compartidos (Button-PC) ----\n// Principal: alto 40, ancho mín. 112, padding 0 20, radio 4, fondo #FFFFFF, texto 14/22 #181818.\n// Solo uno por área de acción. Al pasar el cursor sube 2px con el brillo lima de avatr.com.\n.av-btn-primary\n  position: relative\n  height: 40px !important\n  min-width: 112px\n  padding: 0 20px\n  box-sizing: border-box\n  background: var(--av-white) !important\n  border: none !important\n  border-radius: var(--av-radius) !important\n  cursor: pointer\n  box-shadow: 0 12px 20px -12px rgba(180, 215, 25, 0)\n  transition: transform 0.2s linear, box-shadow 0.3s linear\n  > *\n    color: var(--av-ink) !important\n    font-size: 14px !important\n    line-height: 22px !important\n    font-weight: 400\n  &:hover\n    transform: translate3d(0, -2px, 0)\n    box-shadow: 0 14px 22px -10px rgba(180, 215, 25, 0.85)\n","// AVATRFont (subset latino). La fuente oficial no incluye ñ, ¿, ¡ ni mayúsculas\n// acentuadas; esos glifos caen a Inter (importada en index.tsx), respaldo en --av-font.\n\n@font-face\n  font-family: 'AVATRFont'\n  font-style: normal\n  font-weight: 300\n  font-display: swap\n  src: url('../assets/fonts/avatr/AVATRFont-Light.woff2') format('woff2')\n\n@font-face\n  font-family: 'AVATRFont'\n  font-style: normal\n  font-weight: 400\n  font-display: swap\n  src: url('../assets/fonts/avatr/AVATRFont-Regular.woff2') format('woff2')\n\n@font-face\n  font-family: 'AVATRFont'\n  font-style: normal\n  font-weight: 500\n  font-display: swap\n  src: url('../assets/fonts/avatr/AVATRFont-Bold.woff2') format('woff2')\n",".bottombar-full-container\n  position: absolute\n  bottom: 0.625rem\n  left: 50%\n  transform: translateX(-50%)\n  width: 22.5rem\n  max-width: calc(100% - 1.25rem)\n  padding-top: 0.25rem\n  display: flex\n  flex-direction: column\n  align-items: center\n  justify-content: space-evenly\n  opacity: 1\n  background: var(--av-glass)\n  backdrop-filter: var(--av-blur)\n  -webkit-backdrop-filter: var(--av-blur)\n  border: 1px solid var(--av-line)\n  border-radius: var(--av-radius-lg)\n  transition: opacity 0.8s ease-in-out, bottom 0.8s var(--av-ease)\n\n.bottombar-full-container.hidden\n  bottom: -8rem\n\n.bottombar-full-container.hiddenhigh\n  bottom: -13rem\n\n.bottombar-collapse-btn\n  width: 2rem\n  height: 2rem\n  background: var(--av-glass-strong)\n  border: 1px solid var(--av-line)\n  border-radius: var(--av-radius)\n  display: flex\n  align-items: center\n  justify-content: center\n  pointer-events: auto\n  cursor: pointer\n  position: absolute\n  top: -1rem\n  right: 1rem\n  img\n    width: 1rem\n    height: 1rem\n    object-fit: contain\n    transform: rotate(-90deg)\n    transition: transform 0.8s var(--av-ease)\n\n.bottombar-collapse-btn.collapsed\n  img\n    transform: rotate(90deg)\n\n.bottombar-menu-title\n  color: var(--av-text)\n  font-size: 1rem\n  line-height: 1.5rem\n  font-weight: 300\n  margin-top: 0.75rem\n\n.bottombar-menu-container\n  width: 100%\n  height: auto\n  margin-top: 0.75rem\n\n// ---- Vista ----\n.bottombar-menu-view\n  width: 100%\n  height: 2.75rem\n  display: flex\n  flex-direction: row\n  align-items: center\n\n.bottombar-view-content\n  height: 100%\n  width: calc(100% - 2rem)\n  margin: 0 1rem\n  display: flex\n  flex-direction: row\n  justify-content: space-between\n  align-items: center\n\n.bottombar-view-logo\n  width: auto\n  height: 0.6875rem\n  object-fit: contain\n\n.bottombar-view-options\n  display: flex\n  gap: 4px\n  padding: 4px\n  border: 1px solid var(--av-line)\n  border-radius: var(--av-radius)\n\n.bottombar-view-button-container\n  width: 5.5rem\n  height: 30px\n  cursor: pointer\n\n.bottombar-view-button\n  width: 100%\n  height: 100%\n  border-radius: 2px\n  display: flex\n  align-items: center\n  justify-content: center\n  transition: background 0.3s var(--av-ease)\n\n.bottombar-view-button.selected\n  background: var(--av-text)\n\n.bottombar-view-text\n  color: var(--av-text-2)\n  font-size: 0.75rem\n  line-height: 1.125rem\n  font-weight: 400\n\n.bottombar-view-text.selected\n  color: var(--av-ink)\n\n// ---- Color ----\n.bottombar-menu-color\n  width: 100%\n  min-height: 2.75rem\n  display: flex\n  flex-direction: column\n  align-items: center\n  justify-content: space-between\n  gap: 4px\n\n// Selector de color móvil (avatr.com/en/07 en ≤767px): bolita de 22px, halo #E5E5E5 de 32px\n.bottombar-color-selection\n  display: flex\n  gap: 12px\n  flex-direction: row\n  justify-content: center\n\n.bottombar-color-element\n  position: relative\n  width: 32px\n  height: 32px\n  display: flex\n  justify-content: center\n  align-items: center\n  cursor: pointer\n  &::before\n    content: ''\n    position: absolute\n    inset: 0\n    border-radius: 50%\n    background-color: #E5E5E5\n    opacity: 0\n    transform: scale(0.8)\n    transition: opacity 0.3s linear, transform 0.3s var(--av-ease)\n\n.bottombar-color-element.selected::before\n  opacity: 1\n  transform: scale(1)\n\n.bottombar-color-img\n  position: relative\n  z-index: 1\n  width: 22px\n  height: 22px\n  border-radius: 50%\n  object-fit: contain\n\n.bottombar-color-text\n  animation: av-color-name 0.3s linear\n  width: 100%\n  color: var(--av-text-2)\n  font-size: 0.75rem\n  line-height: 1.125rem\n  text-align: center\n\n// ---- Escenarios: selector segmentado (alto total 40px) ----\n.bottombar-scenario\n  width: 100%\n  min-height: 2.75rem\n  display: flex\n  flex-direction: column\n  align-items: center\n  justify-content: center\n\n.bottombar-scenario-title\n  display: none\n\n.bottombar-scenario-selection\n  display: flex\n  gap: 4px\n  padding: 4px\n  width: calc(100% - 2rem)\n  box-sizing: border-box\n  border: 1px solid var(--av-line)\n  border-radius: var(--av-radius)\n\n.bottombar-scenario-subcontainer\n  flex: 1\n  min-width: 0\n  height: 30px\n  cursor: pointer\n\n.bottombar-scenario-element\n  width: 100%\n  height: 100%\n  border-radius: 2px\n  display: flex\n  align-items: center\n  justify-content: center\n  transition: background 0.3s var(--av-ease)\n\n.bottombar-scenario-element.selected\n  background: var(--av-text)\n\n.bottombar-scenario-text\n  color: var(--av-text-2)\n  font-size: 0.75rem\n  line-height: 1.125rem\n  font-weight: 400\n\n.bottombar-scenario-text.selected\n  color: var(--av-ink)\n\n// ---- Opciones ----\n.bottombar-menu-options\n  width: 100%\n  height: 3rem\n  display: flex\n  align-items: center\n  justify-content: center\n\n.bottombar-options-content\n  display: flex\n  width: 90%\n  gap: 0.5rem\n  justify-content: center\n\n.bottombar-options-button\n  width: 45%\n  height: 2rem\n  display: flex\n  justify-content: center\n  align-items: center\n  cursor: pointer\n  border-radius: var(--av-radius)\n  border: 1px solid var(--av-line-strong)\n\n.bottombar-options-text\n  color: var(--av-text)\n  font-size: 0.875rem\n  line-height: 1.375rem\n\n// ---- Menú principal (pestañas) ----\n.bottombar-main-container\n  width: 100%\n  height: auto\n  margin: 0.75rem 0\n  padding: 0 0.5rem\n  box-sizing: border-box\n  overflow-x: auto\n  overflow-y: hidden\n  scrollbar-width: none\n  &::-webkit-scrollbar\n    display: none\n\n.bottombar-main-container-scroll\n  min-width: 100%\n  display: flex\n  flex-direction: row\n  gap: 0.25rem\n\n.bottombar-main-button\n  // 6 pestañas en ~355px: se reparten el ancho y los textos largos pasan a dos líneas\n  flex: 1 1 auto\n  min-width: 0\n  min-height: 3.25rem\n  padding: 6px 2px\n  box-sizing: border-box\n  display: flex\n  flex-direction: column\n  justify-content: center\n  align-items: center\n  gap: 0.375rem\n  border-radius: var(--av-radius)\n  border: 1px solid transparent\n  cursor: pointer\n  transition: background 0.3s var(--av-ease), border-color 0.3s var(--av-ease)\n\n.bottombar-main-button:hover\n  background: var(--av-hover)\n\n.bottombar-main-button.selected\n  background: rgba(255, 255, 255, 0.1)\n  border-color: var(--av-line-strong)\n\n.bottombar-main-button-logo\n  height: 1rem\n  width: 1.25rem\n  object-fit: contain\n\n.bottombar-main-button-text\n  color: var(--av-text-2)\n  font-size: 0.75rem\n  line-height: 1.125rem\n  font-weight: 400\n  letter-spacing: 0.02em\n  white-space: normal\n  text-align: center\n\n.bottombar-main-button.selected .bottombar-main-button-text\n  color: var(--av-text)\n\n// ---- Asientos (desactivado) ----\n.bottombar-menu-seat\n  width: 100%\n  height: 8rem\n  display: flex\n  flex-direction: column\n  align-items: center\n  pointer-events: none\n\n.bottombar-menu-seat.enabled\n  pointer-events: auto\n\n.bottombar-seat-subcontainer\n  width: 100%\n  height: 100%\n  display: flex\n  flex-direction: column\n  align-items: center\n\n.bottombar-seat-title\n  color: var(--av-text-3)\n  font-size: 0.75rem\n  line-height: 1.125rem\n  letter-spacing: var(--av-tracking)\n  text-transform: uppercase\n\n.bottombar-seat-icon-container\n  width: 100%\n  height: calc(90% - 1rem)\n  display: flex\n  margin: 0.5rem 0\n  flex-direction: column\n  justify-content: space-around\n  align-items: center\n\n.bottombar-seat-icon-row\n  width: 100%\n  height: 45%\n  display: flex\n  justify-content: center\n\n.bottombar-seat-seat-icon\n  height: calc(100% - 0.2rem)\n  aspect-ratio: 1\n  border: 1px solid var(--av-line-strong)\n  border-radius: var(--av-radius)\n  margin: 0.125rem\n  cursor: pointer\n\n.bottombar-seat-seat-icon.selected\n  background: var(--av-text)\n","@keyframes moveToRigth\n  0%\n    left: -17.5%\n  100%\n    left: 2rem\n\n@keyframes move\n  0%\n    left: 7%\n    transform: rotate(-10deg)\n  50%\n    left: 70%\n    transform: rotate(25deg)\n  100%\n    left: 7%\n    transform: rotate(-10deg)\n\n@keyframes moveDown\n  0% \n    top: -5.7rem\n  100%\n    top: 1.7rem\n\n@keyframes moveTop\n  0%\n    bottom: -8rem\n  100%\n    bottom: 1%\n\n@keyframes moveDownMobile\n  0%\n    top: -4rem\n  100%\n    top: 6rem//2rem\n\n@keyframes moveDownMobile4k\n  0%\n    top: -4rem\n  100%\n    top: 2rem\n\n@keyframes fade\n  0%\n    opacity: 0\n  100%\n    opacity: 1\n\n@keyframes breath\n  0%\n    width: 1.0rem\n    height: 1.0rem\n  50%\n    width: 1.2rem\n    height: 1.2rem\n  100%\n    width: 1.0rem\n    height: 1.0rem",".bullet-full-container\n  display: flex\n  position: absolute\n  width: 100%\n  height: calc(100% - 3.75rem)\n  justify-content: center\n  align-items: center\n  flex-direction: row\n  pointer-events: none\n  opacity: 1\n  transition: opacity 0.8s ease-in-out\n\n.bullet-full-container.hide\n  opacity: 0\n\n.bullet-sidebar-container\n  position: absolute\n  display: flex\n  height: 100%\n  width: 38rem\n  max-width: 90%\n  flex-direction: column\n  justify-content: center\n\n.bullet-sidebar-container.portrait\n  width: 21rem\n\n.bullet-container\n  position: absolute\n  display: flex\n  width: 100%\n  height: auto\n  flex-direction: column\n  justify-content: center\n\n.bullet-container.portrait\n  height: 100%\n\n.bullet-container.hide\n  pointer-events: none\n\n.bullet-container-content\n  position: relative\n  width: calc(100% - 2.5rem)\n  height: 15.625rem\n  max-height: 60%\n  padding: 1.25rem\n  border-radius: var(--av-radius-lg)\n  background: var(--av-glass-strong)\n  backdrop-filter: var(--av-blur)\n  -webkit-backdrop-filter: var(--av-blur)\n  border: 1px solid var(--av-line)\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45)\n  display: flex\n  justify-content: center\n  flex-direction: row\n  pointer-events: auto\n\n.bullet-container-content.hide\n  pointer-events: none\n\n.bullet-container-content.portrait\n  position: absolute\n  height: 8.5rem\n  padding: 0.875rem\n\n.bullet-container-img\n  width: 48%\n  border-radius: var(--av-radius)\n  object-fit: cover\n  margin-right: 1.5rem\n\n.bullet-container-img.portrait\n  margin-right: 0.875rem\n\n.bullet-container-data\n  width: -webkit-fill-available\n  display: flex\n  flex-direction: column\n  padding-right: 2.25rem\n  overflow-y: auto\n  overflow-x: hidden\n\n.bullet-container-data.portrait\n  padding-right: 1.75rem\n\n.bullet-container-title\n  color: var(--av-text)\n  font-size: 1.25rem\n  line-height: 1.75rem\n  font-weight: 400\n  text-align: start\n  margin-top: 0.25rem\n  margin-bottom: 1rem\n  padding-bottom: 1rem\n  border-bottom: 1px solid var(--av-line)\n\n.bullet-container-title.portrait\n  font-size: 0.875rem\n  line-height: 1.375rem\n  margin-top: 0\n  margin-bottom: 0.5rem\n  padding-bottom: 0.5rem\n\n.bullet-container-desc\n  color: var(--av-text-2)\n  font-size: 0.875rem\n  line-height: 1.375rem\n  font-weight: 300\n  text-align: start\n\n.bullet-container-desc.portrait\n  font-size: 0.75rem\n  line-height: 1.125rem\n\n.bullet-container-banner-button\n  position: absolute\n  top: 0.875rem\n  right: 0.875rem\n  width: 2.25rem\n  height: 2.25rem\n  object-fit: contain\n  cursor: pointer\n  transition: transform 0.3s var(--av-ease)\n\n.bullet-container-banner-button:hover\n  transform: rotate(90deg)\n\n.bullet-container-banner-button.portrait\n  top: 0.5rem\n  right: 0.5rem\n  width: 1.75rem\n  height: 1.75rem\n",".carselection-full-container\n  position: absolute\n  width: 15rem //14.8125rem\n  max-width: 85% //100%\n  height: calc(100% - 3.75rem)\n  right: 0px\n  background: #F4F7FE\n  display: flex\n  flex-direction: column\n  align-items: center\n  justify-content: flex-start\n  transition: opacity 0.8s ease-in-out, right 0.8s ease-in-out\n  z-index: 1\n\n.carselection-full-container.hide\n  right: -15rem\n  opacity: 0\n  pointer-events: none\n\n.carselection-full-container.portrait\n  width: 11.875rem\n  height: calc(100% - 2.5rem)\n\n.carselection-full-container.in3dcontainer\n  width: 11.875rem\n  height: 100%\n\n.carselection-close-bg\n  position: absolute\n  width: 2.5rem\n  height: 2.5rem\n  top: calc(50% - 1.25rem)\n  left: calc(0% - 1.25rem)\n  display: flex\n  justify-content: center\n  align-items: center\n  background: #F4F7FE\n  border-radius: 100%\n\n.carselection-close-bg.portrait\n  width: 2.5rem //TODO\n  \n\n.carselection-close-button\n  width: 80%\n  height: 80%\n  background: #FFF\n  border-radius: 100%\n  display: flex\n  justify-content: center\n  align-items: center\n  cursor: pointer\n\n.carselection-close-icon\n  width: 50%\n  height: 50%\n  margin: auto\n\n.carselection-title\n  margin: 2.5rem 1.164rem 0rem 1.164rem\n  font-family: var(--av-font)\n  font-weight: 500\n  font-size: 1.125rem\n  color: #00095B\n  text-align: center\n\n.carselection-title.portrait\n  font-size: 0.85rem\n  margin: 1.25rem 1.677rem 0rem 1.677rem\n\n.carselection-list\n  width: calc(100% - 0.25rem - 0.25rem)\n  margin: 0rem 1.164rem 0rem 1.364rem\n  max-height: 100%\n  overflow-y: auto\n  overflow-x: hidden\n\n.carselection-category\n  width: calc(100% - 0.914rem - 0.914rem)\n  height: auto\n  margin-left: auto\n  margin-right: auto\n  margin-top: 1.2rem\n  margin-bottom: 0.24rem\n\n.carselection-category-text\n  //margin-top: 1.25rem\n  margin-bottom: 0.06125rem\n  font-family: var(--av-font)\n  font-weight: 400\n  font-size: 0.75rem\n  color: #84848E\n\n.carselection-car\n  width: 100%\n  height: auto\n  cursor: pointer\n\n.carselection-car.disabled\n  pointer-events: none\n  cursor: unset\n\n.carselection-car-image\n  width: 100%\n  height: 3.98125rem\n  margin-top: 0.66375rem\n  border-radius: 0.625rem 0.625rem 0rem 0rem\n  border: 1px solid #D3D3D3\n  background: #D3D3D3\n  background-size: cover\n  background-repeat: no-repeat\n  background-position: center\n\n.carselection-car-image.portrait\n  height: 3.75rem\n\n.carselection-car-image.disabled\n  -webkit-filter: grayscale(1)\n  filter: grayscale(1)\n\n.carselection-car-desc\n  width: 100%\n  height: 3.98125rem\n  border-radius: 0rem 0rem 0.625rem 0.625rem\n  border: 1px solid #D3D3D3\n  background: #fff\n  display: flex\n  justify-content: center\n  align-items: center\n\n.carselection-car-desc.portrait\n  height: 3.5rem\n\n.carselection-car-desc-text\n  width: 80%\n  font-family: var(--av-font)\n  font-weight: 500\n  font-size: 0.9rem //clamp(0.1rem, 3.7vw, 1rem)\n  color: #00095B\n  text-align: center\n\n.carselection-car-desc-text.portrait\n  width: 80%\n\n.carselection-car-desc-text.disabled\n  color: #84848E",".card-full-container\n  display: flex\n  position: absolute\n  width: 100%\n  height: calc(100% - 3.75rem)\n  justify-content: center\n  flex-direction: row\n  pointer-events: none\n  opacity: 1\n  transition: opacity 0.8s ease-in-out\n\n.card-full-container.hide\n  opacity: 0\n\n.card-full-container.portrait\n  width: 100%\n  // max-height: 60%\n  // height: 14.25rem\n\n// .card-float-container\n//   display: flex\n//   height: 100%\n//   width: 21.25rem\n//   max-width: 45%\n//   margin-right: 1.25rem\n//   flex-direction: column\n//   justify-content: center\n\n// .card-float-container.portrait\n//   width: 100%\n//   max-width: 100%\n//   margin-right: 0rem\n  \n.card-container\n  display: flex\n  width: 19.125rem\n  max-width: 90%\n  height: auto\n  flex-direction: column\n  justify-content: center\n  pointer-events: auto\n\n.card-container.portrait\n  height: 100%\n\n.card-container.hide\n  pointer-events: none\n\n.card-container-banner\n  width: 100%\n  height: 10rem\n  max-height: 80%\n  border-radius: 0.625rem 0.625rem 0rem 0rem\n  background: #D3D3D3\n  background-size: cover\n  background-repeat: no-repeat\n  background-position: center\n  display: flex\n  justify-content: flex-end\n\n.card-container-banner.portrait\n  height: 10rem\n\n.card-container-banner-button\n  width: 2.5rem\n  height: 2.5rem\n  margin-top: 0.2rem\n  margin-right: 0.2rem\n  object-fit: contain\n  cursor: pointer\n\n.card-container-content\n  width: 100%\n  border-radius: 0rem 0rem 0.625rem 0.625rem\n  background: #F4F7FE\n  display: flex\n  flex-direction: column\n  justify-content: space-between\n  align-items: center\n\n.card-container-content.portrait\n  //border-radius: 0rem 0rem 0rem 0rem\n\n.card-container-data\n  display: flex\n  flex-direction: column\n  justify-content: space-evenly\n  width: calc(100% - 1.875rem - 1.875rem)\n  margin: 0.625rem 1.875rem 0.625rem 1.875rem\n\n.card-container-title\n  font-family: var(--av-font)\n  font-weight: 500\n  font-size: 1.125rem\n  color: #00095B\n  \n.card-container-title.portrait\n  font-size: clamp(0.5rem, 5vw, 1rem)\n\n.card-container-desc\n  margin-top: 0.625rem\n  font-family: var(--av-font)\n  font-weight: 300\n  font-size: 0.75rem\n  color: #84848E\n  text-align: start\n.card-container-desc.portrait\n  font-size: clamp(0.5rem, 5vw, 0.75rem)\n\n.card-container-block\n  width: calc(100% - 1.28rem - 1.28rem)\n  margin: 0rem 1.28rem 0rem 1.28rem\n\n.card-container-block-line\n  width: 100%\n  border-top: 1px solid #EEEEEE\n\n.card-container-info\n  display: flex\n  flex-direction: row\n  justify-content: flex-start\n  align-items: center\n  width: 100%\n  margin: 0.625rem 0rem 0.625rem 0rem\n\n.card-container-info-icon\n  width: 1.18rem\n  height: 1.18rem\n  object-fit: contain\n  \n.card-container-info-desc\n  font-family: var(--av-font)\n  font-weight: 300\n  font-size: 0.8rem\n  color: #84848E\n  text-align: start\n  margin-left: 0.82rem\n\n.card-container-button\n  width: calc(100% - 2.875rem - 2.875rem)\n  height: 2.375rem\n  background: #066FEF\n  border-radius: 2rem\n  display: flex\n  align-items: center\n  justify-content: center\n  cursor: pointer\n  margin: 1.3rem 2.875rem 0.8rem 2.875rem\n  transition: background 0.8s ease-in-out\n\n.card-container-button:hover\n  background: #00095B\n\n.card-container-button-text\n  color: #FFFFFF\n  font-family: var(--av-font)\n  font-weight: 300\n  font-size: clamp(0.5rem, 5vw, 0.9rem)\n\n.card-container-close-portrait\n  width: 100%\n  height: 4.5rem\n  display: flex\n  justify-content: center\n  align-items: center\n  \n.card-close-button-portrait\n  //width: 2.5rem\n  height: 90%\n  object-fit: contain\n  cursor: pointer",".carousel-container\n  position: absolute\n  width: 100%\n  height: 100%\n  opacity: 1\n  transition: opacity 0.8s ease-in-out\n  z-index: 1\n  background: var(--av-bg)\n\n.carousel-container.hide-container\n  opacity: 0\n  pointer-events: none\n\n// ---- Panel de información ----\n.carousel-info-card\n  position: absolute\n  width: 38%\n  height: 100%\n  left: 0\n  display: flex\n  flex-direction: column\n  justify-content: space-between\n  align-items: flex-start\n  background: var(--av-bg)\n  z-index: 1\n\n.carousel-info-card.portrait\n  width: 100%\n  height: auto\n  left: unset\n  bottom: 0\n\n.carousel-info-card.mobileland\n  width: 45%\n\n.carousel-info-header\n  height: 0.875rem\n  width: auto\n  max-width: 60%\n  object-fit: contain\n  object-position: left center\n  margin-top: 2.5rem\n  margin-left: var(--av-safe)\n  opacity: 0.95\n\n.carousel-info-desc\n  margin-left: var(--av-safe)\n  width: calc(100% - var(--av-safe))\n  height: auto\n  display: flex\n  flex-direction: column\n  justify-content: center\n\n.carousel-info-desc.portrait\n  margin-left: 1.25rem\n  margin-top: 1.5rem\n  width: calc(100% - 1.25rem)\n\n.carousel-info-desc.mobileland\n  margin-left: 2rem\n  width: calc(100% - 2rem)\n\n.carousel-info-eyebrow\n  display: flex\n  align-items: center\n  gap: 0.75rem\n  color: var(--av-text-3)\n  font-size: 0.75rem\n  line-height: 1.125rem\n  font-weight: 400\n  letter-spacing: 0.24em\n  text-transform: uppercase\n  margin-bottom: 1.25rem\n  &::before\n    content: ''\n    width: 1.5rem\n    height: 1px\n    background: var(--av-accent)\n\n.carousel-info-eyebrow.portrait\n  font-size: 0.75rem\n  line-height: 1.125rem\n  margin-bottom: 0.625rem\n\n.carousel-info-title\n  width: calc(100% - var(--av-safe))\n  color: var(--av-text)\n  font-size: clamp(1.75rem, 3.6vw, 3rem)\n  line-height: 1.5\n  font-weight: 300\n  letter-spacing: -0.01em\n  margin-bottom: 2.75rem\n  margin-right: var(--av-safe)\n\n.carousel-info-title.portrait\n  width: calc(100% - 1.25rem)\n  font-size: 1.75rem\n  line-height: 2.625rem\n  margin-bottom: 1.25rem\n  margin-right: 1.25rem\n\n.carousel-info-title.mobileland\n  font-size: clamp(1.25rem, 2.4vw, 1.75rem)\n  line-height: 1.5\n  width: calc(100% - 2rem)\n  margin-bottom: 1rem\n  margin-right: 2rem\n\n.carousel-info-specs\n  margin-right: var(--av-safe)\n  margin-bottom: 3rem\n  padding-top: 1.5rem\n  border-top: 1px solid var(--av-line)\n  max-width: calc(100% - var(--av-safe))\n  height: 3rem\n  object-fit: contain\n  object-position: left center\n\n.carousel-info-specs.portrait\n  margin-right: 1.25rem\n  margin-bottom: 1.25rem\n  padding-top: 1rem\n  width: calc(100% - 1.25rem)\n  max-width: unset\n  height: auto\n\n.carousel-info-specs.mobileland\n  margin-right: 2rem\n  margin-bottom: 1rem\n  padding-top: 0.75rem\n  width: calc(100% - 2rem)\n\n.carousel-info-options\n  margin-right: var(--av-safe)\n  display: flex\n  flex-direction: row\n  justify-content: space-between\n  align-items: flex-start\n\n.carousel-info-options.portrait\n  margin-right: 1.25rem\n  display: block\n\n.carousel-info-options-buttonnav.portrait\n  max-width: none\n  width: 100%\n\n.carousel-info-options-buttonnav\n  display: flex\n  max-width: 60%\n  flex-direction: column\n  justify-content: space-between\n  align-items: flex-start\n\n.carousel-info-options-button\n  width: auto\n  max-width: 100%\n  display: flex\n  align-items: center\n  justify-content: center\n  margin-bottom: 2rem\n\n.carousel-info-options-button.portrait\n  // H5: botón principal = ancho de pantalla - 40px\n  width: 100%\n  margin-bottom: 1.25rem\n\n.carousel-info-options-button.mobileland\n  margin-bottom: 0.75rem\n\n.carousel-info-options-button-text\n  font-size: 0.875rem\n  line-height: 1.375rem\n  letter-spacing: 0.02em\n\n.carousel-info-options-button-text.portrait\n  font-size: 0.875rem\n  line-height: 1.375rem\n\n// Indicadores en línea (reemplazan los puntos)\n.carousel-info-options-bullets\n  display: flex\n  flex-direction: row\n  align-items: center\n  justify-content: flex-start\n  gap: 0.5rem\n\n.carousel-info-options-bullets.portrait\n  margin-bottom: 1rem\n\n.carousel-bullet-container\n  height: 1.25rem\n  display: flex\n  align-items: center\n  cursor: pointer\n\n.carousel-bullet\n  width: 1.5rem\n  height: 2px\n  background: var(--av-line-strong)\n  transition: width 0.4s var(--av-ease), background 0.4s var(--av-ease)\n\n.carousel-bullet.selected\n  width: 2.75rem\n  background: var(--av-text)\n\n.carousel-info-options-navegation\n  display: flex\n  flex-direction: row\n  justify-content: center\n  align-content: center\n  gap: 0.5rem\n\n.carousel-info-options-navegation-next\n  // Botón secundario: 40px, borde 1px #FFFFFF, radio 4\n  height: 40px\n  width: 40px\n  box-sizing: border-box\n  border-radius: var(--av-radius)\n  background: transparent\n  border: 1px solid var(--av-line-strong)\n  display: flex\n  justify-content: center\n  align-items: center\n  cursor: pointer\n  transition: background 0.3s var(--av-ease), border-color 0.3s var(--av-ease)\n\n.carousel-info-options-navegation-next:hover\n  background: var(--av-hover)\n\n// En vertical el botón principal ocupa todo el ancho; se navega deslizando o con los indicadores\n.carousel-info-options-navegation.portrait\n  display: none\n\n.carousel-info-options-navegation-icon\n  width: 45%\n  object-fit: contain\n\n.carousel-content-footer\n  width: 100%\n  height: 12%\n\n// ---- Imagen ----\n.carousel-content-image\n  position: absolute\n  width: 62%\n  height: 100%\n  right: 0\n  background: var(--av-bg)\n  pointer-events: none\n  overflow: hidden\n  // Funde la foto con el panel oscuro\n  &::after\n    content: ''\n    position: absolute\n    inset: 0\n    background: linear-gradient(90deg, var(--av-bg) 0%, rgba(24, 24, 24, 0) 22%), linear-gradient(0deg, rgba(24, 24, 24, 0.7) 0%, rgba(24, 24, 24, 0) 30%)\n    pointer-events: none\n\n.carousel-content-image.portrait\n  width: 100%\n  height: calc(100% - 11.875rem)\n  right: 0\n  &::after\n    background: linear-gradient(0deg, var(--av-bg) 0%, rgba(24, 24, 24, 0) 35%), linear-gradient(180deg, rgba(24, 24, 24, 0.55) 0%, rgba(24, 24, 24, 0) 18%)\n\n// Logo sobre la imagen en vertical (en horizontal va en el panel)\n.carousel-portrait-logo\n  position: absolute\n  top: 1.5rem\n  left: 1.25rem\n  height: 0.75rem\n  width: auto\n  z-index: 1\n  filter: drop-shadow(0 1px 6px rgba(0, 0, 0, 0.5))\n\n.carousel-seal-container\n  position: absolute\n  width: 100%\n  height: 6.5rem\n  display: flex\n  bottom: 0\n  flex-direction: row\n  justify-content: center\n  align-items: center\n  z-index: 1\n\n.carousel-seal-container.portrait\n  height: 4.125rem\n  top: -4.125rem\n  bottom: unset\n\n.carousel-seal-container-img\n  height: 70%\n  max-width: 90%\n  object-fit: contain\n  opacity: 0.9\n\n.carousel-slide\n  position: absolute\n  width: 100%\n  height: 100%\n\n.carousel-slide-center\n  position: absolute\n  width: 100%\n  height: 100%\n  display: flex\n  justify-content: flex-end\n  align-items: flex-end\n  opacity: 1\n  right: 0%\n  transition: right 0.8s var(--av-ease), opacity 0.8s ease-in-out\n.carousel-slide-center.right\n  opacity: 0\n  right: -100%\n.carousel-slide-center.left\n  opacity: 0\n  right: 100%\n\n.carousel-slide-right\n  position: absolute\n  width: 100%\n  height: 100%\n  display: flex\n  justify-content: flex-end\n  align-items: flex-end\n  opacity: 0\n  right: -100%\n  transition: right 0.8s var(--av-ease), opacity 0.8s ease-in-out\n.carousel-slide-right.center\n  right: 0%\n  opacity: 1\n\n.carousel-slide-left\n  position: absolute\n  width: 100%\n  height: 100%\n  display: flex\n  justify-content: flex-end\n  align-items: flex-end\n  opacity: 0\n  right: 100%\n  transition: right 0.8s var(--av-ease), opacity 0.8s ease-in-out\n.carousel-slide-left.center\n  right: 0%\n  opacity: 1\n\n.carousel-slide-img\n  width: 100%\n  height: 100%\n  object-fit: cover\n  // Corre el carro a la derecha para que no quede bajo el degradado del panel\n  object-position: 35% 50%\n\n.carousel-slide-img.portrait\n  object-position: 50% 50%\n\n.carousel-load-only\n  position: absolute\n  width: 100%\n  height: 100%\n  opacity: 0\n\n.carousel-slides\n  position: absolute\n  width: 100%\n  height: 100%\n  opacity: 0\n.carousel-slides.visible\n  opacity: 1\n",".concessionaire-full-container\n    position: absolute\n    width: 100%\n    height: 100%\n    opacity: 1\n    transition: opacity 0.8s ease-in-out\n    \n.concessionaire-full-container.hide\n    opacity: 0\n    pointer-events: none\n\n.concessionaire-panoramic\n    position: absolute\n    width: 100%\n    height: 100%\n\n.concessionaire-panoramic-frame\n    width: 100%\n    height: 100%\n    border-style: none\n\n.concessionaire-panoramic-frame.portrait\n    position: relative","// ---- Tutorial de controles (rotar / zoom) ----\n.drag-animation-container\n  position: absolute\n  width: auto\n  height: 7.25rem\n  max-height: 50%\n  background: var(--av-glass)\n  backdrop-filter: var(--av-blur)\n  -webkit-backdrop-filter: var(--av-blur)\n  border: 1px solid var(--av-line)\n  border-radius: var(--av-radius-lg)\n  left: 50%\n  transform: translate(-50%, 0)\n  bottom: 1.5rem\n  display: flex\n  align-items: center\n\n.drag-animation-container.portrait\n  height: 7.25rem\n  bottom: 12rem\n\n.drag-animation-mouse\n  position: absolute\n  width: 1.5rem\n  height: 2rem\n  object-fit: contain\n  margin-top: 1rem\n  margin-bottom: 0.5rem\n  margin-left: 0.5rem\n\n.drag-animation-mouse.portrait\n  width: 1.5rem\n  height: 1.5rem\n\n.drag-animation-mouse-move\n  animation: move 8s infinite\n\n.drag-animation-container-main\n  position: relative\n  width: 12rem\n  height: 100%\n\n.drag-animation-container-main.portrait\n  width: 10.44rem\n  max-width: 100%\n\n.drag-animation-hr\n  width: 1px\n  background-color: var(--av-line-strong)\n  height: 60%\n\n.drag-animation-text\n  position: absolute\n  font-size: 0.75rem\n  line-height: 1.125rem\n  font-weight: 300\n  color: var(--av-text-2)\n  width: 85%\n  left: 50%\n  bottom: 12%\n  transform: translate(-50%, 0)\n  text-align: center\n\n.drag-animation-text.portrait\n  font-size: 0.75rem\n  line-height: 1.125rem\n\n.drag-animation-scroll-downs\n  position: relative\n  top: 12%\n  left: 50%\n  width: 1.5rem\n  height: 1.5rem\n  transform: translate(-50%, 0)\n\n.drag-animation-mousey\n  width: 0.375rem\n  padding: 0.375rem 0.5rem\n  height: 1.25rem\n  border: 1.25px solid var(--av-text)\n  border-radius: 2.5rem\n  box-sizing: content-box\n  display: flex\n  justify-content: center\n\n.drag-animation-scroller\n  width: 2px\n  height: 8px\n  border-radius: 2px\n  background-color: var(--av-accent)\n  animation-name: scroll\n  animation-duration: 2.2s\n  animation-timing-function: cubic-bezier(.15, .41, .69, .94)\n  animation-iteration-count: infinite\n\n@keyframes scroll\n  0%\n    opacity: 0\n  10%\n    transform: translateY(0)\n    opacity: 1\n  100%\n    transform: translateY(15px)\n    opacity: 0\n\n.drag-animation-mouse-center-top\n  position: absolute\n  width: 1.5rem\n  height: 1.5rem\n  object-fit: contain\n  margin-top: 1rem\n  margin-bottom: 0.5rem\n  left: 52.5%\n  transform: translate(-50%, 0)\n  animation: move-up 8s infinite\n\n.drag-animation-mouse-center-bottom\n  position: absolute\n  width: 1.5rem\n  height: 1.5rem\n  object-fit: contain\n  margin-top: 2rem\n  margin-bottom: 0.5rem\n  left: 42.5%\n  transform: translate(-50%, 0)\n  animation: move-bottom 8s infinite\n\n.drag-animation-touch-center-top\n  animation: move-up 4s infinite\n\n.drag-animation-touch-center-bottom\n  animation: move-bottom 4s infinite\n\n@keyframes move-bottom\n  0%\n    transform: translate(-45%, -20%)\n  50%\n    transform: translate(-150%, 0%)\n  100%\n    transform: translate(-45%, -20%)\n\n@keyframes move-up\n  0%\n    transform: translate(-45%, -20%)\n  50%\n    transform: translate(60%, -60%)\n  100%\n    transform: translate(-45%, -20%)\n\n// ---- Botón para mostrar / ocultar el panel lateral ----\n.car-studio-collapse-container\n  position: absolute\n  top: 1.5rem\n  left: calc(100% + 0.75rem)\n  display: flex\n  flex-direction: row\n  align-items: center\n  justify-content: flex-start\n  transition: left 0.8s var(--av-ease)\n  pointer-events: none\n\n.car-studio-collapse-container.collapsed\n  left: calc(100% + var(--av-sb-left) + 0.75rem)\n\n.car-studio-collapse-btn\n  width: 40px\n  height: 40px\n  box-sizing: border-box\n  flex-shrink: 0\n  background: var(--av-glass)\n  backdrop-filter: var(--av-blur)\n  -webkit-backdrop-filter: var(--av-blur)\n  border: 1px solid var(--av-line-strong)\n  border-radius: var(--av-radius)\n  cursor: pointer\n  display: flex\n  align-items: center\n  justify-content: center\n  pointer-events: auto\n  transition: background 0.3s var(--av-ease), border-color 0.3s var(--av-ease)\n  img\n    width: 1.125rem\n    height: 1.125rem\n    object-fit: contain\n    transform: rotate(0deg)\n    transition: transform 0.8s var(--av-ease)\n\n.car-studio-collapse-btn:hover\n  background: var(--av-glass-strong)\n\n.car-studio-collapse-btn.collapsed\n  img\n    transform: rotate(180deg)\n\n.car-studio-collapse-tutorial\n  margin-left: 0.75rem\n  width: 15rem\n  height: 4.5rem\n  background: var(--av-glass)\n  backdrop-filter: var(--av-blur)\n  -webkit-backdrop-filter: var(--av-blur)\n  border: 1px solid var(--av-line)\n  border-radius: var(--av-radius-lg)\n  display: flex\n  align-items: center\n  pointer-events: none\n  opacity: 1\n  transition: opacity 0.8s ease-in-out\n\n.car-studio-collapse-tutorial.hide\n  opacity: 0\n\n.collapse-animation-icon-container\n  position: relative\n  flex-shrink: 0\n  width: 4.5rem\n  height: 4.5rem\n\n.collapse-icon-animation\n  position: absolute\n  width: 2rem\n  height: 2rem\n  top: 0.875rem\n  left: 0.75rem\n  animation: cross-fade-mouse 2s infinite\n\n.collapse-icon\n  position: absolute\n  width: 1.5rem\n  height: 1.5rem\n  top: 1.875rem\n  left: 1.75rem\n\n.car-studio-collapse-tutorial-text\n  margin-right: 1rem\n  color: var(--av-text-2)\n  font-size: 0.75rem\n  line-height: 1.125rem\n\n.collapse-animation-text-reduced\n  font-weight: 300\n\n.fade-out\n  pointer-events: none\n  opacity: 0\n  transition: all 0.4s ease-in-out\n\n.fade-in\n  pointer-events: all\n  opacity: 1\n  transition: all 0.4s ease-in-out\n\n@keyframes cross-fade-mouse\n  0%\n    opacity: 1\n  50%\n    opacity: 0\n  100%\n    opacity: 1\n",".gallery-full-container\n  position: absolute\n  width: 100%\n  height: 100%\n  background: rgba(24, 24, 24, 0.9)\n  backdrop-filter: var(--av-blur)\n  -webkit-backdrop-filter: var(--av-blur)\n  opacity: 1\n  transition: opacity 0.8s ease-in-out\n\n.gallery-full-container.hide\n  pointer-events: none\n  opacity: 0\n  // Oculta de verdad al terminar el fundido: ningún hijo recibe clics\n  visibility: hidden\n  transition: opacity 0.8s ease-in-out, visibility 0s linear 0.8s\n\n// Mientras la galería (o una de sus vistas) no esté visible, nada dentro captura clics\n.gallery-full-container.hide *,\n.gallery-partial-container:not(.visible) *\n  pointer-events: none !important\n\n.gallery-partial-container\n  position: absolute\n  width: -webkit-fill-available\n  height: calc(100% - 2.5rem)\n  margin-top: 2.5rem\n  // ancho del panel lateral + márgenes\n  left: calc(var(--av-sb-left) + 19.25rem)\n  display: flex\n  flex-direction: row\n  justify-content: center\n  overflow-y: auto\n  transition: left 0.8s var(--av-ease), opacity 0.8s ease-in-out\n  opacity: 0\n  pointer-events: none\n\n.gallery-partial-container.visible\n  opacity: 1\n  pointer-events: auto\n\n.gallery-partial-container.extended\n  left: 1rem\n\n.gallery-partial-container.portrait\n  flex-direction: column\n  justify-content: space-around\n  align-items: center\n  left: 0\n  height: calc(100% - 1.25rem - 0.375rem)\n  margin-top: 1.25rem\n  margin-bottom: 0.375rem\n\n// Menú inferior de la galería (vertical)\n.gallery-partial-container-collage-menu\n  width: calc(100% - 1.5rem)\n  padding: 1rem 0\n  background: var(--av-glass)\n  border: 1px solid var(--av-line)\n  border-radius: var(--av-radius-lg)\n  display: flex\n  flex-direction: column\n  justify-content: space-between\n  align-items: center\n  gap: 0.875rem\n\n.gallery-partial-container-collage-title\n  color: var(--av-text)\n  font-size: 1rem\n  line-height: 1.5rem\n  font-weight: 300\n\n.gallery-partial-container-collage-buttons\n  width: 100%\n  display: flex\n  flex-direction: row\n  justify-content: space-between\n  align-items: center\n\n.gallery-partial-container-collage-logo\n  width: auto\n  height: 0.75rem\n  object-fit: contain\n  margin-left: 1rem\n  margin-right: 1.5rem\n\n.gallery-partial-container-collage-button\n  width: -webkit-fill-available\n  height: 40px\n  box-sizing: border-box\n  border: 1px solid var(--av-line-strong)\n  border-radius: var(--av-radius)\n  display: flex\n  align-items: center\n  justify-content: center\n  cursor: pointer\n  margin-right: 1rem\n  transition: background 0.3s var(--av-ease)\n\n.gallery-partial-container-collage-button:hover\n  background: var(--av-hover)\n\n.gallery-partial-container-collage-button-text\n  color: var(--av-text)\n  font-size: 0.875rem\n  line-height: 1.375rem\n  font-weight: 400\n\n// Collage\n.gallery-partial-container-collage\n  width: 90%\n  height: 100%\n  display: flex\n  justify-content: center\n\n.gallery-partial-container-collage.altportrait\n  height: calc(100% - 7.5rem)\n\n.gallery-collage-image\n  object-fit: contain\n  border-radius: var(--av-radius)\n  cursor: pointer\n  transition: filter 0.6s ease, transform 0.6s var(--av-ease)\n\n.gallery-collage-image:hover\n  filter: brightness(70%)\n\n// Imagen completa\n.gallery-partial-container-fullpicture\n  width: 90%\n  height: calc(100% - 2.5rem)\n  margin-bottom: 2.5rem\n  display: flex\n  justify-content: center\n  align-items: center\n\n.gallery-partial-container-fullpicture.portrait\n  height: calc(50% - 2.5rem)\n\n.gallery-partial-container-image\n  width: 100%\n  height: 100%\n  object-fit: cover\n  border-radius: var(--av-radius-lg)\n\n.gallery-partial-container-controls\n  width: 90%\n  height: calc(100% - 2.5rem)\n  margin-bottom: 2.5rem\n  display: flex\n  position: absolute\n  flex-direction: column\n  justify-content: flex-end\n  align-items: center\n  pointer-events: none\n\n.gallery-container-full-controls\n  display: flex\n  flex-direction: column\n  align-items: center\n  justify-content: flex-end\n  width: 14rem\n  margin-bottom: 1.25rem\n  padding: 0.875rem\n  background: var(--av-glass)\n  backdrop-filter: var(--av-blur)\n  -webkit-backdrop-filter: var(--av-blur)\n  border: 1px solid var(--av-line)\n  border-radius: var(--av-radius-lg)\n  pointer-events: auto\n\n.gallery-container-controls-navigation\n  width: 100%\n  display: flex\n  flex-direction: row\n  justify-content: space-between\n  align-items: center\n  margin-bottom: 0.75rem\n\n.gallery-container-controls-button\n  width: 40px\n  height: 40px\n  box-sizing: border-box\n  border: 1px solid var(--av-line-strong)\n  border-radius: var(--av-radius)\n  cursor: pointer\n  display: flex\n  align-items: center\n  justify-content: center\n  transition: background 0.3s var(--av-ease)\n  img\n    width: 1.125rem\n    height: 1.125rem\n    object-fit: contain\n\n.gallery-container-controls-button:hover\n  background: var(--av-hover)\n\n.gallery-container-controls-button.right\n  img\n    transform: rotate(180deg)\n\n.gallery-container-controls-subtitle\n  color: var(--av-text-2)\n  font-size: 0.875rem\n  line-height: 1.375rem\n  font-weight: 400\n  letter-spacing: 0.08em\n  font-variant-numeric: tabular-nums\n\n.gallery-controls-button\n  width: 100%\n  height: 40px\n  box-sizing: border-box\n  border: 1px solid var(--av-line-strong)\n  border-radius: var(--av-radius)\n  display: flex\n  align-items: center\n  justify-content: center\n  cursor: pointer\n  transition: background 0.3s var(--av-ease)\n\n.gallery-controls-button:hover\n  background: var(--av-hover)\n\n.gallery-controls-button-text\n  color: var(--av-text)\n  font-size: 0.875rem\n  line-height: 1.375rem\n  font-weight: 400\n",".intro-container\n  position: absolute\n  width: 100%\n  height: 100%\n  background-color: #222222\n  background-repeat: no-repeat\n  background-size: cover\n  background-position: center 50%\n  object-fit: cover\n  opacity: 1\n  transition: opacity 0.8s ease-in-out\n\n.intro-container.hide-container\n  opacity: 0\n  pointer-events: none\n\n.intro-content\n  width: 100%\n  height: 100%\n  display: flex\n  justify-content: space-between\n  align-items: center\n  flex-direction: column\n\n.intro-top\n  display: flex\n  justify-content: center\n  align-items: center\n  flex-direction: column\n\n.intro-top-title-icon\n  height: clamp(0.75rem, 6vw, 8rem)\n  margin-top: 11svh\n  aspect-ratio: 949 / 230\n\n.intro-top-title-icon.portrait\n  height: unset\n  width: 60%\n\n.intro-top-title\n  color: #FFFFFF\n  font-size: clamp(0.75rem, 5vw, 4.625rem)\n  font-family: var(--av-font)\n  font-weight: 400\n  text-align: center\n  margin-top: 11svh\n\n.intro-top-title.portrait\n  font-size: clamp(0.75rem, 15vw, 4.625rem)\n  margin-top: 4svh\n\n.intro-top-subtitle\n  color: #FFFFFF\n  font-size: clamp(0.75rem, 2vw, 1.875rem)\n  font-family: var(--av-font)\n  font-weight: 400\n  text-align: center\n\n.intro-top-subtitle.portrait\n  font-size: clamp(0.75rem, 6vw, 1.875rem)\n\n.intro-bottom\n  display: flex\n  width: 70%\n  justify-content: center\n  align-items: center\n  flex-direction: column\n  margin-bottom: 2.3125rem\n.intro-bottom.portrait\n  width: 95%\n  margin-bottom: 2.5rem\n\n.intro-bottom-line\n  width: 100%\n  height: 2px\n  background: #FFFFFF\n\n.intro-bottom-security\n  width: 100%\n  margin-top: 1.25rem\n  aspect-ratio: 907 / 96\n  object-fit: contain\n\n.intro-bottom-security.portrait\n  aspect-ratio: 320 / 46\n\n.intro-bottom-button\n  display: flex\n  align-items: center\n  justify-content: center\n  margin-top: 2rem\n  max-width: calc(100% - 4rem)\n  border: 1px solid rgba(238, 103, 103, 1)\n  background: #DD4040 0% 0% no-repeat padding-box\n  box-shadow: -2px 2px 6px rgba(50, 58, 79, 0.16)\n  border-radius: 10rem\n  \n  transition: background 0.2s ease-in-out\n  color: #FFFFFF\n  font-size: clamp(0.75rem, 2vw, 1.875rem)\n  font-family: var(--av-font)\n  font-weight: 400\n  text-align: center\n  padding: 0.5rem 2rem 0.5rem 2rem\n  \n.intro-bottom-button.portrait\n  max-width: calc(100% - 8rem)\n  font-size: clamp(0.5rem, 5vw, 1.2rem)\n  padding: 0.5rem 4rem 0.5rem 4rem\n\n.intro-bottom-button:hover\n  background: #B33131 0% 0% no-repeat padding-box\n  cursor: pointer",".full-loading-screen-container\n  width: 100%\n  height: 100%\n  display: flex\n  position: absolute\n  pointer-events: none\n\n.loading-screen-container\n  position: absolute\n  width: 100%\n  height: 100%\n  display: flex\n  justify-content: center\n  align-items: center\n  background-color: rgba(0, 48, 87, 0.6)\n  backdrop-filter: blur(10px)\n  pointer-events: auto\n\n.loading-screen-container.expand\n  width: calc(100% - 2rem)\n  left: 2rem",".loading-container\n  position: absolute\n  width: 100%\n  height: 100%\n  background: var(--av-bg)\n  opacity: 1\n  transition: opacity 0.9s ease-in-out\n\n.loading-container.hide-container\n  opacity: 0\n  pointer-events: none\n\n.loading-progress\n  width: 100%\n  height: 100%\n  display: flex\n  justify-content: center\n  align-items: center\n  flex-direction: column\n\n.loading-post-logo\n  height: 1.5rem\n  width: auto\n  max-width: 60%\n  object-fit: contain\n  margin-bottom: 3.5rem\n  animation: loading-breath 2.4s ease-in-out infinite\n\n.loading-post-logo.portrait\n  height: 1.125rem\n  margin-bottom: 2.5rem\n\n.loading-progress-bar\n  max-width: 32rem\n  width: 70%\n  height: 2px\n\n.loading-progress-info\n  max-width: 32rem\n  width: 70%\n  display: flex\n  justify-content: space-between\n  align-items: baseline\n  gap: 1rem\n  margin-top: 1rem\n\n.loading-progress-message\n  color: var(--av-text-3)\n  font-size: 0.75rem\n  line-height: 1.125rem\n  font-weight: 400\n  letter-spacing: 0.08em\n\n.loading-progress-message.portrait\n  font-size: 0.75rem\n  line-height: 1.125rem\n\n.loading-progress-value\n  color: var(--av-text)\n  font-size: 0.75rem\n  line-height: 1.125rem\n  font-weight: 400\n  letter-spacing: 0.08em\n  font-variant-numeric: tabular-nums\n\n@keyframes loading-breath\n  0%, 100%\n    opacity: 0.55\n  50%\n    opacity: 1\n",".pdfviewer-global\n  display: flex\n  position: absolute\n  width: 100%\n  height: 100%\n  background: rgba(0,0,0,0.8) 0% 0% no-repeat padding-box\n  backdrop-filter: blur(5px)\n  justify-content: center\n  align-items: center\n  z-index: 2\n  opacity: 0\n  transition: opacity 0.8s ease-in-out\n  pointer-events: none\n\n.pdfviewer-global.visible\n  opacity: 1\n  pointer-events: auto\n\n.pdfviewer-menu\n  display: flex\n  width: 97.87rem\n  height: 51.56rem\n  max-width: 85%\n  max-height: 85%\n  background: #fff\n  border-radius: 10px\n  justify-content: space-evenly\n  align-items: center\n  flex-direction: column\n\n.pdfviewer-menu.portrait\n  width: calc(100% - 1.25rem)\n  height: calc(100% - 1.25rem)\n  max-width: unset\n  max-height: unset\n.pdfviewer-container\n  width: 99%\n  height: 90%\n  --rpv-core__page-layer-box-shadow: 0px 0px 0px 0 rgba(0, 0, 0, 0.0) //para eliminar sombras de las páginas\n\n.pdfviewer-close-btn\n  width: 14.1875rem\n  height: 2.25rem\n  background: #DD4040\n  border-radius: 5px\n  display: flex\n  align-items: center\n  justify-content: space-evenly\n  cursor: pointer\n  border: 1px solid rgba(238, 103, 103, 1)\n  font-family: var(--av-font)\n  font-weight: 400\n  font-size: clamp(0.1rem, 4vw, 0.8rem)\n  color: #fff\n\n\n.pdfviewer-close-btn:hover\n  box-shadow: 0px 0px 6px #000000\n    \n\n//sobre escribir estilos por defecto del visor\n.rpv-default-layout__toolbar\n  background-color: #fff\n  border-bottom: 0px\n\n.rpv-core__icon\n  stroke-width: 2\n\n.rpv-default-layout__container\n  border: 0px\n\n\n.rpv-default-layout__sidebar--ltr\n  border-right: 0px\n\n.rpv-default-layout__sidebar-headers\n  background-color: #fff",".pc-full-container\n  position: absolute\n  width: 100%\n  height: 100%\n\n.pc-full-container.portrait\n  //position: relative\n\n.pc-container\n  position: absolute\n  width: 100%\n  height: 100%\n  opacity: 0\n  border-style: none\n  transition: opacity 1s ease\n\n.pc-container.portrait\n  position: relative\n  height: calc(100% + 0.625rem)\n\n.pc-container.visible\n  opacity: 1",".screenshot-full-container\n  position: absolute\n  width: 100%\n  height: calc(100% - 3.75rem)\n  background: transparent\n  pointer-events: none\n  opacity: 1\n  transition: opacity 0.8s ease-in-out, background 0.8s ease-in-out\n\n.screenshot-full-container.portrait\n  height: 100%\n  z-index: 1\n\n.screenshot-full-container.background\n  height: 100%\n  background: rgba(24, 24, 24, 0.9)\n  backdrop-filter: var(--av-blur)\n  -webkit-backdrop-filter: var(--av-blur)\n\n.screenshot-full-container.hide\n  opacity: 0\n\n// Retícula\n.screenshot-reticle-container\n  position: absolute\n  width: 100%\n  height: 100%\n  display: flex\n  align-items: center\n  justify-content: center\n\n.screenshot-reticle-rows\n  width: 55%\n  height: 68%\n  display: flex\n  flex-wrap: wrap\n  align-content: space-between\n\n.screenshot-reticle-rows.portrait\n  width: 90%\n  height: 50%\n\n.screenshot-reticle-columns\n  width: 100%\n  display: flex\n  flex-direction: row\n  justify-content: space-between\n\n%reticle-corner\n  width: 2.5rem\n  height: 2.5rem\n  border: 1.5px solid var(--av-text)\n\n.screenshot-reticle-tl\n  @extend %reticle-corner\n  border-bottom-width: 0\n  border-right-width: 0\n.screenshot-reticle-tr\n  @extend %reticle-corner\n  border-bottom-width: 0\n  border-left-width: 0\n.screenshot-reticle-bl\n  @extend %reticle-corner\n  border-top-width: 0\n  border-right-width: 0\n.screenshot-reticle-br\n  @extend %reticle-corner\n  border-top-width: 0\n  border-left-width: 0\n\n.screenshot-reticle-tl.portrait,\n.screenshot-reticle-tr.portrait,\n.screenshot-reticle-bl.portrait,\n.screenshot-reticle-br.portrait\n  width: 1.25rem\n  height: 1.25rem\n\n// Botón de captura\n.screenshot-capture-container\n  position: absolute\n  height: 100%\n  display: flex\n  justify-content: flex-start\n  align-content: center\n  flex-wrap: wrap\n  pointer-events: auto\n\n.screenshot-capture-container.portrait\n  width: 100%\n  justify-content: center\n  align-content: flex-end\n\n.screenshot-capture-container.hide\n  pointer-events: none\n\n.screenshot-capture-center\n  height: 4rem\n  margin-left: 1.75rem\n  display: flex\n  align-items: center\n\n.screenshot-capture-center.portrait\n  height: 3.5rem\n  margin-left: 0\n  margin-bottom: 1.5rem\n\n.screenshot-capture-icon\n  height: 100%\n  cursor: pointer\n  transition: transform 0.2s linear, filter 0.3s linear\n\n.screenshot-capture-icon:hover\n  transform: scale(1.05)\n  filter: drop-shadow(0 6px 12px rgba(180, 215, 25, 0.6))\n\n.screenshot-capture-msg\n  margin-left: 1rem\n  padding: 0.75rem 1rem\n  background: var(--av-glass)\n  backdrop-filter: var(--av-blur)\n  -webkit-backdrop-filter: var(--av-blur)\n  border: 1px solid var(--av-line)\n  border-radius: var(--av-radius-lg)\n  display: flex\n  align-items: center\n\n.screenshot-capture-text\n  color: var(--av-text-2)\n  font-size: 0.875rem\n  line-height: 1.375rem\n\n// Vista previa\n.screenshot-preview-container\n  position: absolute\n  width: 100%\n  height: 100%\n  display: flex\n  justify-content: center\n  align-content: center\n  flex-wrap: wrap\n  pointer-events: auto\n\n.screenshot-preview-container.hide\n  pointer-events: none\n\n.screenshot-preview-center\n  width: 80%\n  height: 80%\n  display: flex\n  flex-direction: row\n  justify-content: center\n  align-items: center\n\n.screenshot-preview-center.portrait\n  width: 90%\n  height: auto\n  flex-direction: column\n\n.screenshot-preview-image\n  width: 60%\n  max-height: 100%\n  aspect-ratio: 905/509\n  border-radius: var(--av-radius-lg)\n  border: 1px solid var(--av-line)\n  background-size: cover\n  background-repeat: no-repeat\n  background-position: center\n\n.screenshot-preview-image.portrait\n  width: 100%\n  max-height: 60%\n  aspect-ratio: 1\n\n.screenshot-preview-confirmation\n  width: calc(40% - 4rem)\n  margin-left: 4rem\n  display: flex\n  flex-direction: column\n  justify-content: center\n\n.screenshot-preview-confirmation.portrait\n  width: 100%\n  margin-left: 0\n\n.screenshot-preview-confirmation-title\n  color: var(--av-text)\n  font-size: 2.25rem\n  line-height: 3.375rem\n  font-weight: 300\n\n.screenshot-preview-confirmation-title.portrait\n  font-size: 1.25rem\n  line-height: 1.75rem\n  text-align: center\n  margin: 1.25rem 0\n\n.screenshot-preview-confirmation-buttons\n  display: flex\n  flex-direction: column\n  gap: 0.625rem\n  margin-top: 2.5rem\n\n.screenshot-preview-confirmation-buttons.portrait\n  margin-top: 0\n\n%screenshot-button\n  width: 100%\n  min-width: 112px\n  max-width: 18rem\n  height: 40px\n  box-sizing: border-box\n  padding: 0 20px\n  border-radius: var(--av-radius)\n  display: flex\n  align-items: center\n  justify-content: center\n  cursor: pointer\n\n.screenshot-preview-button-download\n  @extend %screenshot-button\n  background: var(--av-text)\n  box-shadow: 0 12px 20px -12px rgba(180, 215, 25, 0)\n  transition: transform 0.2s linear, box-shadow 0.3s linear\n\n.screenshot-preview-button-download:hover\n  transform: translate3d(0, -2px, 0)\n  box-shadow: 0 14px 22px -10px rgba(180, 215, 25, 0.85)\n\n.screenshot-preview-button-retake\n  @extend %screenshot-button\n  border: 1px solid var(--av-line-strong)\n  transition: background 0.3s var(--av-ease)\n\n.screenshot-preview-button-retake:hover\n  background: var(--av-hover)\n\n.screenshot-preview-button-download.portrait,\n.screenshot-preview-button-retake.portrait\n  max-width: 100%\n\n.screenshot-preview-button-download-text,\n.screenshot-preview-button-retake-text\n  font-size: 0.875rem\n  line-height: 1.375rem\n  font-weight: 400\n  letter-spacing: 0.02em\n\n.screenshot-preview-button-download-text\n  color: var(--av-ink)\n\n.screenshot-preview-button-retake-text\n  color: var(--av-text)\n\n.screenshot-return-button\n  position: absolute\n  margin-left: 1.25rem\n  margin-top: 1.25rem\n  height: 40px\n  box-sizing: border-box\n  padding: 0 12px\n  background: var(--av-glass)\n  backdrop-filter: var(--av-blur)\n  -webkit-backdrop-filter: var(--av-blur)\n  border: 1px solid var(--av-line-strong)\n  border-radius: var(--av-radius)\n  display: flex\n  align-items: center\n  pointer-events: auto\n  cursor: pointer\n\n.screenshot-return-button.hide\n  pointer-events: none\n\n.screenshot-return-text\n  color: var(--av-text)\n  font-size: 0.875rem\n  line-height: 1.375rem\n  font-weight: 400\n",".studio-full-container\n  position: absolute\n  width: 100%\n  height: 100%\n  opacity: 1\n  transition: opacity 0.8s ease-in-out\n\n.studio-full-container.portrait\n  display: flex\n  flex-direction: column\n  justify-content: space-between\n\n.studio-full-container.hide\n  opacity: 0\n  pointer-events: none\n\n// Capas ocultas: ningún hijo (aunque tenga pointer-events: auto) debe recibir clics\n.studio-full-container.hide *,\n.studio-full-siderbar.hide *\n  pointer-events: none !important\n\n.studio-3d-container\n  position: absolute\n  width: 100%\n  height: 100%\n\n// ---- Topbar (Atrás + música): botones secundarios pequeños, alto 40, borde 1px #FFFFFF ----\n.studio-full-siderbar\n  display: flex\n  position: absolute\n  height: 100%\n  left: var(--av-sb-left)\n  align-items: flex-start\n  flex-direction: column\n  pointer-events: none\n  opacity: 1\n  transition: opacity 0.8s ease-in-out\n\n.studio-full-siderbar.hide\n  opacity: 0\n\n.studio-sidebar-topbar\n  display: flex\n  gap: 0.5rem\n  height: 40px\n  margin-top: 1.25rem\n  margin-bottom: 0.75rem\n  position: relative\n\n.studio-sidebar-topbar.portrait\n  position: absolute\n  height: 40px\n  margin-left: 1.25rem\n  margin-top: 1.25rem\n  margin-bottom: unset\n  z-index: 2\n\n.studio-sidebar-topbar-button,\n.studio-sidebar-topbar-music\n  height: 100%\n  box-sizing: border-box\n  background: var(--av-glass)\n  backdrop-filter: var(--av-blur)\n  -webkit-backdrop-filter: var(--av-blur)\n  border: 1px solid var(--av-line-strong)\n  border-radius: var(--av-radius)\n  display: flex\n  align-items: center\n  justify-content: center\n  cursor: pointer\n  pointer-events: auto\n  transition: background 0.3s var(--av-ease), border-color 0.3s var(--av-ease)\n\n.studio-sidebar-topbar-button:hover,\n.studio-sidebar-topbar-music:hover\n  background: var(--av-glass-strong)\n\n.studio-sidebar-topbar-button\n  gap: 0.25rem\n  padding: 0 12px 0 8px\n\n.studio-sidebar-topbar-icon\n  width: 1.125rem\n  height: 1.125rem\n\n.studio-sidebar-topbar-text\n  color: var(--av-text)\n  font-size: 0.875rem\n  line-height: 1.375rem\n  font-weight: 400\n\n.studio-sidebar-topbar-music\n  aspect-ratio: 1\n  img\n    width: 1rem\n    height: 1rem\n    object-fit: contain\n    opacity: 0.9\n\n// ---- Panel lateral ----\n.studio-sidebar-container\n  display: flex\n  flex-direction: column\n  pointer-events: auto\n  position: relative\n  width: 18rem\n  height: calc(100% - 40px - 1.25rem - 0.75rem - 1.25rem)\n  margin-bottom: 1.25rem\n  left: 0\n  background: var(--av-glass)\n  backdrop-filter: var(--av-blur)\n  -webkit-backdrop-filter: var(--av-blur)\n  border: 1px solid var(--av-line)\n  border-radius: var(--av-radius-lg)\n  transition: left 0.8s var(--av-ease)\n\n// Sale completo de pantalla; el botón de colapso queda alineado con la topbar\n.studio-sidebar-container.collapsed\n  left: calc(-18rem - var(--av-sb-left) - 0.75rem)\n\n.studio-sidebar-subcontainer\n  position: relative\n  height: 100%\n  padding: 1.75rem 1.75rem 1.5rem\n  box-sizing: border-box\n  display: flex\n  flex-direction: column\n  overflow-y: auto\n  overflow-x: hidden\n\n.studio-sidebar-header\n  display: flex\n  flex-direction: column\n\n.studio-sidebar-header-logo\n  order: 0\n  height: 0.75rem\n  width: auto\n  align-self: flex-start\n  object-fit: contain\n\n.studio-sidebar-header-subtitle\n  order: 1\n  display: flex\n  align-items: center\n  gap: 0.625rem\n  margin-top: 2.5rem\n  color: var(--av-text-3)\n  font-size: 0.75rem\n  line-height: 1.125rem\n  font-weight: 400\n  letter-spacing: var(--av-tracking)\n  text-transform: uppercase\n  &::before\n    content: ''\n    width: 1rem\n    height: 1px\n    background: var(--av-accent)\n\n.studio-sidebar-header-title\n  order: 2\n  margin-top: 0.625rem\n  color: var(--av-text)\n  font-size: 1.75rem\n  line-height: 2.625rem\n  font-weight: 300\n\n// Secciones (Vista / Color)\n.studio-sidebar-section\n  margin-top: 2.25rem\n\n.studio-sidebar-section-title,\n.studio-sidebar-color-title\n  color: var(--av-text-3)\n  font-size: 0.75rem\n  line-height: 1.125rem\n  font-weight: 400\n  letter-spacing: var(--av-tracking)\n  text-transform: uppercase\n  margin-bottom: 0.875rem\n\n// Selector segmentado Exterior / Interior (alto total 40px)\n.studio-sidebar-view\n  display: flex\n  gap: 4px\n  padding: 4px\n  border: 1px solid var(--av-line)\n  border-radius: var(--av-radius)\n\n.studio-sidebar-view-button-container\n  flex: 1\n  height: 30px\n  cursor: pointer\n\n.studio-sidebar-view-button\n  width: 100%\n  height: 100%\n  border-radius: 2px\n  display: flex\n  align-items: center\n  justify-content: center\n  background: transparent\n  transition: background 0.3s var(--av-ease)\n\n.studio-sidebar-view-button:hover\n  background: var(--av-hover)\n\n.studio-sidebar-view-button.selected\n  background: var(--av-text)\n\n.studio-sidebar-view-text\n  color: var(--av-text-2)\n  font-size: 0.875rem\n  line-height: 1.375rem\n  font-weight: 400\n  letter-spacing: 0.02em\n  transition: color 0.3s var(--av-ease)\n\n.studio-sidebar-view-text.selected\n  color: var(--av-ink)\n\n// Color\n.studio-sidebar-color\n  margin-top: 2.25rem\n\n.studio-sidebar-color-subcontainer\n  display: flex\n  flex-direction: column\n\n// Selector de color (igual que avatr.com/en/07): bolita de 32px sobre un área de 48px.\n// La activa (y la que está bajo el cursor) muestra un halo #E5E5E5 de 48px y su nombre.\n.studio-sidebar-color-selection\n  display: flex\n  flex-wrap: wrap\n  // las áreas de 48px sobresalen 8px del ancho útil del panel\n  margin: 0 -8px\n\n.studio-sidebar-color-element\n  position: relative\n  width: 48px\n  height: 48px\n  display: flex\n  justify-content: center\n  align-items: center\n  cursor: pointer\n  &::before\n    content: ''\n    position: absolute\n    inset: 0\n    border-radius: 50%\n    background-color: #e5e5e5ee\n    opacity: 0\n    transform: scale(0.8)\n    transition: opacity 0.3s linear, transform 0.3s var(--av-ease)\n\n.studio-sidebar-color-element.selected::before,\n.studio-sidebar-color-element:hover::before\n  opacity: 1\n  transform: scale(1)\n\n// Mientras el cursor está sobre otra bolita, el halo pasa a esa (como en avatr.com)\n.studio-sidebar-color-selection:hover .studio-sidebar-color-element.selected:not(:hover)::before\n  opacity: 0\n  transform: scale(0.8)\n\n.studio-sidebar-color-img\n  position: relative\n  z-index: 1\n  width: 32px\n  height: 32px\n  border-radius: 50%\n  object-fit: contain\n\n.studio-sidebar-color-text\n  margin-top: 0.5rem\n  animation: av-color-name 0.3s linear\n  color: var(--av-text)\n  font-size: 1rem\n  line-height: 1.5rem\n  font-weight: 300\n\n// Acciones\n.studio-sidebar-options\n  display: flex\n  flex-direction: column\n  gap: 0.5rem\n  margin-top: auto\n  padding-top: 2rem\n\n.studio-sidebar-options-button\n  width: 100%\n  height: 40px\n  box-sizing: border-box\n  flex-shrink: 0\n  background: transparent\n  border: 1px solid var(--av-line-strong)\n  border-radius: var(--av-radius)\n  display: flex\n  align-items: center\n  justify-content: center\n  cursor: pointer\n  transition: background 0.3s var(--av-ease), border-color 0.3s var(--av-ease)\n\n.studio-sidebar-options-button:hover\n  background: var(--av-hover)\n\n.studio-sidebar-options-button.av-btn-primary\n  margin-top: 0.25rem\n\n.studio-sidebar-options-text\n  width: 100%\n  color: var(--av-text)\n  font-size: 0.875rem\n  line-height: 1.375rem\n  font-weight: 400\n  text-align: center\n\n// ---- Componentes desactivados (luces, escenarios, asientos) ----\n.studio-sidebar-lights\n  display: flex\n  align-items: center\n  margin-top: 1.5rem\n\n.studio-sidebar-lights-title\n  color: var(--av-text)\n  font-size: 0.875rem\n  line-height: 1.375rem\n  margin-left: 0.625rem\n\n// Escenarios: mismo selector segmentado que Vista (alto total 40px)\n.studio-sidebar-scenario-subcontainer\n  display: flex\n  flex-direction: column\n  margin-top: 2.25rem\n\n.studio-sidebar-scenario-title\n  color: var(--av-text-3)\n  font-size: 0.75rem\n  line-height: 1.125rem\n  font-weight: 400\n  letter-spacing: var(--av-tracking)\n  text-transform: uppercase\n  margin-bottom: 0.875rem\n\n.studio-sidebar-scenario-selection\n  display: flex\n  gap: 4px\n  padding: 4px\n  border: 1px solid var(--av-line)\n  border-radius: var(--av-radius)\n\n.studio-sidebar-scenario-button-container\n  flex: 1\n  min-width: 0\n  height: 30px\n  cursor: pointer\n\n.studio-sidebar-scenario-button\n  width: 100%\n  height: 100%\n  border-radius: 2px\n  display: flex\n  align-items: center\n  justify-content: center\n  background: transparent\n  transition: background 0.3s var(--av-ease)\n\n.studio-sidebar-scenario-button:hover\n  background: var(--av-hover)\n\n.studio-sidebar-scenario-button.selected\n  background: var(--av-text)\n\n.studio-sidebar-scenario-text\n  color: var(--av-text-2)\n  font-size: 0.875rem\n  line-height: 1.375rem\n  font-weight: 400\n  white-space: nowrap\n  overflow: hidden\n  text-overflow: ellipsis\n  transition: color 0.3s var(--av-ease)\n\n.studio-sidebar-scenario-text.selected\n  color: var(--av-ink)\n\n.studio-sidebar-seats\n  pointer-events: none\n  margin-top: 2.25rem\n\n.studio-sidebar-seats.enabled\n  pointer-events: auto\n\n.studio-sidebar-seats-subcontainer\n  display: flex\n  flex-direction: column\n  align-items: center\n\n.studio-sidebar-seats-title\n  color: var(--av-text-3)\n  font-size: 0.75rem\n  line-height: 1.125rem\n  letter-spacing: var(--av-tracking)\n  text-transform: uppercase\n  margin-bottom: 1rem\n\n.studio-sidebar-icon-container\n  width: 50%\n  display: flex\n  flex-direction: column\n\n.studio-sidebar-icon-row\n  display: flex\n\n.studio-sidebar-seat-icon\n  width: 45%\n  aspect-ratio: 1\n  border: 1px solid var(--av-line-strong)\n  border-radius: var(--av-radius)\n  margin: 0.25rem\n  cursor: pointer\n  transition: background 0.3s var(--av-ease)\n\n.studio-sidebar-seat-icon.selected\n  background: var(--av-text)\n\n\n@keyframes av-color-name\n  from\n    opacity: 0\n  to\n    opacity: 1\n","// TEMPORAL: visor de imágenes de la vista interior (ver interior.viewer.component.tsx)\n.interior-viewer\n  // fixed: cubre toda la pantalla aunque el contenedor 3D esté desplazado en vertical;\n  // topbar, panel lateral y barra inferior se dibujan encima por orden en el DOM\n  position: fixed\n  inset: 0\n  background: var(--av-bg)\n  opacity: 1\n  transition: opacity 0.6s ease-in-out\n\n.interior-viewer.hide\n  opacity: 0\n  pointer-events: none\n  visibility: hidden\n  transition: opacity 0.6s ease-in-out, visibility 0s linear 0.6s\n  *\n    pointer-events: none !important\n\n// Vertical: imagen completa entre la topbar y la barra inferior\n.interior-viewer.portrait\n  display: flex\n  flex-direction: column\n  justify-content: center\n  align-items: center\n  padding: 72px 0 216px\n  box-sizing: border-box\n\n.interior-viewer-stage\n  position: absolute\n  inset: 0\n\n.interior-viewer-stage.portrait\n  position: relative\n  inset: auto\n  width: 100%\n  aspect-ratio: 4320 / 2400\n\n.interior-viewer-image\n  position: absolute\n  inset: 0\n  width: 100%\n  height: 100%\n  object-fit: cover\n  opacity: 0\n  transition: opacity 0.6s ease-in-out\n  -webkit-user-drag: none\n\n.interior-viewer-image.visible\n  opacity: 1\n\n.interior-viewer-image.portrait\n  object-fit: contain\n\n// Controles: botones secundarios de 40px (borde 1px #FFFFFF, radio 4)\n.interior-viewer-controls\n  position: absolute\n  bottom: 1.5rem\n  // centrado en el área libre a la derecha del panel lateral\n  left: calc(50% + (18rem + var(--av-sb-left)) / 2)\n  transform: translateX(-50%)\n  display: flex\n  align-items: center\n  gap: 12px\n  padding: 8px\n  background: var(--av-glass)\n  backdrop-filter: var(--av-blur)\n  -webkit-backdrop-filter: var(--av-blur)\n  border: 1px solid var(--av-line)\n  border-radius: var(--av-radius-lg)\n  transition: left 0.8s var(--av-ease)\n\n.interior-viewer.extended .interior-viewer-controls\n  left: 50%\n\n.interior-viewer-controls.portrait\n  position: relative\n  bottom: auto\n  left: auto\n  transform: none\n  margin-top: 1rem\n\n.interior-viewer.portrait .interior-viewer-controls\n  left: auto\n\n.interior-viewer-button\n  width: 40px\n  height: 40px\n  box-sizing: border-box\n  border: 1px solid var(--av-line-strong)\n  border-radius: var(--av-radius)\n  display: flex\n  align-items: center\n  justify-content: center\n  cursor: pointer\n  transition: background 0.3s var(--av-ease)\n  img\n    width: 1.125rem\n    height: 1.125rem\n    object-fit: contain\n\n.interior-viewer-button:hover\n  background: var(--av-hover)\n\n.interior-viewer-indicators\n  display: flex\n  align-items: center\n  gap: 8px\n  padding: 0 4px\n\n.interior-viewer-indicator\n  height: 40px\n  display: flex\n  align-items: center\n  cursor: pointer\n\n.interior-viewer-indicator-line\n  width: 1.5rem\n  height: 2px\n  background: var(--av-gray-2)\n  transition: width 0.4s var(--av-ease), background 0.4s var(--av-ease)\n\n.interior-viewer-indicator.selected .interior-viewer-indicator-line\n  width: 2.75rem\n  background: var(--av-text)\n\n.interior-viewer-counter\n  min-width: 2.5rem\n  color: var(--av-text-2)\n  font-size: 0.75rem\n  line-height: 1.125rem\n  text-align: center\n  font-variant-numeric: tabular-nums\n","@use './ipad_portrait' as ipad\n    \n@media screen and (orientation: portrait) and (min-width: 1000px) and (min-height: 1000px)\n  @include ipad.ipad-portrait\n\n  ","@mixin ipad-portrait\n  \n  .carousel-info-title.portrait\n    width: calc(100% - 4.53125rem)\n    font-size: 3rem\n    line-height: 4.5rem\n    margin-bottom: 1.125rem\n    margin-right: 4.53125rem\n\n  .carousel-info-desc.portrait\n    margin-left: 4.53125rem\n    margin-top: 2.875rem\n    width: calc(100% - 4.53125rem)\n\n  .carousel-info-specs.portrait\n    margin-right: 4.53125rem\n    margin-bottom: 2.73875rem\n    width: calc(100% - 4.53125rem)\n\n  .carousel-info-options.portrait\n    justify-content: center\n    margin-right: 4.53125rem\n  .carousel-info-options-buttonnav    \n    max-width: unset\n\n  .carousel-info-options-button.portrait\n    width: 31.25rem\n    margin-bottom: 3rem\n\n  .carousel-info-options-button-text.portrait\n    font-size: 1.25rem\n    line-height: 1.75rem\n\n  .carousel-info-options-navegation-next.portrait\n    height: 3.5rem\n    width: 3.5rem\n\n  .carousel-bullet-container.portrait\n    height: 2.5rem\n\n  .carousel-seal-container.portrait\n    height: 7.375rem\n    top: -7.375rem\n    bottom: unset\n\n  .studio-sidebar-topbar.portrait\n    height: 2.75rem\n    margin-left: 1.25rem\n    margin-top: 1.25rem\n\n  .studio-sidebar-topbar-text.portrait\n    font-size: 1rem\n    line-height: 1.5rem\n\n  .studio-sidebar-topbar-music.portrait\n    img\n      width: 1.25rem\n      height: 1.25rem\n\n  .drag-animation-container.portrait\n    bottom: 20rem//40%\n\n  .drag-animation-text.portrait\n    font-size: 0.75rem\n    line-height: 1.125rem\n\n  .bullet-sidebar-container.portrait\n    width: 35rem\n\n  .bullet-container-content.portrait\n    padding-bottom: 2rem\n    height: 15.625rem\n\n  .bullet-container-title.portrait\n    font-size: 1.25rem\n    line-height: 1.75rem\n    margin-bottom: 1.25rem\n\n  .bullet-container-desc.portrait\n    font-size: 1rem\n    line-height: 1.5rem\n\n  .bullet-container-banner-button.portrait\n    width: 2.5rem\n    height: 2.5rem\n    top: 1rem\n    right: 1rem\n\n  .bottombar-full-container\n    width: 39.375rem\n    margin-bottom: 1.25rem\n\n  .bottombar-full-container.hidden\n    bottom: -13.625rem //////modificar\n\n  .bottombar-menu-title\n    font-size: 1.5rem\n    line-height: 2rem\n    margin-top: 0.75rem\n\n  .bottombar-menu-container\n    margin-top: 1.875rem\n\n  .bottombar-menu-view\n    height: 5rem\n\n  .bottombar-menu-color\n    height: 5rem\n\n  .bottombar-view-logo\n    height: 1rem\n\n  .bottombar-view-button-container\n    width: 10rem\n    height: 2.5rem\n\n  .bottombar-view-text\n    font-size: 1.25rem\n    line-height: 1.75rem\n\n  .bottombar-main-container\n    max-width: calc(100% - 1.25rem)\n    height: auto\n    margin: 0.5rem 0rem 0.875rem 0rem\n\n  .bottombar-main-button\n    width: 6.25rem\n    height: 4.5625rem\n\n  .bottombar-main-button-text\n    font-size: 1rem\n    line-height: 1.5rem\n\n  // En iPad se usan las medidas de escritorio de avatr.com: halo 48px, bolita 32px\n  .bottombar-color-element\n    width: 48px\n    height: 48px\n\n  .bottombar-color-img\n    width: 32px\n    height: 32px\n\n  .bottombar-color-text\n    font-size: 1rem\n    line-height: 1.5rem\n    margin-bottom: 1rem\n  \n  .gallery-partial-container-collage.altportrait\n    height: calc(100% - 11.875rem - 1.25rem)\n\n  .gallery-partial-container-collage-menu\n    max-width: 98%\n    width: 61.5rem\n    height: 11.875rem\n\n  .gallery-partial-container-collage-title\n    font-size: 1.5rem\n    line-height: 2rem\n    margin-top: 2.53125rem\n\n  .gallery-partial-container-collage-buttons\n    justify-content: center\n    margin-bottom: 1.25rem\n\n  .gallery-partial-container-collage-logo\n    height: 1rem\n    object-fit: contain\n    margin-left: unset\n    margin-right: 5rem\n\n  .gallery-partial-container-collage-button\n    width: 18.75rem\n    height: 2.5rem\n\n  .gallery-partial-container-collage-button-text\n    font-size: 1.25rem\n    line-height: 1.75rem\n\n  .gallery-container-controls-subtitle\n    font-size: 1.25rem\n    line-height: 1.75rem\n\n  .gallery-container-full-controls\n    width: 17.375rem\n\n  .gallery-controls-button\n    height: 2.5rem\n\n  .gallery-controls-button-text\n    font-size: 1.25rem\n    line-height: 1.75rem\n  \n  .gallery-container-controls-button\n    width: 3rem\n    height: 3rem\n    img\n      width: 1.5rem\n      height: 1.5rem\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
